/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './po-new.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/flex-layout/flexbox/api/layout';
import * as i3 from '@angular/flex-layout/media-query/media-monitor';
import * as i4 from '@angular/flex-layout/flexbox/api/layout-gap';
import * as i5 from '@angular/flex-layout/flexbox/api/class';
import * as i6 from '../../../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as i7 from '@angular/material';
import * as i8 from '../../../../../../$$_gendir/node_modules/@covalent/core/steps/steps.component.ngfactory';
import * as i9 from '@covalent/core/steps/steps.component';
import * as i10 from '../../../../../../$$_gendir/node_modules/@covalent/core/steps/step.component.ngfactory';
import * as i11 from '@covalent/core/steps/step.component';
import * as i12 from '@angular/forms';
import * as i13 from '@angular/flex-layout/flexbox/api/flex';
import * as i14 from '@angular/flex-layout/flexbox/api/layout-wrap';
import * as i15 from '@angular/common';
import * as i16 from '@angular/router';
import * as i17 from '@angular/platform-browser';
import * as i18 from '../../../../../../$$_gendir/node_modules/@covalent/core/data-table/data-table-column/data-table-column.component.ngfactory';
import * as i19 from '@covalent/core/data-table/data-table-column/data-table-column.component';
import * as i20 from '../../../../../../$$_gendir/node_modules/@covalent/core/data-table/data-table-row/data-table-row.component.ngfactory';
import * as i21 from '@covalent/core/data-table/data-table-row/data-table-row.component';
import * as i22 from '../../../../../../$$_gendir/node_modules/@covalent/core/data-table/data-table-cell/data-table-cell.component.ngfactory';
import * as i23 from '@covalent/core/data-table/data-table-cell/data-table-cell.component';
import * as i24 from '../../../../../../$$_gendir/node_modules/@covalent/core/data-table/data-table-table/data-table-table.component.ngfactory';
import * as i25 from '@covalent/core/data-table/data-table-table/data-table-table.component';
import * as i26 from '../../../../../../$$_gendir/node_modules/@covalent/core/paging/paging-bar.component.ngfactory';
import * as i27 from '@covalent/core/paging/paging-bar.component';
import * as i28 from '@angular/flex-layout/flexbox/api/flex-align';
import * as i29 from '../../../../../../app/shared/pipes/translate.pipe';
import * as i30 from '@covalent/core/loading/directives/loading.directive';
import * as i31 from '@covalent/core/loading/services/loading.service';
import * as i32 from '../../../../../../app/agatextscreens/purchasing/pos/po-new/po-new.component';
import * as i33 from '../../../../../../app/shared/services/collection.service';
import * as i34 from '@angular/http';
import * as i35 from '../../../../../../app/app.constants';
import * as i36 from '../../../../../../app/shared/services/authentication.service';
import * as i37 from '../../../../../../app/shared/services/currency.service';
import * as i38 from '../../../../../../app/shared/services/report.service';
import * as i39 from '../../../../../../app/agatextscreens/purchasing/pos/po.service';
import * as i40 from '@covalent/core/dialogs/services/dialog.service';
import * as i41 from '../../../../../../app/agatextscreens/receiving/receiving.service';
import * as i42 from '../../../../../../app/agatextscreens/accounting/branches/branch.service';
import * as i43 from '../../../../../../app/shared/services/settings.service';
import * as i44 from '../../../../../../app/agatextscreens/purchasing/suppliers/supplier.service';
import * as i45 from '@covalent/core/data-table/services/data-table.service';
const styles_PoNewComponent:any[] = [i0.styles];
export const RenderType_PoNewComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_PoNewComponent,data:{}});
function View_PoNewComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),12,'div',[['class',
      'padded-container unsaved-changes'],['fxLayout','row'],['fxLayoutGap','30px']],
      (null as any),(null as any),(null as any),(null as any),(null as any))),i1.ɵdid(737280,
      (null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2],
      {layout:[0,'layout']},(null as any)),i1.ɵdid(1720320,(null as any),0,i4.LayoutGapDirective,
      [i3.MediaMonitor,i1.ElementRef,i1.Renderer2,[2,i2.LayoutDirective]],{gap:[0,
          'gap']},(null as any)),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,
      [i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
          i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
      ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'md-icon',[['role',
      'img']],[[2,'mat-icon',(null as any)]],(null as any),(null as any),i6.View_MdIcon_0,
      i6.RenderType_MdIcon)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,
      i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(9027584,(null as any),0,i7.MdIcon,[i1.ElementRef,i1.Renderer2,i7.MdIconRegistry],
          (null as any),(null as any)),(_l()(),i1.ɵted(0,['warning'])),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'span',
          ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['You have unsaved changes'])),(_l()(),i1.ɵted((null as any),
          ['\n    ']))],(_ck,_v) => {
    const currVal_0:any = 'row';
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = '30px';
    _ck(_v,2,0,currVal_1);
    const currVal_2:any = 'padded-container unsaved-changes';
    _ck(_v,3,0,currVal_2);
    _ck(_v,7,0);
  },(_ck,_v) => {
    const currVal_3:any = true;
    _ck(_v,5,0,currVal_3);
  });
}
function View_PoNewComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),31,'td-steps',[['mode',
      'horizontal']],(null as any),(null as any),(null as any),i8.View_TdStepsComponent_0,
      i8.RenderType_TdStepsComponent)),i1.ɵdid(1228800,(null as any),1,i9.TdStepsComponent,
      ([] as any[]),{mode:[0,'mode']},(null as any)),i1.ɵqud(603979776,1,{stepsContent:1}),
      (_l()(),i1.ɵted((null as any),['\n                '])),(_l()(),i1.ɵeld(16777216,
          (null as any),(null as any),5,'td-step',[['disabled','true'],['label','DRAFT'],
              ['sublabel','To be completed']],(null as any),(null as any),(null as any),
          i10.View_TdStepComponent_0,i10.RenderType_TdStepComponent)),i1.ɵdid(114688,
          [[1,4]],3,i11.TdStepComponent,[i1.ViewContainerRef],{label:[0,'label'],sublabel:[1,
              'sublabel'],active:[2,'active'],disabled:[3,'disabled'],state:[4,'state']},
          (null as any)),i1.ɵqud(335544320,2,{stepLabel:0}),i1.ɵqud(335544320,3,{stepActions:0}),
      i1.ɵqud(335544320,4,{stepSummary:0}),(_l()(),i1.ɵted(0,['NEXT: Move to ORDERED status'])),
      (_l()(),i1.ɵted((null as any),['\n                '])),(_l()(),i1.ɵeld(16777216,
          (null as any),(null as any),5,'td-step',[['disabled','true'],['label','ORDERED'],
              ['sublabel','Submit Order to supplier']],(null as any),(null as any),
          (null as any),i10.View_TdStepComponent_0,i10.RenderType_TdStepComponent)),
      i1.ɵdid(114688,[[1,4]],3,i11.TdStepComponent,[i1.ViewContainerRef],{label:[0,
          'label'],sublabel:[1,'sublabel'],active:[2,'active'],disabled:[3,'disabled'],
          state:[4,'state']},(null as any)),i1.ɵqud(335544320,5,{stepLabel:0}),i1.ɵqud(335544320,
          6,{stepActions:0}),i1.ɵqud(335544320,7,{stepSummary:0}),(_l()(),i1.ɵted(0,
          ['NEXT: Scan pieces in PDA module'])),(_l()(),i1.ɵted((null as any),['\n                '])),
      (_l()(),i1.ɵeld(16777216,(null as any),(null as any),5,'td-step',[['disabled',
          'true'],['label','PACKING LIST'],['sublabel','Upload packing list in Receiving']],
          (null as any),(null as any),(null as any),i10.View_TdStepComponent_0,i10.RenderType_TdStepComponent)),
      i1.ɵdid(114688,[[1,4]],3,i11.TdStepComponent,[i1.ViewContainerRef],{label:[0,
          'label'],sublabel:[1,'sublabel'],active:[2,'active'],disabled:[3,'disabled'],
          state:[4,'state']},(null as any)),i1.ɵqud(335544320,8,{stepLabel:0}),i1.ɵqud(335544320,
          9,{stepActions:0}),i1.ɵqud(335544320,10,{stepSummary:0}),(_l()(),i1.ɵted(0,
          ['The order is part of inventory'])),(_l()(),i1.ɵted((null as any),['\n                '])),
      (_l()(),i1.ɵeld(16777216,(null as any),(null as any),5,'td-step',[['disabled',
          'true'],['label','RECEIVED'],['sublabel','Scan pieces in PDA module']],(null as any),
          (null as any),(null as any),i10.View_TdStepComponent_0,i10.RenderType_TdStepComponent)),
      i1.ɵdid(114688,[[1,4]],3,i11.TdStepComponent,[i1.ViewContainerRef],{label:[0,
          'label'],sublabel:[1,'sublabel'],active:[2,'active'],disabled:[3,'disabled'],
          state:[4,'state']},(null as any)),i1.ɵqud(335544320,11,{stepLabel:0}),i1.ɵqud(335544320,
          12,{stepActions:0}),i1.ɵqud(335544320,13,{stepSummary:0}),(_l()(),i1.ɵted(0,
          ['The order is part of inventory'])),(_l()(),i1.ɵted((null as any),['\n            ']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = 'horizontal';
        _ck(_v,1,0,currVal_0);
        const currVal_1:any = 'DRAFT';
        const currVal_2:any = 'To be completed';
        const currVal_3:any = true;
        const currVal_4:any = 'true';
        const currVal_5:any = (_co.isDraft()? 'complete': 'none');
        _ck(_v,5,0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5);
        const currVal_6:any = 'ORDERED';
        const currVal_7:any = 'Submit Order to supplier';
        const currVal_8:any = true;
        const currVal_9:any = 'true';
        const currVal_10:any = (_co.isOrdered()? 'complete': 'none');
        _ck(_v,12,0,currVal_6,currVal_7,currVal_8,currVal_9,currVal_10);
        const currVal_11:any = 'PACKING LIST';
        const currVal_12:any = 'Upload packing list in Receiving';
        const currVal_13:any = true;
        const currVal_14:any = 'true';
        const currVal_15:any = (_co.isPackingList()? 'complete': 'none');
        _ck(_v,19,0,currVal_11,currVal_12,currVal_13,currVal_14,currVal_15);
        const currVal_16:any = 'RECEIVED';
        const currVal_17:any = 'Scan pieces in PDA module';
        const currVal_18:any = true;
        const currVal_19:any = 'true';
        const currVal_20:any = (_co.isReceived()? 'complete': 'none');
        _ck(_v,26,0,currVal_16,currVal_17,currVal_18,currVal_19,currVal_20);
      },(null as any));
}
function View_PoNewComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),15,'td-steps',[['mode',
      'horizontal']],(null as any),(null as any),(null as any),i8.View_TdStepsComponent_0,
      i8.RenderType_TdStepsComponent)),i1.ɵdid(1228800,(null as any),1,i9.TdStepsComponent,
      ([] as any[]),{mode:[0,'mode']},(null as any)),i1.ɵqud(603979776,14,{stepsContent:1}),
      (_l()(),i1.ɵted((null as any),['\n                '])),(_l()(),i1.ɵeld(16777216,
          (null as any),(null as any),4,'td-step',[['disabled','true'],['label','DRAFT'],
              ['state','complete'],['sublabel','To be completed']],(null as any),(null as any),
          (null as any),i10.View_TdStepComponent_0,i10.RenderType_TdStepComponent)),
      i1.ɵdid(114688,[[14,4]],3,i11.TdStepComponent,[i1.ViewContainerRef],{label:[0,
          'label'],sublabel:[1,'sublabel'],active:[2,'active'],disabled:[3,'disabled'],
          state:[4,'state']},(null as any)),i1.ɵqud(335544320,15,{stepLabel:0}),i1.ɵqud(335544320,
          16,{stepActions:0}),i1.ɵqud(335544320,17,{stepSummary:0}),(_l()(),i1.ɵted((null as any),
          ['\n                '])),(_l()(),i1.ɵeld(16777216,(null as any),(null as any),
          4,'td-step',[['disabled','true'],['label','CANCELLED'],['state','complete'],
              ['sublabel','The order is cancelled']],(null as any),(null as any),(null as any),
          i10.View_TdStepComponent_0,i10.RenderType_TdStepComponent)),i1.ɵdid(114688,
          [[14,4]],3,i11.TdStepComponent,[i1.ViewContainerRef],{label:[0,'label'],
              sublabel:[1,'sublabel'],active:[2,'active'],disabled:[3,'disabled'],
              state:[4,'state']},(null as any)),i1.ɵqud(335544320,18,{stepLabel:0}),
      i1.ɵqud(335544320,19,{stepActions:0}),i1.ɵqud(335544320,20,{stepSummary:0}),
      (_l()(),i1.ɵted((null as any),['\n            ']))],(_ck,_v) => {
    const currVal_0:any = 'horizontal';
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = 'DRAFT';
    const currVal_2:any = 'To be completed';
    const currVal_3:any = true;
    const currVal_4:any = 'true';
    const currVal_5:any = 'complete';
    _ck(_v,5,0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5);
    const currVal_6:any = 'CANCELLED';
    const currVal_7:any = 'The order is cancelled';
    const currVal_8:any = true;
    const currVal_9:any = 'true';
    const currVal_10:any = 'complete';
    _ck(_v,11,0,currVal_6,currVal_7,currVal_8,currVal_9,currVal_10);
  },(null as any));
}
function View_PoNewComponent_6(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'md-option',[['role',
      'option']],[[1,'tabindex',0],[2,'mat-selected',(null as any)],[2,'mat-option-multiple',
      (null as any)],[2,'mat-active',(null as any)],[8,'id',0],[1,'aria-selected',
      0],[1,'aria-disabled',0],[2,'mat-option-disabled',(null as any)],[2,'mat-option',
      (null as any)]],[[(null as any),'click'],[(null as any),'keydown']],(_v,en,$event) => {
    var ad:boolean = true;
    if (('click' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,2)._selectViaInteraction()) !== false);
      ad = (pd_0 && ad);
    }
    if (('keydown' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,2)._handleKeydown($event)) !== false);
      ad = (pd_1 && ad);
    }
    return ad;
  },i6.View_MdOption_0,i6.RenderType_MdOption)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(49152,[[21,4]],0,i7.MdOption,[i1.ElementRef,[2,i7.MATERIAL_COMPATIBILITY_MODE]],
          {value:[0,'value']},(null as any)),(_l()(),i1.ɵted(0,['',' - ','']))],(_ck,
      _v) => {
    const currVal_9:any = _v.context.$implicit.id;
    _ck(_v,2,0,currVal_9);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,2)._getTabIndex();
    const currVal_1:any = i1.ɵnov(_v,2).selected;
    const currVal_2:any = i1.ɵnov(_v,2).multiple;
    const currVal_3:any = i1.ɵnov(_v,2).active;
    const currVal_4:any = i1.ɵnov(_v,2).id;
    const currVal_5:any = i1.ɵnov(_v,2).selected.toString();
    const currVal_6:any = i1.ɵnov(_v,2).disabled.toString();
    const currVal_7:any = i1.ɵnov(_v,2).disabled;
    const currVal_8:any = true;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8);
    const currVal_10:any = _v.context.$implicit.code;
    const currVal_11:any = _v.context.$implicit.name;
    _ck(_v,3,0,currVal_10,currVal_11);
  });
}
function View_PoNewComponent_7(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'md-option',[['role',
      'option']],[[1,'tabindex',0],[2,'mat-selected',(null as any)],[2,'mat-option-multiple',
      (null as any)],[2,'mat-active',(null as any)],[8,'id',0],[1,'aria-selected',
      0],[1,'aria-disabled',0],[2,'mat-option-disabled',(null as any)],[2,'mat-option',
      (null as any)]],[[(null as any),'click'],[(null as any),'keydown']],(_v,en,$event) => {
    var ad:boolean = true;
    if (('click' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,2)._selectViaInteraction()) !== false);
      ad = (pd_0 && ad);
    }
    if (('keydown' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,2)._handleKeydown($event)) !== false);
      ad = (pd_1 && ad);
    }
    return ad;
  },i6.View_MdOption_0,i6.RenderType_MdOption)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(49152,[[22,4]],0,i7.MdOption,[i1.ElementRef,[2,i7.MATERIAL_COMPATIBILITY_MODE]],
          {value:[0,'value']},(null as any)),(_l()(),i1.ɵted(0,['','/','']))],(_ck,
      _v) => {
    const currVal_9:any = _v.context.$implicit.id;
    _ck(_v,2,0,currVal_9);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,2)._getTabIndex();
    const currVal_1:any = i1.ɵnov(_v,2).selected;
    const currVal_2:any = i1.ɵnov(_v,2).multiple;
    const currVal_3:any = i1.ɵnov(_v,2).active;
    const currVal_4:any = i1.ɵnov(_v,2).id;
    const currVal_5:any = i1.ɵnov(_v,2).selected.toString();
    const currVal_6:any = i1.ɵnov(_v,2).disabled.toString();
    const currVal_7:any = i1.ɵnov(_v,2).disabled;
    const currVal_8:any = true;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8);
    const currVal_10:any = _v.context.$implicit.code;
    const currVal_11:any = _v.context.$implicit.name;
    _ck(_v,3,0,currVal_10,currVal_11);
  });
}
function View_PoNewComponent_8(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'md-option',[['role',
      'option']],[[1,'tabindex',0],[2,'mat-selected',(null as any)],[2,'mat-option-multiple',
      (null as any)],[2,'mat-active',(null as any)],[8,'id',0],[1,'aria-selected',
      0],[1,'aria-disabled',0],[2,'mat-option-disabled',(null as any)],[2,'mat-option',
      (null as any)]],[[(null as any),'click'],[(null as any),'keydown']],(_v,en,$event) => {
    var ad:boolean = true;
    if (('click' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,2)._selectViaInteraction()) !== false);
      ad = (pd_0 && ad);
    }
    if (('keydown' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,2)._handleKeydown($event)) !== false);
      ad = (pd_1 && ad);
    }
    return ad;
  },i6.View_MdOption_0,i6.RenderType_MdOption)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(49152,[[47,4]],0,i7.MdOption,[i1.ElementRef,[2,i7.MATERIAL_COMPATIBILITY_MODE]],
          {value:[0,'value']},(null as any)),(_l()(),i1.ɵted(0,['','']))],(_ck,_v) => {
    const currVal_9:any = _v.context.$implicit;
    _ck(_v,2,0,currVal_9);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,2)._getTabIndex();
    const currVal_1:any = i1.ɵnov(_v,2).selected;
    const currVal_2:any = i1.ɵnov(_v,2).multiple;
    const currVal_3:any = i1.ɵnov(_v,2).active;
    const currVal_4:any = i1.ɵnov(_v,2).id;
    const currVal_5:any = i1.ɵnov(_v,2).selected.toString();
    const currVal_6:any = i1.ɵnov(_v,2).disabled.toString();
    const currVal_7:any = i1.ɵnov(_v,2).disabled;
    const currVal_8:any = true;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8);
    const currVal_10:any = _v.context.$implicit;
    _ck(_v,3,0,currVal_10);
  });
}
function View_PoNewComponent_5(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),141,'md-card-content',
      [['fxLayout','column']],[[2,'mat-card-content',(null as any)]],(null as any),
      (null as any),(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(16384,(null as any),0,i7.MdCardContent,([] as any[]),(null as any),(null as any)),
      i1.ɵdid(737280,(null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2],{layout:[0,'layout']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n                '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),75,
          'div',[['class','padded-container'],['fxLayout','row'],['fxLayout.lt-md',
              'column'],['fxLayoutGap','30px'],['fxLayoutGap.lt-md','14px']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(737280,
          (null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2],
          {layout:[0,'layout'],layoutLtMd:[1,'layoutLtMd']},(null as any)),i1.ɵdid(1720320,
          (null as any),0,i4.LayoutGapDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2,
              [2,i2.LayoutDirective]],{gap:[0,'gap'],gapLtMd:[1,'gapLtMd']},(null as any)),
      i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),['\n                    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),13,'md-select',[['fxFlex','22%'],
          ['name','branch'],['role','listbox']],[[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)],[1,'tabindex',0],[1,'aria-label',0],[1,'aria-labelledby',
              0],[1,'aria-required',0],[1,'aria-disabled',0],[1,'aria-invalid',0],
          [1,'aria-owns',0],[2,'mat-select-disabled',(null as any)],[2,'mat-select',
              (null as any)]],[[(null as any),'ngModelChange'],[(null as any),'keydown'],
          [(null as any),'blur']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('keydown' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,15)._handleClosedKeydown($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,15)._onBlur()) !== false);
          ad = (pd_1 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_2:any = ((<any>(_co.currentPo.requesting_branch_id = $event)) !== false);
          ad = (pd_2 && ad);
        }
        if (('ngModelChange' === en)) {
          _co.branchChanged($event);
          const pd_3:any = ((<any>_co.loadSuppliers($event)) !== false);
          ad = (pd_3 && ad);
        }
        return ad;
      },i6.View_MdSelect_0,i6.RenderType_MdSelect)),i1.ɵdid(671744,(null as any),0,
          i12.NgModel,[[8,(null as any)],[8,(null as any)],[8,(null as any)],[8,(null as any)]],
          {name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,
          (null as any),i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),
          0,i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          (null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
              i1.ElementRef],(null as any),(null as any)),i1.ɵdid(1294336,(null as any),
          1,i7.MdSelect,[i1.ElementRef,i1.Renderer2,i7.ViewportRuler,i1.ChangeDetectorRef,
              [2,i7.Dir],[2,i12.NgControl],[8,(null as any)]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵqud(603979776,21,{options:1}),i1.ɵppd(2),i1.ɵdid(737280,
          (null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2,
              [3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,'flex']},
          (null as any)),(_l()(),i1.ɵted(0,['\n                        '])),(_l()(),
          i1.ɵand(16777216,(null as any),0,2,(null as any),View_PoNewComponent_6)),
      i1.ɵdid(802816,(null as any),0,i15.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),i1.ɵpid(131072,
          i15.AsyncPipe,[i1.ChangeDetectorRef]),(_l()(),i1.ɵted(0,['\n                    '])),
      (_l()(),i1.ɵted((null as any),['\n\n                    '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),14,'md-select',[['fxFlex','22%'],['name','supplierPrefix'],
              ['role','listbox']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',
              (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
              [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
                  (null as any)],[1,'tabindex',0],[1,'aria-label',0],[1,'aria-labelledby',
                  0],[1,'aria-required',0],[1,'aria-disabled',0],[1,'aria-invalid',
                  0],[1,'aria-owns',0],[2,'mat-select-disabled',(null as any)],[2,
                  'mat-select',(null as any)]],[[(null as any),'ngModelChange'],[(null as any),
              'keydown'],[(null as any),'blur']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('keydown' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,30)._handleClosedKeydown($event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,30)._onBlur()) !== false);
              ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_2:any = ((<any>(_co.currentPo.supplier_id = $event)) !== false);
              ad = (pd_2 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_3:any = ((<any>_co.changedSupplier($event)) !== false);
              ad = (pd_3 && ad);
            }
            return ad;
          },i6.View_MdSelect_0,i6.RenderType_MdSelect)),i1.ɵdid(671744,(null as any),
          0,i12.NgModel,[[8,(null as any)],[8,(null as any)],[8,(null as any)],[8,
              (null as any)]],{name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),
      i1.ɵprd(2048,(null as any),i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,
          (null as any),0,i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),
      i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(1294336,(null as any),
          1,i7.MdSelect,[i1.ElementRef,i1.Renderer2,i7.ViewportRuler,i1.ChangeDetectorRef,
              [2,i7.Dir],[2,i12.NgControl],[8,(null as any)]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵqud(603979776,22,{options:1}),i1.ɵppd(2),i1.ɵppd(2),i1.ɵdid(737280,
          (null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2,
              [3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,'flex']},
          (null as any)),(_l()(),i1.ɵted(0,['\n                        '])),(_l()(),
          i1.ɵand(16777216,(null as any),0,2,(null as any),View_PoNewComponent_7)),
      i1.ɵdid(802816,(null as any),0,i15.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),i1.ɵpid(131072,
          i15.AsyncPipe,[i1.ChangeDetectorRef]),(_l()(),i1.ɵted(0,['\n                    '])),
      (_l()(),i1.ɵted((null as any),['\n\n                    '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),18,'md-input-container',[['fxFlex','22%']],[[1,
              'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,42)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,23,{_mdInputChild:0}),i1.ɵqud(335544320,24,{_placeholderChild:0}),
      i1.ɵqud(603979776,25,{_errorChildren:1}),i1.ɵqud(603979776,26,{_hintChildren:1}),
      i1.ɵqud(603979776,27,{_prefixChildren:1}),i1.ɵqud(603979776,28,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput',''],['type','date']],
          [[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
              (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
              [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
                  (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,
                  'required',0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],
              [(null as any),'input'],[(null as any),'blur'],[(null as any),'compositionstart'],
              [(null as any),'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,52)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,52).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,52)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,52)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,57)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,57)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,57)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.currentPo.order_date = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[23,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],
          {placeholder:[0,'placeholder'],type:[1,'type']},(null as any)),i1.ɵppd(2),
      (_l()(),i1.ɵted(1,['\n                    '])),(_l()(),i1.ɵted((null as any),
          ['\n\n                    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          18,'md-input-container',[['fxFlex','22%']],[[1,'align',0],[2,'mat-input-container',
              (null as any)],[2,'mat-input-invalid',(null as any)],[2,'mat-focused',
              (null as any)],[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
              [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
                  (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],
          [[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,62)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,29,{_mdInputChild:0}),i1.ɵqud(335544320,30,{_placeholderChild:0}),
      i1.ɵqud(603979776,31,{_errorChildren:1}),i1.ɵqud(603979776,32,{_hintChildren:1}),
      i1.ɵqud(603979776,33,{_prefixChildren:1}),i1.ɵqud(603979776,34,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput',''],['readonly','']],
          [[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
              (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
              [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
                  (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,
                  'required',0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],
              [(null as any),'input'],[(null as any),'blur'],[(null as any),'compositionstart'],
              [(null as any),'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,72)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,72).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,72)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,72)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,77)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,77)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,77)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.currentPo.supplier_order_ref = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[29,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],
          {placeholder:[0,'placeholder']},(null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,
          ['\n                    '])),(_l()(),i1.ɵted((null as any),['\n                '])),
      (_l()(),i1.ɵted((null as any),['\n                '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),58,'div',[['class','padded-container'],['fxLayout','row'],
              ['fxLayout.lt-md','column'],['fxLayoutGap','30px'],['fxLayoutGap.lt-md',
                  '14px']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),i1.ɵdid(737280,(null as any),0,i2.LayoutDirective,[i3.MediaMonitor,
          i1.ElementRef,i1.Renderer2],{layout:[0,'layout'],layoutLtMd:[1,'layoutLtMd']},
          (null as any)),i1.ɵdid(1720320,(null as any),0,i4.LayoutGapDirective,[i3.MediaMonitor,
          i1.ElementRef,i1.Renderer2,[2,i2.LayoutDirective]],{gap:[0,'gap'],gapLtMd:[1,
          'gapLtMd']},(null as any)),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,
          [i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
              i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n                    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          18,'md-input-container',[['fxFlex','22%']],[[1,'align',0],[2,'mat-input-container',
              (null as any)],[2,'mat-input-invalid',(null as any)],[2,'mat-focused',
              (null as any)],[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
              [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
                  (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],
          [[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,88)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,35,{_mdInputChild:0}),i1.ɵqud(335544320,36,{_placeholderChild:0}),
      i1.ɵqud(603979776,37,{_errorChildren:1}),i1.ɵqud(603979776,38,{_hintChildren:1}),
      i1.ɵqud(603979776,39,{_prefixChildren:1}),i1.ɵqud(603979776,40,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput',''],['type','date']],
          [[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
              (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
              [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
                  (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,
                  'required',0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],
              [(null as any),'input'],[(null as any),'blur'],[(null as any),'compositionstart'],
              [(null as any),'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,98)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,98).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,98)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,98)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,103)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,103)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,103)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.currentPo.estimated_arrival_date = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[35,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],
          {placeholder:[0,'placeholder'],type:[1,'type']},(null as any)),i1.ɵppd(2),
      (_l()(),i1.ɵted(1,['\n                    '])),(_l()(),i1.ɵted((null as any),
          ['\n\n                    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          18,'md-input-container',[['fxFlex','47%']],[[1,'align',0],[2,'mat-input-container',
              (null as any)],[2,'mat-input-invalid',(null as any)],[2,'mat-focused',
              (null as any)],[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
              [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
                  (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],
          [[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,108)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,41,{_mdInputChild:0}),i1.ɵqud(335544320,42,{_placeholderChild:0}),
      i1.ɵqud(603979776,43,{_errorChildren:1}),i1.ɵqud(603979776,44,{_hintChildren:1}),
      i1.ɵqud(603979776,45,{_prefixChildren:1}),i1.ɵqud(603979776,46,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
              (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
              0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
          'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
          'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,118)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,118).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,118)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,118)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('blur' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,123)._onBlur()) !== false);
          ad = (pd_4 && ad);
        }
        if (('focus' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,123)._onFocus()) !== false);
          ad = (pd_5 && ad);
        }
        if (('input' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,123)._onInput()) !== false);
          ad = (pd_6 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_7:any = ((<any>(_co.currentPo.ship_to = $event)) !== false);
          ad = (pd_7 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[41,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],
          {placeholder:[0,'placeholder']},(null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,
          ['\n                    '])),(_l()(),i1.ɵted((null as any),['\n\n                    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),12,'md-select',[['fxFlex','22%'],
          ['name','status'],['role','listbox']],[[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)],[1,'tabindex',0],[1,'aria-label',0],[1,'aria-labelledby',
              0],[1,'aria-required',0],[1,'aria-disabled',0],[1,'aria-invalid',0],
          [1,'aria-owns',0],[2,'mat-select-disabled',(null as any)],[2,'mat-select',
              (null as any)]],[[(null as any),'ngModelChange'],[(null as any),'keydown'],
          [(null as any),'blur']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('keydown' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,132)._handleClosedKeydown($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,132)._onBlur()) !== false);
          ad = (pd_1 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_2:any = ((<any>(_co.currentPo.status = $event)) !== false);
          ad = (pd_2 && ad);
        }
        return ad;
      },i6.View_MdSelect_0,i6.RenderType_MdSelect)),i1.ɵdid(671744,(null as any),0,
          i12.NgModel,[[8,(null as any)],[8,(null as any)],[8,(null as any)],[8,(null as any)]],
          {name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,
          (null as any),i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),
          0,i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          (null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
              i1.ElementRef],(null as any),(null as any)),i1.ɵdid(1294336,(null as any),
          1,i7.MdSelect,[i1.ElementRef,i1.Renderer2,i7.ViewportRuler,i1.ChangeDetectorRef,
              [2,i7.Dir],[2,i12.NgControl],[8,(null as any)]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵqud(603979776,47,{options:1}),i1.ɵppd(2),i1.ɵdid(737280,
          (null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2,
              [3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,'flex']},
          (null as any)),(_l()(),i1.ɵted(0,['\n                        '])),(_l()(),
          i1.ɵand(16777216,(null as any),0,1,(null as any),View_PoNewComponent_8)),
      i1.ɵdid(802816,(null as any),0,i15.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(0,
          ['\n                    '])),(_l()(),i1.ɵted((null as any),['\n                '])),
      (_l()(),i1.ɵted((null as any),['\n            ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = 'column';
    _ck(_v,3,0,currVal_1);
    const currVal_2:any = 'row';
    const currVal_3:any = 'column';
    _ck(_v,6,0,currVal_2,currVal_3);
    const currVal_4:any = '30px';
    const currVal_5:any = '14px';
    _ck(_v,7,0,currVal_4,currVal_5);
    const currVal_6:any = 'padded-container';
    _ck(_v,8,0,currVal_6);
    const currVal_23:any = 'branch';
    const currVal_24:any = _co.currentPo.requesting_branch_id;
    _ck(_v,11,0,currVal_23,currVal_24);
    const currVal_25:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,15,0,_ck(_v,17,0,
        i1.ɵnov((<any>(<any>_v.parent).parent),0),'branch',_co._authService.getLanguage())),
        '');
    _ck(_v,15,0,currVal_25);
    const currVal_26:any = '22%';
    _ck(_v,18,0,currVal_26);
    const currVal_27:any = i1.ɵunv(_v,21,0,i1.ɵnov(_v,22).transform(_co.allBranches$));
    _ck(_v,21,0,currVal_27);
    const currVal_44:any = 'supplierPrefix';
    const currVal_45:any = _co.currentPo.supplier_id;
    _ck(_v,26,0,currVal_44,currVal_45);
    const currVal_46:any = i1.ɵinlineInterpolate(2,'',i1.ɵunv(_v,30,0,_ck(_v,32,0,
        i1.ɵnov((<any>(<any>_v.parent).parent),0),'supplier',_co._authService.getLanguage())),
        ' / ',i1.ɵunv(_v,30,0,_ck(_v,33,0,i1.ɵnov((<any>(<any>_v.parent).parent),0),
            'prefix',_co._authService.getLanguage())),'');
    _ck(_v,30,0,currVal_46);
    const currVal_47:any = '22%';
    _ck(_v,34,0,currVal_47);
    const currVal_48:any = i1.ɵunv(_v,37,0,i1.ɵnov(_v,38).transform(_co.allSupplierPrefixes$));
    _ck(_v,37,0,currVal_48);
    const currVal_60:any = '22%';
    _ck(_v,49,0,currVal_60);
    const currVal_74:any = _co.currentPo.order_date;
    _ck(_v,54,0,currVal_74);
    const currVal_75:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,57,0,_ck(_v,58,0,
        i1.ɵnov((<any>(<any>_v.parent).parent),0),'order_date',_co._authService.getLanguage())),
        '');
    const currVal_76:any = 'date';
    _ck(_v,57,0,currVal_75,currVal_76);
    const currVal_88:any = '22%';
    _ck(_v,69,0,currVal_88);
    const currVal_102:any = _co.currentPo.supplier_order_ref;
    _ck(_v,74,0,currVal_102);
    const currVal_103:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,77,0,_ck(_v,78,0,
        i1.ɵnov((<any>(<any>_v.parent).parent),0),'supplier_order_ref',_co._authService.getLanguage())),
        '');
    _ck(_v,77,0,currVal_103);
    const currVal_104:any = 'row';
    const currVal_105:any = 'column';
    _ck(_v,83,0,currVal_104,currVal_105);
    const currVal_106:any = '30px';
    const currVal_107:any = '14px';
    _ck(_v,84,0,currVal_106,currVal_107);
    const currVal_108:any = 'padded-container';
    _ck(_v,85,0,currVal_108);
    const currVal_120:any = '22%';
    _ck(_v,95,0,currVal_120);
    const currVal_134:any = _co.currentPo.estimated_arrival_date;
    _ck(_v,100,0,currVal_134);
    const currVal_135:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,103,0,_ck(_v,104,
        0,i1.ɵnov((<any>(<any>_v.parent).parent),0),'estimate_arrival_date',_co._authService.getLanguage())),
        '');
    const currVal_136:any = 'date';
    _ck(_v,103,0,currVal_135,currVal_136);
    const currVal_148:any = '47%';
    _ck(_v,115,0,currVal_148);
    const currVal_162:any = _co.currentPo.ship_to;
    _ck(_v,120,0,currVal_162);
    const currVal_163:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,123,0,_ck(_v,124,
        0,i1.ɵnov((<any>(<any>_v.parent).parent),0),'ship_to',_co._authService.getLanguage())),
        '');
    _ck(_v,123,0,currVal_163);
    const currVal_180:any = 'status';
    const currVal_181:any = _co.currentPo.status;
    _ck(_v,128,0,currVal_180,currVal_181);
    const currVal_182:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,132,0,_ck(_v,134,
        0,i1.ɵnov((<any>(<any>_v.parent).parent),0),'status',_co._authService.getLanguage())),
        '');
    _ck(_v,132,0,currVal_182);
    const currVal_183:any = '22%';
    _ck(_v,135,0,currVal_183);
    const currVal_184:any = _co.allStatuses;
    _ck(_v,138,0,currVal_184);
  },(_ck,_v) => {
    const currVal_0:any = true;
    _ck(_v,0,0,currVal_0);
    const currVal_7:any = i1.ɵnov(_v,13).ngClassUntouched;
    const currVal_8:any = i1.ɵnov(_v,13).ngClassTouched;
    const currVal_9:any = i1.ɵnov(_v,13).ngClassPristine;
    const currVal_10:any = i1.ɵnov(_v,13).ngClassDirty;
    const currVal_11:any = i1.ɵnov(_v,13).ngClassValid;
    const currVal_12:any = i1.ɵnov(_v,13).ngClassInvalid;
    const currVal_13:any = i1.ɵnov(_v,13).ngClassPending;
    const currVal_14:any = i1.ɵnov(_v,15).tabIndex;
    const currVal_15:any = i1.ɵnov(_v,15)._ariaLabel;
    const currVal_16:any = i1.ɵnov(_v,15).ariaLabelledby;
    const currVal_17:any = i1.ɵnov(_v,15).required.toString();
    const currVal_18:any = i1.ɵnov(_v,15).disabled.toString();
    const currVal_19:any = (((i1.ɵnov(_v,15)._control == null)? (null as any): i1.ɵnov(_v,
        15)._control.invalid) || 'false');
    const currVal_20:any = i1.ɵnov(_v,15)._optionIds;
    const currVal_21:any = i1.ɵnov(_v,15).disabled;
    const currVal_22:any = true;
    _ck(_v,10,1,[currVal_7,currVal_8,currVal_9,currVal_10,currVal_11,currVal_12,currVal_13,
        currVal_14,currVal_15,currVal_16,currVal_17,currVal_18,currVal_19,currVal_20,
        currVal_21,currVal_22]);
    const currVal_28:any = i1.ɵnov(_v,28).ngClassUntouched;
    const currVal_29:any = i1.ɵnov(_v,28).ngClassTouched;
    const currVal_30:any = i1.ɵnov(_v,28).ngClassPristine;
    const currVal_31:any = i1.ɵnov(_v,28).ngClassDirty;
    const currVal_32:any = i1.ɵnov(_v,28).ngClassValid;
    const currVal_33:any = i1.ɵnov(_v,28).ngClassInvalid;
    const currVal_34:any = i1.ɵnov(_v,28).ngClassPending;
    const currVal_35:any = i1.ɵnov(_v,30).tabIndex;
    const currVal_36:any = i1.ɵnov(_v,30)._ariaLabel;
    const currVal_37:any = i1.ɵnov(_v,30).ariaLabelledby;
    const currVal_38:any = i1.ɵnov(_v,30).required.toString();
    const currVal_39:any = i1.ɵnov(_v,30).disabled.toString();
    const currVal_40:any = (((i1.ɵnov(_v,30)._control == null)? (null as any): i1.ɵnov(_v,
        30)._control.invalid) || 'false');
    const currVal_41:any = i1.ɵnov(_v,30)._optionIds;
    const currVal_42:any = i1.ɵnov(_v,30).disabled;
    const currVal_43:any = true;
    _ck(_v,25,1,[currVal_28,currVal_29,currVal_30,currVal_31,currVal_32,currVal_33,
        currVal_34,currVal_35,currVal_36,currVal_37,currVal_38,currVal_39,currVal_40,
        currVal_41,currVal_42,currVal_43]);
    const currVal_49:any = (null as any);
    const currVal_50:any = true;
    const currVal_51:any = i1.ɵnov(_v,42)._isErrorState();
    const currVal_52:any = i1.ɵnov(_v,42)._mdInputChild.focused;
    const currVal_53:any = i1.ɵnov(_v,42)._shouldForward('untouched');
    const currVal_54:any = i1.ɵnov(_v,42)._shouldForward('touched');
    const currVal_55:any = i1.ɵnov(_v,42)._shouldForward('pristine');
    const currVal_56:any = i1.ɵnov(_v,42)._shouldForward('dirty');
    const currVal_57:any = i1.ɵnov(_v,42)._shouldForward('valid');
    const currVal_58:any = i1.ɵnov(_v,42)._shouldForward('invalid');
    const currVal_59:any = i1.ɵnov(_v,42)._shouldForward('pending');
    _ck(_v,41,1,[currVal_49,currVal_50,currVal_51,currVal_52,currVal_53,currVal_54,
        currVal_55,currVal_56,currVal_57,currVal_58,currVal_59]);
    const currVal_61:any = i1.ɵnov(_v,56).ngClassUntouched;
    const currVal_62:any = i1.ɵnov(_v,56).ngClassTouched;
    const currVal_63:any = i1.ɵnov(_v,56).ngClassPristine;
    const currVal_64:any = i1.ɵnov(_v,56).ngClassDirty;
    const currVal_65:any = i1.ɵnov(_v,56).ngClassValid;
    const currVal_66:any = i1.ɵnov(_v,56).ngClassInvalid;
    const currVal_67:any = i1.ɵnov(_v,56).ngClassPending;
    const currVal_68:any = true;
    const currVal_69:any = i1.ɵnov(_v,57).id;
    const currVal_70:any = i1.ɵnov(_v,57).placeholder;
    const currVal_71:any = i1.ɵnov(_v,57).disabled;
    const currVal_72:any = i1.ɵnov(_v,57).required;
    const currVal_73:any = (i1.ɵnov(_v,57).ariaDescribedby || (null as any));
    _ck(_v,51,1,[currVal_61,currVal_62,currVal_63,currVal_64,currVal_65,currVal_66,
        currVal_67,currVal_68,currVal_69,currVal_70,currVal_71,currVal_72,currVal_73]);
    const currVal_77:any = (null as any);
    const currVal_78:any = true;
    const currVal_79:any = i1.ɵnov(_v,62)._isErrorState();
    const currVal_80:any = i1.ɵnov(_v,62)._mdInputChild.focused;
    const currVal_81:any = i1.ɵnov(_v,62)._shouldForward('untouched');
    const currVal_82:any = i1.ɵnov(_v,62)._shouldForward('touched');
    const currVal_83:any = i1.ɵnov(_v,62)._shouldForward('pristine');
    const currVal_84:any = i1.ɵnov(_v,62)._shouldForward('dirty');
    const currVal_85:any = i1.ɵnov(_v,62)._shouldForward('valid');
    const currVal_86:any = i1.ɵnov(_v,62)._shouldForward('invalid');
    const currVal_87:any = i1.ɵnov(_v,62)._shouldForward('pending');
    _ck(_v,61,1,[currVal_77,currVal_78,currVal_79,currVal_80,currVal_81,currVal_82,
        currVal_83,currVal_84,currVal_85,currVal_86,currVal_87]);
    const currVal_89:any = i1.ɵnov(_v,76).ngClassUntouched;
    const currVal_90:any = i1.ɵnov(_v,76).ngClassTouched;
    const currVal_91:any = i1.ɵnov(_v,76).ngClassPristine;
    const currVal_92:any = i1.ɵnov(_v,76).ngClassDirty;
    const currVal_93:any = i1.ɵnov(_v,76).ngClassValid;
    const currVal_94:any = i1.ɵnov(_v,76).ngClassInvalid;
    const currVal_95:any = i1.ɵnov(_v,76).ngClassPending;
    const currVal_96:any = true;
    const currVal_97:any = i1.ɵnov(_v,77).id;
    const currVal_98:any = i1.ɵnov(_v,77).placeholder;
    const currVal_99:any = i1.ɵnov(_v,77).disabled;
    const currVal_100:any = i1.ɵnov(_v,77).required;
    const currVal_101:any = (i1.ɵnov(_v,77).ariaDescribedby || (null as any));
    _ck(_v,71,1,[currVal_89,currVal_90,currVal_91,currVal_92,currVal_93,currVal_94,
        currVal_95,currVal_96,currVal_97,currVal_98,currVal_99,currVal_100,currVal_101]);
    const currVal_109:any = (null as any);
    const currVal_110:any = true;
    const currVal_111:any = i1.ɵnov(_v,88)._isErrorState();
    const currVal_112:any = i1.ɵnov(_v,88)._mdInputChild.focused;
    const currVal_113:any = i1.ɵnov(_v,88)._shouldForward('untouched');
    const currVal_114:any = i1.ɵnov(_v,88)._shouldForward('touched');
    const currVal_115:any = i1.ɵnov(_v,88)._shouldForward('pristine');
    const currVal_116:any = i1.ɵnov(_v,88)._shouldForward('dirty');
    const currVal_117:any = i1.ɵnov(_v,88)._shouldForward('valid');
    const currVal_118:any = i1.ɵnov(_v,88)._shouldForward('invalid');
    const currVal_119:any = i1.ɵnov(_v,88)._shouldForward('pending');
    _ck(_v,87,1,[currVal_109,currVal_110,currVal_111,currVal_112,currVal_113,currVal_114,
        currVal_115,currVal_116,currVal_117,currVal_118,currVal_119]);
    const currVal_121:any = i1.ɵnov(_v,102).ngClassUntouched;
    const currVal_122:any = i1.ɵnov(_v,102).ngClassTouched;
    const currVal_123:any = i1.ɵnov(_v,102).ngClassPristine;
    const currVal_124:any = i1.ɵnov(_v,102).ngClassDirty;
    const currVal_125:any = i1.ɵnov(_v,102).ngClassValid;
    const currVal_126:any = i1.ɵnov(_v,102).ngClassInvalid;
    const currVal_127:any = i1.ɵnov(_v,102).ngClassPending;
    const currVal_128:any = true;
    const currVal_129:any = i1.ɵnov(_v,103).id;
    const currVal_130:any = i1.ɵnov(_v,103).placeholder;
    const currVal_131:any = i1.ɵnov(_v,103).disabled;
    const currVal_132:any = i1.ɵnov(_v,103).required;
    const currVal_133:any = (i1.ɵnov(_v,103).ariaDescribedby || (null as any));
    _ck(_v,97,1,[currVal_121,currVal_122,currVal_123,currVal_124,currVal_125,currVal_126,
        currVal_127,currVal_128,currVal_129,currVal_130,currVal_131,currVal_132,currVal_133]);
    const currVal_137:any = (null as any);
    const currVal_138:any = true;
    const currVal_139:any = i1.ɵnov(_v,108)._isErrorState();
    const currVal_140:any = i1.ɵnov(_v,108)._mdInputChild.focused;
    const currVal_141:any = i1.ɵnov(_v,108)._shouldForward('untouched');
    const currVal_142:any = i1.ɵnov(_v,108)._shouldForward('touched');
    const currVal_143:any = i1.ɵnov(_v,108)._shouldForward('pristine');
    const currVal_144:any = i1.ɵnov(_v,108)._shouldForward('dirty');
    const currVal_145:any = i1.ɵnov(_v,108)._shouldForward('valid');
    const currVal_146:any = i1.ɵnov(_v,108)._shouldForward('invalid');
    const currVal_147:any = i1.ɵnov(_v,108)._shouldForward('pending');
    _ck(_v,107,1,[currVal_137,currVal_138,currVal_139,currVal_140,currVal_141,currVal_142,
        currVal_143,currVal_144,currVal_145,currVal_146,currVal_147]);
    const currVal_149:any = i1.ɵnov(_v,122).ngClassUntouched;
    const currVal_150:any = i1.ɵnov(_v,122).ngClassTouched;
    const currVal_151:any = i1.ɵnov(_v,122).ngClassPristine;
    const currVal_152:any = i1.ɵnov(_v,122).ngClassDirty;
    const currVal_153:any = i1.ɵnov(_v,122).ngClassValid;
    const currVal_154:any = i1.ɵnov(_v,122).ngClassInvalid;
    const currVal_155:any = i1.ɵnov(_v,122).ngClassPending;
    const currVal_156:any = true;
    const currVal_157:any = i1.ɵnov(_v,123).id;
    const currVal_158:any = i1.ɵnov(_v,123).placeholder;
    const currVal_159:any = i1.ɵnov(_v,123).disabled;
    const currVal_160:any = i1.ɵnov(_v,123).required;
    const currVal_161:any = (i1.ɵnov(_v,123).ariaDescribedby || (null as any));
    _ck(_v,117,1,[currVal_149,currVal_150,currVal_151,currVal_152,currVal_153,currVal_154,
        currVal_155,currVal_156,currVal_157,currVal_158,currVal_159,currVal_160,currVal_161]);
    const currVal_164:any = i1.ɵnov(_v,130).ngClassUntouched;
    const currVal_165:any = i1.ɵnov(_v,130).ngClassTouched;
    const currVal_166:any = i1.ɵnov(_v,130).ngClassPristine;
    const currVal_167:any = i1.ɵnov(_v,130).ngClassDirty;
    const currVal_168:any = i1.ɵnov(_v,130).ngClassValid;
    const currVal_169:any = i1.ɵnov(_v,130).ngClassInvalid;
    const currVal_170:any = i1.ɵnov(_v,130).ngClassPending;
    const currVal_171:any = i1.ɵnov(_v,132).tabIndex;
    const currVal_172:any = i1.ɵnov(_v,132)._ariaLabel;
    const currVal_173:any = i1.ɵnov(_v,132).ariaLabelledby;
    const currVal_174:any = i1.ɵnov(_v,132).required.toString();
    const currVal_175:any = i1.ɵnov(_v,132).disabled.toString();
    const currVal_176:any = (((i1.ɵnov(_v,132)._control == null)? (null as any): i1.ɵnov(_v,
        132)._control.invalid) || 'false');
    const currVal_177:any = i1.ɵnov(_v,132)._optionIds;
    const currVal_178:any = i1.ɵnov(_v,132).disabled;
    const currVal_179:any = true;
    _ck(_v,127,1,[currVal_164,currVal_165,currVal_166,currVal_167,currVal_168,currVal_169,
        currVal_170,currVal_171,currVal_172,currVal_173,currVal_174,currVal_175,currVal_176,
        currVal_177,currVal_178,currVal_179]);
  });
}
function View_PoNewComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),42,'md-card',([] as any[]),
      [[2,'mat-card',(null as any)]],(null as any),(null as any),i6.View_MdCard_0,
      i6.RenderType_MdCard)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,
      i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(49152,(null as any),0,i7.MdCard,([] as any[]),(null as any),(null as any)),
      (_l()(),i1.ɵted(0,['\n            '])),(_l()(),i1.ɵand(16777216,(null as any),
          0,1,(null as any),View_PoNewComponent_3)),i1.ɵdid(16384,(null as any),0,
          i15.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted(0,['\n            '])),(_l()(),i1.ɵand(16777216,(null as any),
          0,1,(null as any),View_PoNewComponent_4)),i1.ɵdid(16384,(null as any),0,
          i15.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted(0,['\n            '])),(_l()(),i1.ɵeld(0,(null as any),0,28,
          'md-card-header',[['fxLayout','column']],[[2,'mat-card-header',(null as any)]],
          (null as any),(null as any),i6.View_MdCardHeader_0,i6.RenderType_MdCardHeader)),
      i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(49152,(null as any),
          0,i7.MdCardHeader,([] as any[]),(null as any),(null as any)),i1.ɵdid(737280,
          (null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2],
          {layout:[0,'layout']},(null as any)),(_l()(),i1.ɵted(2,['\n                '])),
      (_l()(),i1.ɵeld(0,(null as any),1,15,'md-card-title',([] as any[]),[[2,'mat-card-title',
          (null as any)]],(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(16384,(null as any),
          0,i7.MdCardTitle,([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n                    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          10,'span',[['class','md-title'],['fxFlex','100']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),i1.ɵdid(737280,(null as any),
          0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2,[3,i2.LayoutDirective],
              [3,i14.LayoutWrapDirective]],{flex:[0,'flex']},(null as any)),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['',' /\n                        '])),
      i1.ɵppd(2),(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'a',([] as any[]),
          [[1,'target',0],[8,'href',4]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,25).onClick($event.button,$event.ctrlKey,
                  $event.metaKey,$event.shiftKey)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(671744,(null as any),0,i16.RouterLinkWithHref,
          [i16.Router,i16.ActivatedRoute,i15.LocationStrategy],{routerLink:[0,'routerLink']},
          (null as any)),i1.ɵpad(1),(_l()(),i1.ɵted((null as any),['',''])),i1.ɵppd(2),
      (_l()(),i1.ɵted((null as any),[' / ','\n                    '])),(_l()(),i1.ɵted((null as any),
          ['\n                '])),(_l()(),i1.ɵted(2,['\n                '])),(_l()(),
          i1.ɵeld(0,(null as any),1,5,'md-card-subtitle',[['class','bg-grey color-white text-only']],
              [[2,'mat-card-subtitle',(null as any)]],(null as any),(null as any),
              (null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
          [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(16384,(null as any),0,i7.MdCardSubtitle,([] as any[]),(null as any),
          (null as any)),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i3.MediaMonitor,
          i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],
          {classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['',''])),i1.ɵppd(2),(_l()(),i1.ɵted(2,['\n            '])),(_l()(),i1.ɵted(0,
          ['\n            '])),(_l()(),i1.ɵand(16777216,(null as any),0,1,(null as any),
          View_PoNewComponent_5)),i1.ɵdid(16384,(null as any),0,i15.NgIf,[i1.ViewContainerRef,
          i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(0,['\n        ']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_1:boolean = !_co.isCancelled();
        _ck(_v,5,0,currVal_1);
        const currVal_2:any = _co.isCancelled();
        _ck(_v,8,0,currVal_2);
        const currVal_4:any = 'column';
        _ck(_v,13,0,currVal_4);
        const currVal_6:any = '100';
        _ck(_v,20,0,currVal_6);
        const currVal_7:any = 'md-title';
        _ck(_v,21,0,currVal_7);
        const currVal_11:any = _ck(_v,26,0,'/purchasing/po');
        _ck(_v,25,0,currVal_11);
        const currVal_15:any = 'bg-grey color-white text-only';
        _ck(_v,35,0,currVal_15);
        const currVal_17:any = _co.currentPo;
        _ck(_v,41,0,currVal_17);
      },(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = true;
        _ck(_v,0,0,currVal_0);
        const currVal_3:any = true;
        _ck(_v,10,0,currVal_3);
        const currVal_5:any = true;
        _ck(_v,15,0,currVal_5);
        const currVal_8:any = i1.ɵunv(_v,22,0,_ck(_v,23,0,i1.ɵnov((<any>_v.parent),
            0),'purchasing',_co._authService.getLanguage()));
        _ck(_v,22,0,currVal_8);
        const currVal_9:any = i1.ɵnov(_v,25).target;
        const currVal_10:any = i1.ɵnov(_v,25).href;
        _ck(_v,24,0,currVal_9,currVal_10);
        const currVal_12:any = i1.ɵunv(_v,27,0,_ck(_v,28,0,i1.ɵnov((<any>_v.parent),
            0),'po_list',_co._authService.getLanguage()));
        _ck(_v,27,0,currVal_12);
        const currVal_13:any = ((_co.isEditMode && _co.currentPo)? _co.currentPo.po_number: _co.title);
        _ck(_v,29,0,currVal_13);
        const currVal_14:any = true;
        _ck(_v,32,0,currVal_14);
        const currVal_16:any = i1.ɵunv(_v,36,0,_ck(_v,37,0,i1.ɵnov((<any>_v.parent),
            0),'po_details',_co._authService.getLanguage()));
        _ck(_v,36,0,currVal_16);
      });
}
function View_PoNewComponent_10(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'md-option',[['role',
      'option']],[[1,'tabindex',0],[2,'mat-selected',(null as any)],[2,'mat-option-multiple',
      (null as any)],[2,'mat-active',(null as any)],[8,'id',0],[1,'aria-selected',
      0],[1,'aria-disabled',0],[2,'mat-option-disabled',(null as any)],[2,'mat-option',
      (null as any)]],[[(null as any),'click'],[(null as any),'keydown']],(_v,en,$event) => {
    var ad:boolean = true;
    if (('click' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,2)._selectViaInteraction()) !== false);
      ad = (pd_0 && ad);
    }
    if (('keydown' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,2)._handleKeydown($event)) !== false);
      ad = (pd_1 && ad);
    }
    return ad;
  },i6.View_MdOption_0,i6.RenderType_MdOption)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(49152,[[90,4]],0,i7.MdOption,[i1.ElementRef,[2,i7.MATERIAL_COMPATIBILITY_MODE]],
          {value:[0,'value']},(null as any)),(_l()(),i1.ɵted(0,['',' (',')']))],(_ck,
      _v) => {
    const currVal_9:any = _v.context.$implicit.code;
    _ck(_v,2,0,currVal_9);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,2)._getTabIndex();
    const currVal_1:any = i1.ɵnov(_v,2).selected;
    const currVal_2:any = i1.ɵnov(_v,2).multiple;
    const currVal_3:any = i1.ɵnov(_v,2).active;
    const currVal_4:any = i1.ɵnov(_v,2).id;
    const currVal_5:any = i1.ɵnov(_v,2).selected.toString();
    const currVal_6:any = i1.ɵnov(_v,2).disabled.toString();
    const currVal_7:any = i1.ɵnov(_v,2).disabled;
    const currVal_8:any = true;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8);
    const currVal_10:any = _v.context.$implicit.code;
    const currVal_11:any = _v.context.$implicit.description;
    _ck(_v,3,0,currVal_10,currVal_11);
  });
}
function View_PoNewComponent_9(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),384,'md-card-content',
      [['fxLayout','column']],[[2,'mat-card-content',(null as any)]],(null as any),
      (null as any),(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(16384,(null as any),0,i7.MdCardContent,([] as any[]),(null as any),(null as any)),
      i1.ɵdid(737280,(null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2],{layout:[0,'layout']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n                '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),84,
          'div',[['class','padded-container'],['fxLayout','row'],['fxLayout.lt-md',
              'column'],['fxLayoutGap','30px'],['fxLayoutGap.lt-md','14px']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(737280,
          (null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2],
          {layout:[0,'layout'],layoutLtMd:[1,'layoutLtMd']},(null as any)),i1.ɵdid(1720320,
          (null as any),0,i4.LayoutGapDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2,
              [2,i2.LayoutDirective]],{gap:[0,'gap'],gapLtMd:[1,'gapLtMd']},(null as any)),
      i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),['\n                    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',[['fxFlex',
          '22%']],[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
          (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,11)._focusInput()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,48,{_mdInputChild:0}),i1.ɵqud(335544320,49,{_placeholderChild:0}),
      i1.ɵqud(603979776,50,{_errorChildren:1}),i1.ɵqud(603979776,51,{_hintChildren:1}),
      i1.ɵqud(603979776,52,{_prefixChildren:1}),i1.ɵqud(603979776,53,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
              (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
              0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
          'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
          'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,21)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,21).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,21)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,21)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('blur' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,26)._onBlur()) !== false);
          ad = (pd_4 && ad);
        }
        if (('focus' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,26)._onFocus()) !== false);
          ad = (pd_5 && ad);
        }
        if (('input' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,26)._onInput()) !== false);
          ad = (pd_6 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_7:any = ((<any>(_co.currentPo.proforma_invoice_number = $event)) !== false);
          ad = (pd_7 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[48,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],
          {placeholder:[0,'placeholder']},(null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,
          ['\n                    '])),(_l()(),i1.ɵted((null as any),['\n\n                    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',[['fxFlex',
          '22%']],[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
          (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,31)._focusInput()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,54,{_mdInputChild:0}),i1.ɵqud(335544320,55,{_placeholderChild:0}),
      i1.ɵqud(603979776,56,{_errorChildren:1}),i1.ɵqud(603979776,57,{_hintChildren:1}),
      i1.ɵqud(603979776,58,{_prefixChildren:1}),i1.ɵqud(603979776,59,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput',''],['type','date']],
          [[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
              (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
              [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
                  (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,
                  'required',0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],
              [(null as any),'input'],[(null as any),'blur'],[(null as any),'compositionstart'],
              [(null as any),'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,41)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,41).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,41)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,41)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,46)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,46)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,46)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.currentPo.proforma_invoice_date = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[54,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],
          {placeholder:[0,'placeholder'],type:[1,'type']},(null as any)),i1.ɵppd(2),
      (_l()(),i1.ɵted(1,['\n                    '])),(_l()(),i1.ɵted((null as any),
          ['\n\n                    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          18,'md-input-container',[['fxFlex','22%']],[[1,'align',0],[2,'mat-input-container',
              (null as any)],[2,'mat-input-invalid',(null as any)],[2,'mat-focused',
              (null as any)],[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
              [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
                  (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],
          [[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,51)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,60,{_mdInputChild:0}),i1.ɵqud(335544320,61,{_placeholderChild:0}),
      i1.ɵqud(603979776,62,{_errorChildren:1}),i1.ɵqud(603979776,63,{_hintChildren:1}),
      i1.ɵqud(603979776,64,{_prefixChildren:1}),i1.ɵqud(603979776,65,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
              (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
              0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
          'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
          'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,61)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,61).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,61)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,61)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('blur' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,66)._onBlur()) !== false);
          ad = (pd_4 && ad);
        }
        if (('focus' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,66)._onFocus()) !== false);
          ad = (pd_5 && ad);
        }
        if (('input' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,66)._onInput()) !== false);
          ad = (pd_6 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_7:any = ((<any>(_co.currentPo.downpayment_amount = $event)) !== false);
          ad = (pd_7 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[60,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],
          {placeholder:[0,'placeholder']},(null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,
          ['\n                    '])),(_l()(),i1.ɵted((null as any),['\n\n                    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',[['fxFlex',
          '22%']],[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
          (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,71)._focusInput()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,66,{_mdInputChild:0}),i1.ɵqud(335544320,67,{_placeholderChild:0}),
      i1.ɵqud(603979776,68,{_errorChildren:1}),i1.ɵqud(603979776,69,{_hintChildren:1}),
      i1.ɵqud(603979776,70,{_prefixChildren:1}),i1.ɵqud(603979776,71,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput',''],['type','date']],
          [[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
              (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
              [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
                  (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,
                  'required',0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],
              [(null as any),'input'],[(null as any),'blur'],[(null as any),'compositionstart'],
              [(null as any),'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,81)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,81).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,81)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,81)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,86)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,86)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,86)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.currentPo.downpayment_date = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[66,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],
          {placeholder:[0,'placeholder'],type:[1,'type']},(null as any)),i1.ɵppd(2),
      (_l()(),i1.ɵted(1,['\n                    '])),(_l()(),i1.ɵted((null as any),
          ['\n                '])),(_l()(),i1.ɵted((null as any),['\n                '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),93,'div',[['class','padded-container'],
          ['fxLayout','row'],['fxLayout.lt-md','column'],['fxLayoutGap','30px'],['fxLayoutGap.lt-md',
              '14px']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(737280,(null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2],{layout:[0,'layout'],layoutLtMd:[1,'layoutLtMd']},(null as any)),
      i1.ɵdid(1720320,(null as any),0,i4.LayoutGapDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[2,i2.LayoutDirective]],{gap:[0,'gap'],gapLtMd:[1,'gapLtMd']},
          (null as any)),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i3.MediaMonitor,
          i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],
          {classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n\n                    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          18,'md-input-container',[['fxFlex','22%']],[[1,'align',0],[2,'mat-input-container',
              (null as any)],[2,'mat-input-invalid',(null as any)],[2,'mat-focused',
              (null as any)],[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
              [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
                  (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],
          [[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,97)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,72,{_mdInputChild:0}),i1.ɵqud(335544320,73,{_placeholderChild:0}),
      i1.ɵqud(603979776,74,{_errorChildren:1}),i1.ɵqud(603979776,75,{_hintChildren:1}),
      i1.ɵqud(603979776,76,{_prefixChildren:1}),i1.ɵqud(603979776,77,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
              (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
              0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
          'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
          'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,107)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,107).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,107)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,107)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('blur' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,112)._onBlur()) !== false);
          ad = (pd_4 && ad);
        }
        if (('focus' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,112)._onFocus()) !== false);
          ad = (pd_5 && ad);
        }
        if (('input' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,112)._onInput()) !== false);
          ad = (pd_6 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_7:any = ((<any>(_co.currentPo.additional_details = $event)) !== false);
          ad = (pd_7 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[72,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],
          {placeholder:[0,'placeholder']},(null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,
          ['\n                    '])),(_l()(),i1.ɵted((null as any),['\n\n                    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',[['fxFlex',
          '22%']],[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
          (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,117)._focusInput()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,78,{_mdInputChild:0}),i1.ɵqud(335544320,79,{_placeholderChild:0}),
      i1.ɵqud(603979776,80,{_errorChildren:1}),i1.ɵqud(603979776,81,{_hintChildren:1}),
      i1.ɵqud(603979776,82,{_prefixChildren:1}),i1.ɵqud(603979776,83,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
              (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
              0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
          'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
          'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,127)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,127).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,127)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,127)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('blur' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,132)._onBlur()) !== false);
          ad = (pd_4 && ad);
        }
        if (('focus' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,132)._onFocus()) !== false);
          ad = (pd_5 && ad);
        }
        if (('input' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,132)._onInput()) !== false);
          ad = (pd_6 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_7:any = ((<any>(_co.currentPo.additional_cost = $event)) !== false);
          ad = (pd_7 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[78,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],
          {placeholder:[0,'placeholder']},(null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,
          ['\n                    '])),(_l()(),i1.ɵted((null as any),['\n\n                    '])),
      (_l()(),i1.ɵted((null as any),['\n                    '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),28,'md-input-container',[['fxFlex','22%']],[[1,
              'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,138)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,84,{_mdInputChild:0}),i1.ɵqud(335544320,85,{_placeholderChild:0}),
      i1.ɵqud(603979776,86,{_errorChildren:1}),i1.ɵqud(603979776,87,{_hintChildren:1}),
      i1.ɵqud(603979776,88,{_prefixChildren:1}),i1.ɵqud(603979776,89,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(16777216,(null as any),1,8,'input',[['aria-autocomplete','list'],
          ['aria-multiline','false'],['autocomplete','off'],['mdInput',''],['role',
              'combobox']],[[1,'aria-activedescendant',0],[1,'aria-expanded',0],[1,
          'aria-owns',0],[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
          [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
              (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)],
          [2,'mat-input-element',(null as any)],[8,'id',0],[8,'placeholder',0],[8,
              'disabled',0],[8,'required',0],[1,'aria-describedby',0]],[[(null as any),
          'ngModelChange'],[(null as any),'blur'],[(null as any),'input'],[(null as any),
          'compositionstart'],[(null as any),'compositionend'],[(null as any),'focus'],
          [(null as any),'keydown']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,148)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,148).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,148)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,148)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('focus' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,149).openPanel()) !== false);
          ad = (pd_4 && ad);
        }
        if (('input' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,149)._handleInput($event)) !== false);
          ad = (pd_5 && ad);
        }
        if (('blur' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,149)._onTouched()) !== false);
          ad = (pd_6 && ad);
        }
        if (('keydown' === en)) {
          const pd_7:any = ((<any>i1.ɵnov(_v,149)._handleKeydown($event)) !== false);
          ad = (pd_7 && ad);
        }
        if (('blur' === en)) {
          const pd_8:any = ((<any>i1.ɵnov(_v,154)._onBlur()) !== false);
          ad = (pd_8 && ad);
        }
        if (('focus' === en)) {
          const pd_9:any = ((<any>i1.ɵnov(_v,154)._onFocus()) !== false);
          ad = (pd_9 && ad);
        }
        if (('input' === en)) {
          const pd_10:any = ((<any>i1.ɵnov(_v,154)._onInput()) !== false);
          ad = (pd_10 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_11:any = ((<any>(_co.currentPo.currency = $event)) !== false);
          ad = (pd_11 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_12:any = ((<any>_co.filterCurrencies($event)) !== false);
          ad = (pd_12 && ad);
        }
        if (('blur' === en)) {
          const pd_13:any = ((<any>_co.setCurrency()) !== false);
          ad = (pd_13 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵdid(147456,(null as any),0,i7.MdAutocompleteTrigger,[i1.ElementRef,
          i7.Overlay,i1.ViewContainerRef,i1.ChangeDetectorRef,i7.ScrollDispatcher,
          [2,i7.Dir],i1.NgZone,[2,i7.MdInputContainer],[2,i17.DOCUMENT]],{autocomplete:[0,
          'autocomplete']},(null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,
          (p0_0:any,p1_0:any) => {
            return [p0_0,p1_0];
          },[i12.DefaultValueAccessor,i7.MdAutocompleteTrigger]),i1.ɵdid(671744,(null as any),
          0,i12.NgModel,[[8,(null as any)],[8,(null as any)],[8,(null as any)],[2,
              i12.NG_VALUE_ACCESSOR]],{model:[0,'model']},{update:'ngModelChange'}),
      i1.ɵprd(2048,(null as any),i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,
          (null as any),0,i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),
      i1.ɵdid(16384,[[84,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,
          i12.NgControl]],{placeholder:[0,'placeholder']},(null as any)),i1.ɵppd(2),
      (_l()(),i1.ɵted(1,['\n                        '])),(_l()(),i1.ɵeld(0,(null as any),
          1,7,'md-autocomplete',([] as any[]),[[2,'mat-autocomplete',(null as any)]],
          (null as any),(null as any),i6.View_MdAutocomplete_0,i6.RenderType_MdAutocomplete)),
      i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(1097728,[['currencyAuto',
          4]],1,i7.MdAutocomplete,[i1.ChangeDetectorRef],(null as any),(null as any)),
      i1.ɵqud(603979776,90,{options:1}),(_l()(),i1.ɵted(0,['\n                            '])),
      (_l()(),i1.ɵand(16777216,(null as any),0,1,(null as any),View_PoNewComponent_10)),
      i1.ɵdid(802816,(null as any),0,i15.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(0,
          ['\n                        '])),(_l()(),i1.ɵted(1,['\n                    '])),
      (_l()(),i1.ɵted((null as any),['\n\n                    '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),16,'md-input-container',[['fxFlex','22%']],[[1,
              'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,168)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,91,{_mdInputChild:0}),i1.ɵqud(335544320,92,{_placeholderChild:0}),
      i1.ɵqud(603979776,93,{_errorChildren:1}),i1.ɵqud(603979776,94,{_hintChildren:1}),
      i1.ɵqud(603979776,95,{_prefixChildren:1}),i1.ɵqud(603979776,96,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵted(1,['\n\n                        '])),(_l()(),i1.ɵted(1,['\n\n                        '])),
      (_l()(),i1.ɵted(1,['\n                        '])),(_l()(),i1.ɵeld(0,(null as any),
          1,2,'input',[['mdInput',''],['readonly','']],[[8,'value',0],[2,'mat-input-element',
              (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
              0],[1,'aria-describedby',0]],[[(null as any),'blur'],[(null as any),
              'focus'],[(null as any),'input']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('blur' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,181)._onBlur()) !== false);
              ad = (pd_0 && ad);
            }
            if (('focus' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,181)._onFocus()) !== false);
              ad = (pd_1 && ad);
            }
            if (('input' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,181)._onInput()) !== false);
              ad = (pd_2 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,[[91,4]],0,i7.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[8,(null as any)]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,['\n\n                    '])),
      (_l()(),i1.ɵted((null as any),['\n                '])),(_l()(),i1.ɵted((null as any),
          ['\n                '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),84,
          'div',[['class','padded-container'],['fxLayout','row'],['fxLayout.lt-md',
              'column'],['fxLayoutGap','30px'],['fxLayoutGap.lt-md','14px']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(737280,
          (null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2],
          {layout:[0,'layout'],layoutLtMd:[1,'layoutLtMd']},(null as any)),i1.ɵdid(1720320,
          (null as any),0,i4.LayoutGapDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2,
              [2,i2.LayoutDirective]],{gap:[0,'gap'],gapLtMd:[1,'gapLtMd']},(null as any)),
      i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),['\n                    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',[['fxFlex',
          '22%']],[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
          (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,192)._focusInput()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,97,{_mdInputChild:0}),i1.ɵqud(335544320,98,{_placeholderChild:0}),
      i1.ɵqud(603979776,99,{_errorChildren:1}),i1.ɵqud(603979776,100,{_hintChildren:1}),
      i1.ɵqud(603979776,101,{_prefixChildren:1}),i1.ɵqud(603979776,102,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
              (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
              0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
          'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
          'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,202)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,202).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,202)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,202)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('blur' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,207)._onBlur()) !== false);
          ad = (pd_4 && ad);
        }
        if (('focus' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,207)._onFocus()) !== false);
          ad = (pd_5 && ad);
        }
        if (('input' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,207)._onInput()) !== false);
          ad = (pd_6 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_7:any = ((<any>(_co.currentPo.credit_details = $event)) !== false);
          ad = (pd_7 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[97,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],
          {placeholder:[0,'placeholder']},(null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,
          ['\n                    '])),(_l()(),i1.ɵted((null as any),['\n\n                    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',[['fxFlex',
          '22%']],[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
          (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,212)._focusInput()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,103,{_mdInputChild:0}),i1.ɵqud(335544320,104,{_placeholderChild:0}),
      i1.ɵqud(603979776,105,{_errorChildren:1}),i1.ɵqud(603979776,106,{_hintChildren:1}),
      i1.ɵqud(603979776,107,{_prefixChildren:1}),i1.ɵqud(603979776,108,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
              (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
              0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
          'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
          'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,222)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,222).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,222)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,222)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('blur' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,227)._onBlur()) !== false);
          ad = (pd_4 && ad);
        }
        if (('focus' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,227)._onFocus()) !== false);
          ad = (pd_5 && ad);
        }
        if (('input' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,227)._onInput()) !== false);
          ad = (pd_6 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_7:any = ((<any>(_co.currentPo.credit_amount = $event)) !== false);
          ad = (pd_7 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[103,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],
          {placeholder:[0,'placeholder']},(null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,
          ['\n                    '])),(_l()(),i1.ɵted((null as any),['\n\n                    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',[['fxFlex',
          '22%']],[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
          (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,232)._focusInput()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,109,{_mdInputChild:0}),i1.ɵqud(335544320,110,{_placeholderChild:0}),
      i1.ɵqud(603979776,111,{_errorChildren:1}),i1.ɵqud(603979776,112,{_hintChildren:1}),
      i1.ɵqud(603979776,113,{_prefixChildren:1}),i1.ɵqud(603979776,114,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
              (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
              0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
          'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
          'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,242)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,242).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,242)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,242)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('blur' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,247)._onBlur()) !== false);
          ad = (pd_4 && ad);
        }
        if (('focus' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,247)._onFocus()) !== false);
          ad = (pd_5 && ad);
        }
        if (('input' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,247)._onInput()) !== false);
          ad = (pd_6 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_7:any = ((<any>(_co.currentPo.balance_paid_amount = $event)) !== false);
          ad = (pd_7 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[109,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],
          {placeholder:[0,'placeholder']},(null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,
          ['\n                    '])),(_l()(),i1.ɵted((null as any),['\n\n                    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',[['fxFlex',
          '22%']],[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
          (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,252)._focusInput()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,115,{_mdInputChild:0}),i1.ɵqud(335544320,116,{_placeholderChild:0}),
      i1.ɵqud(603979776,117,{_errorChildren:1}),i1.ɵqud(603979776,118,{_hintChildren:1}),
      i1.ɵqud(603979776,119,{_prefixChildren:1}),i1.ɵqud(603979776,120,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput',''],['type','date']],
          [[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
              (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
              [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
                  (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,
                  'required',0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],
              [(null as any),'input'],[(null as any),'blur'],[(null as any),'compositionstart'],
              [(null as any),'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,262)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,262).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,262)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,262)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,267)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,267)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,267)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.currentPo.payment_date = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[115,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],
          {placeholder:[0,'placeholder'],type:[1,'type']},(null as any)),i1.ɵppd(2),
      (_l()(),i1.ɵted(1,['\n                    '])),(_l()(),i1.ɵted((null as any),
          ['\n                '])),(_l()(),i1.ɵted((null as any),['\n\n\n                '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),84,'div',[['class','padded-container'],
          ['fxLayout','row'],['fxLayout.lt-md','column'],['fxLayoutGap','30px'],['fxLayoutGap.lt-md',
              '14px']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(737280,(null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2],{layout:[0,'layout'],layoutLtMd:[1,'layoutLtMd']},(null as any)),
      i1.ɵdid(1720320,(null as any),0,i4.LayoutGapDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[2,i2.LayoutDirective]],{gap:[0,'gap'],gapLtMd:[1,'gapLtMd']},
          (null as any)),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i3.MediaMonitor,
          i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],
          {classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n                    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          18,'md-input-container',[['fxFlex','22%']],[[1,'align',0],[2,'mat-input-container',
              (null as any)],[2,'mat-input-invalid',(null as any)],[2,'mat-focused',
              (null as any)],[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
              [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
                  (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],
          [[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,278)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,121,{_mdInputChild:0}),i1.ɵqud(335544320,122,{_placeholderChild:0}),
      i1.ɵqud(603979776,123,{_errorChildren:1}),i1.ɵqud(603979776,124,{_hintChildren:1}),
      i1.ɵqud(603979776,125,{_prefixChildren:1}),i1.ɵqud(603979776,126,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
              (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
              0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
          'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
          'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,288)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,288).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,288)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,288)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('blur' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,293)._onBlur()) !== false);
          ad = (pd_4 && ad);
        }
        if (('focus' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,293)._onFocus()) !== false);
          ad = (pd_5 && ad);
        }
        if (('input' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,293)._onInput()) !== false);
          ad = (pd_6 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_7:any = ((<any>(_co.currentPo.final_invoice_number = $event)) !== false);
          ad = (pd_7 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[121,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],
          {placeholder:[0,'placeholder']},(null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,
          ['\n                    '])),(_l()(),i1.ɵted((null as any),['\n\n                    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',[['fxFlex',
          '22%']],[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
          (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,298)._focusInput()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,127,{_mdInputChild:0}),i1.ɵqud(335544320,128,{_placeholderChild:0}),
      i1.ɵqud(603979776,129,{_errorChildren:1}),i1.ɵqud(603979776,130,{_hintChildren:1}),
      i1.ɵqud(603979776,131,{_prefixChildren:1}),i1.ɵqud(603979776,132,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput',''],['type','date']],
          [[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
              (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
              [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
                  (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,
                  'required',0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],
              [(null as any),'input'],[(null as any),'blur'],[(null as any),'compositionstart'],
              [(null as any),'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,308)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,308).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,308)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,308)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,313)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,313)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,313)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.currentPo.final_invoice_date = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[127,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],
          {placeholder:[0,'placeholder'],type:[1,'type']},(null as any)),i1.ɵppd(2),
      (_l()(),i1.ɵted(1,['\n                    '])),(_l()(),i1.ɵted((null as any),
          ['\n\n                    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          18,'md-input-container',[['fxFlex','22%']],[[1,'align',0],[2,'mat-input-container',
              (null as any)],[2,'mat-input-invalid',(null as any)],[2,'mat-focused',
              (null as any)],[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
              [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
                  (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],
          [[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,318)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,133,{_mdInputChild:0}),i1.ɵqud(335544320,134,{_placeholderChild:0}),
      i1.ɵqud(603979776,135,{_errorChildren:1}),i1.ɵqud(603979776,136,{_hintChildren:1}),
      i1.ɵqud(603979776,137,{_prefixChildren:1}),i1.ɵqud(603979776,138,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
              (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
              0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
          'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
          'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,328)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,328).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,328)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,328)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('blur' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,333)._onBlur()) !== false);
          ad = (pd_4 && ad);
        }
        if (('focus' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,333)._onFocus()) !== false);
          ad = (pd_5 && ad);
        }
        if (('input' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,333)._onInput()) !== false);
          ad = (pd_6 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_7:any = ((<any>(_co.currentPo.total_qty_produced = $event)) !== false);
          ad = (pd_7 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[133,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],
          {placeholder:[0,'placeholder']},(null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,
          ['\n                    '])),(_l()(),i1.ɵted((null as any),['\n\n                    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',[['fxFlex',
          '22%']],[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
          (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,338)._focusInput()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,139,{_mdInputChild:0}),i1.ɵqud(335544320,140,{_placeholderChild:0}),
      i1.ɵqud(603979776,141,{_errorChildren:1}),i1.ɵqud(603979776,142,{_hintChildren:1}),
      i1.ɵqud(603979776,143,{_prefixChildren:1}),i1.ɵqud(603979776,144,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
              (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
              0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
          'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
          'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,348)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,348).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,348)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,348)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('blur' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,353)._onBlur()) !== false);
          ad = (pd_4 && ad);
        }
        if (('focus' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,353)._onFocus()) !== false);
          ad = (pd_5 && ad);
        }
        if (('input' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,353)._onInput()) !== false);
          ad = (pd_6 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_7:any = ((<any>(_co.currentPo.total_amount = $event)) !== false);
          ad = (pd_7 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[139,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],
          {placeholder:[0,'placeholder']},(null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,
          ['\n                    '])),(_l()(),i1.ɵted((null as any),['\n                '])),
      (_l()(),i1.ɵted((null as any),['\n\n                '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),25,'div',[['class','padded-container'],['fxLayout','row'],
              ['fxLayout.lt-md','column'],['fxLayoutGap','30px'],['fxLayoutGap.lt-md',
                  '14px']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),i1.ɵdid(737280,(null as any),0,i2.LayoutDirective,[i3.MediaMonitor,
          i1.ElementRef,i1.Renderer2],{layout:[0,'layout'],layoutLtMd:[1,'layoutLtMd']},
          (null as any)),i1.ɵdid(1720320,(null as any),0,i4.LayoutGapDirective,[i3.MediaMonitor,
          i1.ElementRef,i1.Renderer2,[2,i2.LayoutDirective]],{gap:[0,'gap'],gapLtMd:[1,
          'gapLtMd']},(null as any)),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,
          [i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
              i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n                    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          19,'md-input-container',[['fxFlex','47%']],[[1,'align',0],[2,'mat-input-container',
              (null as any)],[2,'mat-input-invalid',(null as any)],[2,'mat-focused',
              (null as any)],[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
              [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
                  (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],
          [[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,364)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,145,{_mdInputChild:0}),i1.ɵqud(335544320,146,{_placeholderChild:0}),
      i1.ɵqud(603979776,147,{_errorChildren:1}),i1.ɵqud(603979776,148,{_hintChildren:1}),
      i1.ɵqud(603979776,149,{_prefixChildren:1}),i1.ɵqud(603979776,150,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,8,'textarea',[['mdInput','']],[[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
              (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
              0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
          'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
          'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,374)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,374).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,374)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,374)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('blur' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,379)._onBlur()) !== false);
          ad = (pd_4 && ad);
        }
        if (('focus' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,379)._onFocus()) !== false);
          ad = (pd_5 && ad);
        }
        if (('input' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,379)._onInput()) !== false);
          ad = (pd_6 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_7:any = ((<any>(_co.currentPo.notes = $event)) !== false);
          ad = (pd_7 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[145,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],
          {placeholder:[0,'placeholder']},(null as any)),i1.ɵppd(2),(_l()(),i1.ɵted((null as any),
          ['',''])),(_l()(),i1.ɵted(1,['\n                    '])),(_l()(),i1.ɵted((null as any),
          ['\n                '])),(_l()(),i1.ɵted((null as any),['\n            ']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_1:any = 'column';
        _ck(_v,3,0,currVal_1);
        const currVal_2:any = 'row';
        const currVal_3:any = 'column';
        _ck(_v,6,0,currVal_2,currVal_3);
        const currVal_4:any = '30px';
        const currVal_5:any = '14px';
        _ck(_v,7,0,currVal_4,currVal_5);
        const currVal_6:any = 'padded-container';
        _ck(_v,8,0,currVal_6);
        const currVal_18:any = '22%';
        _ck(_v,18,0,currVal_18);
        const currVal_32:any = _co.currentPo.proforma_invoice_number;
        _ck(_v,23,0,currVal_32);
        const currVal_33:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,26,0,_ck(_v,27,
            0,i1.ɵnov((<any>_v.parent),0),'proforma_invoice_number',_co._authService.getLanguage())),
            '');
        _ck(_v,26,0,currVal_33);
        const currVal_45:any = '22%';
        _ck(_v,38,0,currVal_45);
        const currVal_59:any = _co.currentPo.proforma_invoice_date;
        _ck(_v,43,0,currVal_59);
        const currVal_60:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,46,0,_ck(_v,47,
            0,i1.ɵnov((<any>_v.parent),0),'proforma_invoice_date',_co._authService.getLanguage())),
            '');
        const currVal_61:any = 'date';
        _ck(_v,46,0,currVal_60,currVal_61);
        const currVal_73:any = '22%';
        _ck(_v,58,0,currVal_73);
        const currVal_87:any = _co.currentPo.downpayment_amount;
        _ck(_v,63,0,currVal_87);
        const currVal_88:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,66,0,_ck(_v,67,
            0,i1.ɵnov((<any>_v.parent),0),'downpayment_amount',_co._authService.getLanguage())),
            '');
        _ck(_v,66,0,currVal_88);
        const currVal_100:any = '22%';
        _ck(_v,78,0,currVal_100);
        const currVal_114:any = _co.currentPo.downpayment_date;
        _ck(_v,83,0,currVal_114);
        const currVal_115:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,86,0,_ck(_v,
            87,0,i1.ɵnov((<any>_v.parent),0),'downpayment_date',_co._authService.getLanguage())),
            '');
        const currVal_116:any = 'date';
        _ck(_v,86,0,currVal_115,currVal_116);
        const currVal_117:any = 'row';
        const currVal_118:any = 'column';
        _ck(_v,92,0,currVal_117,currVal_118);
        const currVal_119:any = '30px';
        const currVal_120:any = '14px';
        _ck(_v,93,0,currVal_119,currVal_120);
        const currVal_121:any = 'padded-container';
        _ck(_v,94,0,currVal_121);
        const currVal_133:any = '22%';
        _ck(_v,104,0,currVal_133);
        const currVal_147:any = _co.currentPo.additional_details;
        _ck(_v,109,0,currVal_147);
        const currVal_148:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,112,0,_ck(_v,
            113,0,i1.ɵnov((<any>_v.parent),0),'additional_details',_co._authService.getLanguage())),
            '');
        _ck(_v,112,0,currVal_148);
        const currVal_160:any = '22%';
        _ck(_v,124,0,currVal_160);
        const currVal_174:any = _co.currentPo.additional_cost;
        _ck(_v,129,0,currVal_174);
        const currVal_175:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,132,0,_ck(_v,
            133,0,i1.ɵnov((<any>_v.parent),0),'additional_cost',_co._authService.getLanguage())),
            '');
        _ck(_v,132,0,currVal_175);
        const currVal_187:any = '22%';
        _ck(_v,145,0,currVal_187);
        const currVal_204:any = i1.ɵnov(_v,159);
        _ck(_v,149,0,currVal_204);
        const currVal_205:any = _co.currentPo.currency;
        _ck(_v,151,0,currVal_205);
        const currVal_206:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,154,0,_ck(_v,
            155,0,i1.ɵnov((<any>_v.parent),0),'currency',_co._authService.getLanguage())),
            '');
        _ck(_v,154,0,currVal_206);
        const currVal_208:any = _co._currencies;
        _ck(_v,163,0,currVal_208);
        const currVal_220:any = '22%';
        _ck(_v,175,0,currVal_220);
        const currVal_228:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,181,0,_ck(_v,
            182,0,i1.ɵnov((<any>_v.parent),0),'balance_due_calculated',_co._authService.getLanguage())),
            '');
        _ck(_v,181,0,currVal_228);
        const currVal_229:any = 'row';
        const currVal_230:any = 'column';
        _ck(_v,187,0,currVal_229,currVal_230);
        const currVal_231:any = '30px';
        const currVal_232:any = '14px';
        _ck(_v,188,0,currVal_231,currVal_232);
        const currVal_233:any = 'padded-container';
        _ck(_v,189,0,currVal_233);
        const currVal_245:any = '22%';
        _ck(_v,199,0,currVal_245);
        const currVal_259:any = _co.currentPo.credit_details;
        _ck(_v,204,0,currVal_259);
        const currVal_260:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,207,0,_ck(_v,
            208,0,i1.ɵnov((<any>_v.parent),0),'credit_details',_co._authService.getLanguage())),
            '');
        _ck(_v,207,0,currVal_260);
        const currVal_272:any = '22%';
        _ck(_v,219,0,currVal_272);
        const currVal_286:any = _co.currentPo.credit_amount;
        _ck(_v,224,0,currVal_286);
        const currVal_287:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,227,0,_ck(_v,
            228,0,i1.ɵnov((<any>_v.parent),0),'credit_amount',_co._authService.getLanguage())),
            '');
        _ck(_v,227,0,currVal_287);
        const currVal_299:any = '22%';
        _ck(_v,239,0,currVal_299);
        const currVal_313:any = _co.currentPo.balance_paid_amount;
        _ck(_v,244,0,currVal_313);
        const currVal_314:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,247,0,_ck(_v,
            248,0,i1.ɵnov((<any>_v.parent),0),'balance_paid_amount',_co._authService.getLanguage())),
            '');
        _ck(_v,247,0,currVal_314);
        const currVal_326:any = '22%';
        _ck(_v,259,0,currVal_326);
        const currVal_340:any = _co.currentPo.payment_date;
        _ck(_v,264,0,currVal_340);
        const currVal_341:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,267,0,_ck(_v,
            268,0,i1.ɵnov((<any>_v.parent),0),'payment_date',_co._authService.getLanguage())),
            '');
        const currVal_342:any = 'date';
        _ck(_v,267,0,currVal_341,currVal_342);
        const currVal_343:any = 'row';
        const currVal_344:any = 'column';
        _ck(_v,273,0,currVal_343,currVal_344);
        const currVal_345:any = '30px';
        const currVal_346:any = '14px';
        _ck(_v,274,0,currVal_345,currVal_346);
        const currVal_347:any = 'padded-container';
        _ck(_v,275,0,currVal_347);
        const currVal_359:any = '22%';
        _ck(_v,285,0,currVal_359);
        const currVal_373:any = _co.currentPo.final_invoice_number;
        _ck(_v,290,0,currVal_373);
        const currVal_374:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,293,0,_ck(_v,
            294,0,i1.ɵnov((<any>_v.parent),0),'final_invoice_number',_co._authService.getLanguage())),
            '');
        _ck(_v,293,0,currVal_374);
        const currVal_386:any = '22%';
        _ck(_v,305,0,currVal_386);
        const currVal_400:any = _co.currentPo.final_invoice_date;
        _ck(_v,310,0,currVal_400);
        const currVal_401:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,313,0,_ck(_v,
            314,0,i1.ɵnov((<any>_v.parent),0),'final_invoice_date',_co._authService.getLanguage())),
            '');
        const currVal_402:any = 'date';
        _ck(_v,313,0,currVal_401,currVal_402);
        const currVal_414:any = '22%';
        _ck(_v,325,0,currVal_414);
        const currVal_428:any = _co.currentPo.total_qty_produced;
        _ck(_v,330,0,currVal_428);
        const currVal_429:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,333,0,_ck(_v,
            334,0,i1.ɵnov((<any>_v.parent),0),'final_qty_produced',_co._authService.getLanguage())),
            '');
        _ck(_v,333,0,currVal_429);
        const currVal_441:any = '22%';
        _ck(_v,345,0,currVal_441);
        const currVal_455:any = _co.currentPo.total_amount;
        _ck(_v,350,0,currVal_455);
        const currVal_456:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,353,0,_ck(_v,
            354,0,i1.ɵnov((<any>_v.parent),0),'final_invoice_amount',_co._authService.getLanguage())),
            '');
        _ck(_v,353,0,currVal_456);
        const currVal_457:any = 'row';
        const currVal_458:any = 'column';
        _ck(_v,359,0,currVal_457,currVal_458);
        const currVal_459:any = '30px';
        const currVal_460:any = '14px';
        _ck(_v,360,0,currVal_459,currVal_460);
        const currVal_461:any = 'padded-container';
        _ck(_v,361,0,currVal_461);
        const currVal_473:any = '47%';
        _ck(_v,371,0,currVal_473);
        const currVal_487:any = _co.currentPo.notes;
        _ck(_v,376,0,currVal_487);
        const currVal_488:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,379,0,_ck(_v,
            380,0,i1.ɵnov((<any>_v.parent),0),'notes',_co._authService.getLanguage())),
            '');
        _ck(_v,379,0,currVal_488);
      },(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = true;
        _ck(_v,0,0,currVal_0);
        const currVal_7:any = (null as any);
        const currVal_8:any = true;
        const currVal_9:any = i1.ɵnov(_v,11)._isErrorState();
        const currVal_10:any = i1.ɵnov(_v,11)._mdInputChild.focused;
        const currVal_11:any = i1.ɵnov(_v,11)._shouldForward('untouched');
        const currVal_12:any = i1.ɵnov(_v,11)._shouldForward('touched');
        const currVal_13:any = i1.ɵnov(_v,11)._shouldForward('pristine');
        const currVal_14:any = i1.ɵnov(_v,11)._shouldForward('dirty');
        const currVal_15:any = i1.ɵnov(_v,11)._shouldForward('valid');
        const currVal_16:any = i1.ɵnov(_v,11)._shouldForward('invalid');
        const currVal_17:any = i1.ɵnov(_v,11)._shouldForward('pending');
        _ck(_v,10,1,[currVal_7,currVal_8,currVal_9,currVal_10,currVal_11,currVal_12,
            currVal_13,currVal_14,currVal_15,currVal_16,currVal_17]);
        const currVal_19:any = i1.ɵnov(_v,25).ngClassUntouched;
        const currVal_20:any = i1.ɵnov(_v,25).ngClassTouched;
        const currVal_21:any = i1.ɵnov(_v,25).ngClassPristine;
        const currVal_22:any = i1.ɵnov(_v,25).ngClassDirty;
        const currVal_23:any = i1.ɵnov(_v,25).ngClassValid;
        const currVal_24:any = i1.ɵnov(_v,25).ngClassInvalid;
        const currVal_25:any = i1.ɵnov(_v,25).ngClassPending;
        const currVal_26:any = true;
        const currVal_27:any = i1.ɵnov(_v,26).id;
        const currVal_28:any = i1.ɵnov(_v,26).placeholder;
        const currVal_29:any = i1.ɵnov(_v,26).disabled;
        const currVal_30:any = i1.ɵnov(_v,26).required;
        const currVal_31:any = (i1.ɵnov(_v,26).ariaDescribedby || (null as any));
        _ck(_v,20,1,[currVal_19,currVal_20,currVal_21,currVal_22,currVal_23,currVal_24,
            currVal_25,currVal_26,currVal_27,currVal_28,currVal_29,currVal_30,currVal_31]);
        const currVal_34:any = (null as any);
        const currVal_35:any = true;
        const currVal_36:any = i1.ɵnov(_v,31)._isErrorState();
        const currVal_37:any = i1.ɵnov(_v,31)._mdInputChild.focused;
        const currVal_38:any = i1.ɵnov(_v,31)._shouldForward('untouched');
        const currVal_39:any = i1.ɵnov(_v,31)._shouldForward('touched');
        const currVal_40:any = i1.ɵnov(_v,31)._shouldForward('pristine');
        const currVal_41:any = i1.ɵnov(_v,31)._shouldForward('dirty');
        const currVal_42:any = i1.ɵnov(_v,31)._shouldForward('valid');
        const currVal_43:any = i1.ɵnov(_v,31)._shouldForward('invalid');
        const currVal_44:any = i1.ɵnov(_v,31)._shouldForward('pending');
        _ck(_v,30,1,[currVal_34,currVal_35,currVal_36,currVal_37,currVal_38,currVal_39,
            currVal_40,currVal_41,currVal_42,currVal_43,currVal_44]);
        const currVal_46:any = i1.ɵnov(_v,45).ngClassUntouched;
        const currVal_47:any = i1.ɵnov(_v,45).ngClassTouched;
        const currVal_48:any = i1.ɵnov(_v,45).ngClassPristine;
        const currVal_49:any = i1.ɵnov(_v,45).ngClassDirty;
        const currVal_50:any = i1.ɵnov(_v,45).ngClassValid;
        const currVal_51:any = i1.ɵnov(_v,45).ngClassInvalid;
        const currVal_52:any = i1.ɵnov(_v,45).ngClassPending;
        const currVal_53:any = true;
        const currVal_54:any = i1.ɵnov(_v,46).id;
        const currVal_55:any = i1.ɵnov(_v,46).placeholder;
        const currVal_56:any = i1.ɵnov(_v,46).disabled;
        const currVal_57:any = i1.ɵnov(_v,46).required;
        const currVal_58:any = (i1.ɵnov(_v,46).ariaDescribedby || (null as any));
        _ck(_v,40,1,[currVal_46,currVal_47,currVal_48,currVal_49,currVal_50,currVal_51,
            currVal_52,currVal_53,currVal_54,currVal_55,currVal_56,currVal_57,currVal_58]);
        const currVal_62:any = (null as any);
        const currVal_63:any = true;
        const currVal_64:any = i1.ɵnov(_v,51)._isErrorState();
        const currVal_65:any = i1.ɵnov(_v,51)._mdInputChild.focused;
        const currVal_66:any = i1.ɵnov(_v,51)._shouldForward('untouched');
        const currVal_67:any = i1.ɵnov(_v,51)._shouldForward('touched');
        const currVal_68:any = i1.ɵnov(_v,51)._shouldForward('pristine');
        const currVal_69:any = i1.ɵnov(_v,51)._shouldForward('dirty');
        const currVal_70:any = i1.ɵnov(_v,51)._shouldForward('valid');
        const currVal_71:any = i1.ɵnov(_v,51)._shouldForward('invalid');
        const currVal_72:any = i1.ɵnov(_v,51)._shouldForward('pending');
        _ck(_v,50,1,[currVal_62,currVal_63,currVal_64,currVal_65,currVal_66,currVal_67,
            currVal_68,currVal_69,currVal_70,currVal_71,currVal_72]);
        const currVal_74:any = i1.ɵnov(_v,65).ngClassUntouched;
        const currVal_75:any = i1.ɵnov(_v,65).ngClassTouched;
        const currVal_76:any = i1.ɵnov(_v,65).ngClassPristine;
        const currVal_77:any = i1.ɵnov(_v,65).ngClassDirty;
        const currVal_78:any = i1.ɵnov(_v,65).ngClassValid;
        const currVal_79:any = i1.ɵnov(_v,65).ngClassInvalid;
        const currVal_80:any = i1.ɵnov(_v,65).ngClassPending;
        const currVal_81:any = true;
        const currVal_82:any = i1.ɵnov(_v,66).id;
        const currVal_83:any = i1.ɵnov(_v,66).placeholder;
        const currVal_84:any = i1.ɵnov(_v,66).disabled;
        const currVal_85:any = i1.ɵnov(_v,66).required;
        const currVal_86:any = (i1.ɵnov(_v,66).ariaDescribedby || (null as any));
        _ck(_v,60,1,[currVal_74,currVal_75,currVal_76,currVal_77,currVal_78,currVal_79,
            currVal_80,currVal_81,currVal_82,currVal_83,currVal_84,currVal_85,currVal_86]);
        const currVal_89:any = (null as any);
        const currVal_90:any = true;
        const currVal_91:any = i1.ɵnov(_v,71)._isErrorState();
        const currVal_92:any = i1.ɵnov(_v,71)._mdInputChild.focused;
        const currVal_93:any = i1.ɵnov(_v,71)._shouldForward('untouched');
        const currVal_94:any = i1.ɵnov(_v,71)._shouldForward('touched');
        const currVal_95:any = i1.ɵnov(_v,71)._shouldForward('pristine');
        const currVal_96:any = i1.ɵnov(_v,71)._shouldForward('dirty');
        const currVal_97:any = i1.ɵnov(_v,71)._shouldForward('valid');
        const currVal_98:any = i1.ɵnov(_v,71)._shouldForward('invalid');
        const currVal_99:any = i1.ɵnov(_v,71)._shouldForward('pending');
        _ck(_v,70,1,[currVal_89,currVal_90,currVal_91,currVal_92,currVal_93,currVal_94,
            currVal_95,currVal_96,currVal_97,currVal_98,currVal_99]);
        const currVal_101:any = i1.ɵnov(_v,85).ngClassUntouched;
        const currVal_102:any = i1.ɵnov(_v,85).ngClassTouched;
        const currVal_103:any = i1.ɵnov(_v,85).ngClassPristine;
        const currVal_104:any = i1.ɵnov(_v,85).ngClassDirty;
        const currVal_105:any = i1.ɵnov(_v,85).ngClassValid;
        const currVal_106:any = i1.ɵnov(_v,85).ngClassInvalid;
        const currVal_107:any = i1.ɵnov(_v,85).ngClassPending;
        const currVal_108:any = true;
        const currVal_109:any = i1.ɵnov(_v,86).id;
        const currVal_110:any = i1.ɵnov(_v,86).placeholder;
        const currVal_111:any = i1.ɵnov(_v,86).disabled;
        const currVal_112:any = i1.ɵnov(_v,86).required;
        const currVal_113:any = (i1.ɵnov(_v,86).ariaDescribedby || (null as any));
        _ck(_v,80,1,[currVal_101,currVal_102,currVal_103,currVal_104,currVal_105,currVal_106,
            currVal_107,currVal_108,currVal_109,currVal_110,currVal_111,currVal_112,
            currVal_113]);
        const currVal_122:any = (null as any);
        const currVal_123:any = true;
        const currVal_124:any = i1.ɵnov(_v,97)._isErrorState();
        const currVal_125:any = i1.ɵnov(_v,97)._mdInputChild.focused;
        const currVal_126:any = i1.ɵnov(_v,97)._shouldForward('untouched');
        const currVal_127:any = i1.ɵnov(_v,97)._shouldForward('touched');
        const currVal_128:any = i1.ɵnov(_v,97)._shouldForward('pristine');
        const currVal_129:any = i1.ɵnov(_v,97)._shouldForward('dirty');
        const currVal_130:any = i1.ɵnov(_v,97)._shouldForward('valid');
        const currVal_131:any = i1.ɵnov(_v,97)._shouldForward('invalid');
        const currVal_132:any = i1.ɵnov(_v,97)._shouldForward('pending');
        _ck(_v,96,1,[currVal_122,currVal_123,currVal_124,currVal_125,currVal_126,currVal_127,
            currVal_128,currVal_129,currVal_130,currVal_131,currVal_132]);
        const currVal_134:any = i1.ɵnov(_v,111).ngClassUntouched;
        const currVal_135:any = i1.ɵnov(_v,111).ngClassTouched;
        const currVal_136:any = i1.ɵnov(_v,111).ngClassPristine;
        const currVal_137:any = i1.ɵnov(_v,111).ngClassDirty;
        const currVal_138:any = i1.ɵnov(_v,111).ngClassValid;
        const currVal_139:any = i1.ɵnov(_v,111).ngClassInvalid;
        const currVal_140:any = i1.ɵnov(_v,111).ngClassPending;
        const currVal_141:any = true;
        const currVal_142:any = i1.ɵnov(_v,112).id;
        const currVal_143:any = i1.ɵnov(_v,112).placeholder;
        const currVal_144:any = i1.ɵnov(_v,112).disabled;
        const currVal_145:any = i1.ɵnov(_v,112).required;
        const currVal_146:any = (i1.ɵnov(_v,112).ariaDescribedby || (null as any));
        _ck(_v,106,1,[currVal_134,currVal_135,currVal_136,currVal_137,currVal_138,
            currVal_139,currVal_140,currVal_141,currVal_142,currVal_143,currVal_144,
            currVal_145,currVal_146]);
        const currVal_149:any = (null as any);
        const currVal_150:any = true;
        const currVal_151:any = i1.ɵnov(_v,117)._isErrorState();
        const currVal_152:any = i1.ɵnov(_v,117)._mdInputChild.focused;
        const currVal_153:any = i1.ɵnov(_v,117)._shouldForward('untouched');
        const currVal_154:any = i1.ɵnov(_v,117)._shouldForward('touched');
        const currVal_155:any = i1.ɵnov(_v,117)._shouldForward('pristine');
        const currVal_156:any = i1.ɵnov(_v,117)._shouldForward('dirty');
        const currVal_157:any = i1.ɵnov(_v,117)._shouldForward('valid');
        const currVal_158:any = i1.ɵnov(_v,117)._shouldForward('invalid');
        const currVal_159:any = i1.ɵnov(_v,117)._shouldForward('pending');
        _ck(_v,116,1,[currVal_149,currVal_150,currVal_151,currVal_152,currVal_153,
            currVal_154,currVal_155,currVal_156,currVal_157,currVal_158,currVal_159]);
        const currVal_161:any = i1.ɵnov(_v,131).ngClassUntouched;
        const currVal_162:any = i1.ɵnov(_v,131).ngClassTouched;
        const currVal_163:any = i1.ɵnov(_v,131).ngClassPristine;
        const currVal_164:any = i1.ɵnov(_v,131).ngClassDirty;
        const currVal_165:any = i1.ɵnov(_v,131).ngClassValid;
        const currVal_166:any = i1.ɵnov(_v,131).ngClassInvalid;
        const currVal_167:any = i1.ɵnov(_v,131).ngClassPending;
        const currVal_168:any = true;
        const currVal_169:any = i1.ɵnov(_v,132).id;
        const currVal_170:any = i1.ɵnov(_v,132).placeholder;
        const currVal_171:any = i1.ɵnov(_v,132).disabled;
        const currVal_172:any = i1.ɵnov(_v,132).required;
        const currVal_173:any = (i1.ɵnov(_v,132).ariaDescribedby || (null as any));
        _ck(_v,126,1,[currVal_161,currVal_162,currVal_163,currVal_164,currVal_165,
            currVal_166,currVal_167,currVal_168,currVal_169,currVal_170,currVal_171,
            currVal_172,currVal_173]);
        const currVal_176:any = (null as any);
        const currVal_177:any = true;
        const currVal_178:any = i1.ɵnov(_v,138)._isErrorState();
        const currVal_179:any = i1.ɵnov(_v,138)._mdInputChild.focused;
        const currVal_180:any = i1.ɵnov(_v,138)._shouldForward('untouched');
        const currVal_181:any = i1.ɵnov(_v,138)._shouldForward('touched');
        const currVal_182:any = i1.ɵnov(_v,138)._shouldForward('pristine');
        const currVal_183:any = i1.ɵnov(_v,138)._shouldForward('dirty');
        const currVal_184:any = i1.ɵnov(_v,138)._shouldForward('valid');
        const currVal_185:any = i1.ɵnov(_v,138)._shouldForward('invalid');
        const currVal_186:any = i1.ɵnov(_v,138)._shouldForward('pending');
        _ck(_v,137,1,[currVal_176,currVal_177,currVal_178,currVal_179,currVal_180,
            currVal_181,currVal_182,currVal_183,currVal_184,currVal_185,currVal_186]);
        const currVal_188:any = ((i1.ɵnov(_v,149).activeOption == null)? (null as any): i1.ɵnov(_v,
            149).activeOption.id);
        const currVal_189:any = i1.ɵnov(_v,149).panelOpen.toString();
        const currVal_190:any = ((i1.ɵnov(_v,149).autocomplete == null)? (null as any): i1.ɵnov(_v,
            149).autocomplete.id);
        const currVal_191:any = i1.ɵnov(_v,153).ngClassUntouched;
        const currVal_192:any = i1.ɵnov(_v,153).ngClassTouched;
        const currVal_193:any = i1.ɵnov(_v,153).ngClassPristine;
        const currVal_194:any = i1.ɵnov(_v,153).ngClassDirty;
        const currVal_195:any = i1.ɵnov(_v,153).ngClassValid;
        const currVal_196:any = i1.ɵnov(_v,153).ngClassInvalid;
        const currVal_197:any = i1.ɵnov(_v,153).ngClassPending;
        const currVal_198:any = true;
        const currVal_199:any = i1.ɵnov(_v,154).id;
        const currVal_200:any = i1.ɵnov(_v,154).placeholder;
        const currVal_201:any = i1.ɵnov(_v,154).disabled;
        const currVal_202:any = i1.ɵnov(_v,154).required;
        const currVal_203:any = (i1.ɵnov(_v,154).ariaDescribedby || (null as any));
        _ck(_v,147,1,[currVal_188,currVal_189,currVal_190,currVal_191,currVal_192,
            currVal_193,currVal_194,currVal_195,currVal_196,currVal_197,currVal_198,
            currVal_199,currVal_200,currVal_201,currVal_202,currVal_203]);
        const currVal_207:any = true;
        _ck(_v,157,0,currVal_207);
        const currVal_209:any = (null as any);
        const currVal_210:any = true;
        const currVal_211:any = i1.ɵnov(_v,168)._isErrorState();
        const currVal_212:any = i1.ɵnov(_v,168)._mdInputChild.focused;
        const currVal_213:any = i1.ɵnov(_v,168)._shouldForward('untouched');
        const currVal_214:any = i1.ɵnov(_v,168)._shouldForward('touched');
        const currVal_215:any = i1.ɵnov(_v,168)._shouldForward('pristine');
        const currVal_216:any = i1.ɵnov(_v,168)._shouldForward('dirty');
        const currVal_217:any = i1.ɵnov(_v,168)._shouldForward('valid');
        const currVal_218:any = i1.ɵnov(_v,168)._shouldForward('invalid');
        const currVal_219:any = i1.ɵnov(_v,168)._shouldForward('pending');
        _ck(_v,167,1,[currVal_209,currVal_210,currVal_211,currVal_212,currVal_213,
            currVal_214,currVal_215,currVal_216,currVal_217,currVal_218,currVal_219]);
        const currVal_221:any = ((((_co.currentPo.total_amount || 0) * 1) - (_co.currentPo.balance_paid_amount || 0)) - (_co.currentPo.downpayment_amount || 0));
        const currVal_222:any = true;
        const currVal_223:any = i1.ɵnov(_v,181).id;
        const currVal_224:any = i1.ɵnov(_v,181).placeholder;
        const currVal_225:any = i1.ɵnov(_v,181).disabled;
        const currVal_226:any = i1.ɵnov(_v,181).required;
        const currVal_227:any = (i1.ɵnov(_v,181).ariaDescribedby || (null as any));
        _ck(_v,180,0,currVal_221,currVal_222,currVal_223,currVal_224,currVal_225,currVal_226,
            currVal_227);
        const currVal_234:any = (null as any);
        const currVal_235:any = true;
        const currVal_236:any = i1.ɵnov(_v,192)._isErrorState();
        const currVal_237:any = i1.ɵnov(_v,192)._mdInputChild.focused;
        const currVal_238:any = i1.ɵnov(_v,192)._shouldForward('untouched');
        const currVal_239:any = i1.ɵnov(_v,192)._shouldForward('touched');
        const currVal_240:any = i1.ɵnov(_v,192)._shouldForward('pristine');
        const currVal_241:any = i1.ɵnov(_v,192)._shouldForward('dirty');
        const currVal_242:any = i1.ɵnov(_v,192)._shouldForward('valid');
        const currVal_243:any = i1.ɵnov(_v,192)._shouldForward('invalid');
        const currVal_244:any = i1.ɵnov(_v,192)._shouldForward('pending');
        _ck(_v,191,1,[currVal_234,currVal_235,currVal_236,currVal_237,currVal_238,
            currVal_239,currVal_240,currVal_241,currVal_242,currVal_243,currVal_244]);
        const currVal_246:any = i1.ɵnov(_v,206).ngClassUntouched;
        const currVal_247:any = i1.ɵnov(_v,206).ngClassTouched;
        const currVal_248:any = i1.ɵnov(_v,206).ngClassPristine;
        const currVal_249:any = i1.ɵnov(_v,206).ngClassDirty;
        const currVal_250:any = i1.ɵnov(_v,206).ngClassValid;
        const currVal_251:any = i1.ɵnov(_v,206).ngClassInvalid;
        const currVal_252:any = i1.ɵnov(_v,206).ngClassPending;
        const currVal_253:any = true;
        const currVal_254:any = i1.ɵnov(_v,207).id;
        const currVal_255:any = i1.ɵnov(_v,207).placeholder;
        const currVal_256:any = i1.ɵnov(_v,207).disabled;
        const currVal_257:any = i1.ɵnov(_v,207).required;
        const currVal_258:any = (i1.ɵnov(_v,207).ariaDescribedby || (null as any));
        _ck(_v,201,1,[currVal_246,currVal_247,currVal_248,currVal_249,currVal_250,
            currVal_251,currVal_252,currVal_253,currVal_254,currVal_255,currVal_256,
            currVal_257,currVal_258]);
        const currVal_261:any = (null as any);
        const currVal_262:any = true;
        const currVal_263:any = i1.ɵnov(_v,212)._isErrorState();
        const currVal_264:any = i1.ɵnov(_v,212)._mdInputChild.focused;
        const currVal_265:any = i1.ɵnov(_v,212)._shouldForward('untouched');
        const currVal_266:any = i1.ɵnov(_v,212)._shouldForward('touched');
        const currVal_267:any = i1.ɵnov(_v,212)._shouldForward('pristine');
        const currVal_268:any = i1.ɵnov(_v,212)._shouldForward('dirty');
        const currVal_269:any = i1.ɵnov(_v,212)._shouldForward('valid');
        const currVal_270:any = i1.ɵnov(_v,212)._shouldForward('invalid');
        const currVal_271:any = i1.ɵnov(_v,212)._shouldForward('pending');
        _ck(_v,211,1,[currVal_261,currVal_262,currVal_263,currVal_264,currVal_265,
            currVal_266,currVal_267,currVal_268,currVal_269,currVal_270,currVal_271]);
        const currVal_273:any = i1.ɵnov(_v,226).ngClassUntouched;
        const currVal_274:any = i1.ɵnov(_v,226).ngClassTouched;
        const currVal_275:any = i1.ɵnov(_v,226).ngClassPristine;
        const currVal_276:any = i1.ɵnov(_v,226).ngClassDirty;
        const currVal_277:any = i1.ɵnov(_v,226).ngClassValid;
        const currVal_278:any = i1.ɵnov(_v,226).ngClassInvalid;
        const currVal_279:any = i1.ɵnov(_v,226).ngClassPending;
        const currVal_280:any = true;
        const currVal_281:any = i1.ɵnov(_v,227).id;
        const currVal_282:any = i1.ɵnov(_v,227).placeholder;
        const currVal_283:any = i1.ɵnov(_v,227).disabled;
        const currVal_284:any = i1.ɵnov(_v,227).required;
        const currVal_285:any = (i1.ɵnov(_v,227).ariaDescribedby || (null as any));
        _ck(_v,221,1,[currVal_273,currVal_274,currVal_275,currVal_276,currVal_277,
            currVal_278,currVal_279,currVal_280,currVal_281,currVal_282,currVal_283,
            currVal_284,currVal_285]);
        const currVal_288:any = (null as any);
        const currVal_289:any = true;
        const currVal_290:any = i1.ɵnov(_v,232)._isErrorState();
        const currVal_291:any = i1.ɵnov(_v,232)._mdInputChild.focused;
        const currVal_292:any = i1.ɵnov(_v,232)._shouldForward('untouched');
        const currVal_293:any = i1.ɵnov(_v,232)._shouldForward('touched');
        const currVal_294:any = i1.ɵnov(_v,232)._shouldForward('pristine');
        const currVal_295:any = i1.ɵnov(_v,232)._shouldForward('dirty');
        const currVal_296:any = i1.ɵnov(_v,232)._shouldForward('valid');
        const currVal_297:any = i1.ɵnov(_v,232)._shouldForward('invalid');
        const currVal_298:any = i1.ɵnov(_v,232)._shouldForward('pending');
        _ck(_v,231,1,[currVal_288,currVal_289,currVal_290,currVal_291,currVal_292,
            currVal_293,currVal_294,currVal_295,currVal_296,currVal_297,currVal_298]);
        const currVal_300:any = i1.ɵnov(_v,246).ngClassUntouched;
        const currVal_301:any = i1.ɵnov(_v,246).ngClassTouched;
        const currVal_302:any = i1.ɵnov(_v,246).ngClassPristine;
        const currVal_303:any = i1.ɵnov(_v,246).ngClassDirty;
        const currVal_304:any = i1.ɵnov(_v,246).ngClassValid;
        const currVal_305:any = i1.ɵnov(_v,246).ngClassInvalid;
        const currVal_306:any = i1.ɵnov(_v,246).ngClassPending;
        const currVal_307:any = true;
        const currVal_308:any = i1.ɵnov(_v,247).id;
        const currVal_309:any = i1.ɵnov(_v,247).placeholder;
        const currVal_310:any = i1.ɵnov(_v,247).disabled;
        const currVal_311:any = i1.ɵnov(_v,247).required;
        const currVal_312:any = (i1.ɵnov(_v,247).ariaDescribedby || (null as any));
        _ck(_v,241,1,[currVal_300,currVal_301,currVal_302,currVal_303,currVal_304,
            currVal_305,currVal_306,currVal_307,currVal_308,currVal_309,currVal_310,
            currVal_311,currVal_312]);
        const currVal_315:any = (null as any);
        const currVal_316:any = true;
        const currVal_317:any = i1.ɵnov(_v,252)._isErrorState();
        const currVal_318:any = i1.ɵnov(_v,252)._mdInputChild.focused;
        const currVal_319:any = i1.ɵnov(_v,252)._shouldForward('untouched');
        const currVal_320:any = i1.ɵnov(_v,252)._shouldForward('touched');
        const currVal_321:any = i1.ɵnov(_v,252)._shouldForward('pristine');
        const currVal_322:any = i1.ɵnov(_v,252)._shouldForward('dirty');
        const currVal_323:any = i1.ɵnov(_v,252)._shouldForward('valid');
        const currVal_324:any = i1.ɵnov(_v,252)._shouldForward('invalid');
        const currVal_325:any = i1.ɵnov(_v,252)._shouldForward('pending');
        _ck(_v,251,1,[currVal_315,currVal_316,currVal_317,currVal_318,currVal_319,
            currVal_320,currVal_321,currVal_322,currVal_323,currVal_324,currVal_325]);
        const currVal_327:any = i1.ɵnov(_v,266).ngClassUntouched;
        const currVal_328:any = i1.ɵnov(_v,266).ngClassTouched;
        const currVal_329:any = i1.ɵnov(_v,266).ngClassPristine;
        const currVal_330:any = i1.ɵnov(_v,266).ngClassDirty;
        const currVal_331:any = i1.ɵnov(_v,266).ngClassValid;
        const currVal_332:any = i1.ɵnov(_v,266).ngClassInvalid;
        const currVal_333:any = i1.ɵnov(_v,266).ngClassPending;
        const currVal_334:any = true;
        const currVal_335:any = i1.ɵnov(_v,267).id;
        const currVal_336:any = i1.ɵnov(_v,267).placeholder;
        const currVal_337:any = i1.ɵnov(_v,267).disabled;
        const currVal_338:any = i1.ɵnov(_v,267).required;
        const currVal_339:any = (i1.ɵnov(_v,267).ariaDescribedby || (null as any));
        _ck(_v,261,1,[currVal_327,currVal_328,currVal_329,currVal_330,currVal_331,
            currVal_332,currVal_333,currVal_334,currVal_335,currVal_336,currVal_337,
            currVal_338,currVal_339]);
        const currVal_348:any = (null as any);
        const currVal_349:any = true;
        const currVal_350:any = i1.ɵnov(_v,278)._isErrorState();
        const currVal_351:any = i1.ɵnov(_v,278)._mdInputChild.focused;
        const currVal_352:any = i1.ɵnov(_v,278)._shouldForward('untouched');
        const currVal_353:any = i1.ɵnov(_v,278)._shouldForward('touched');
        const currVal_354:any = i1.ɵnov(_v,278)._shouldForward('pristine');
        const currVal_355:any = i1.ɵnov(_v,278)._shouldForward('dirty');
        const currVal_356:any = i1.ɵnov(_v,278)._shouldForward('valid');
        const currVal_357:any = i1.ɵnov(_v,278)._shouldForward('invalid');
        const currVal_358:any = i1.ɵnov(_v,278)._shouldForward('pending');
        _ck(_v,277,1,[currVal_348,currVal_349,currVal_350,currVal_351,currVal_352,
            currVal_353,currVal_354,currVal_355,currVal_356,currVal_357,currVal_358]);
        const currVal_360:any = i1.ɵnov(_v,292).ngClassUntouched;
        const currVal_361:any = i1.ɵnov(_v,292).ngClassTouched;
        const currVal_362:any = i1.ɵnov(_v,292).ngClassPristine;
        const currVal_363:any = i1.ɵnov(_v,292).ngClassDirty;
        const currVal_364:any = i1.ɵnov(_v,292).ngClassValid;
        const currVal_365:any = i1.ɵnov(_v,292).ngClassInvalid;
        const currVal_366:any = i1.ɵnov(_v,292).ngClassPending;
        const currVal_367:any = true;
        const currVal_368:any = i1.ɵnov(_v,293).id;
        const currVal_369:any = i1.ɵnov(_v,293).placeholder;
        const currVal_370:any = i1.ɵnov(_v,293).disabled;
        const currVal_371:any = i1.ɵnov(_v,293).required;
        const currVal_372:any = (i1.ɵnov(_v,293).ariaDescribedby || (null as any));
        _ck(_v,287,1,[currVal_360,currVal_361,currVal_362,currVal_363,currVal_364,
            currVal_365,currVal_366,currVal_367,currVal_368,currVal_369,currVal_370,
            currVal_371,currVal_372]);
        const currVal_375:any = (null as any);
        const currVal_376:any = true;
        const currVal_377:any = i1.ɵnov(_v,298)._isErrorState();
        const currVal_378:any = i1.ɵnov(_v,298)._mdInputChild.focused;
        const currVal_379:any = i1.ɵnov(_v,298)._shouldForward('untouched');
        const currVal_380:any = i1.ɵnov(_v,298)._shouldForward('touched');
        const currVal_381:any = i1.ɵnov(_v,298)._shouldForward('pristine');
        const currVal_382:any = i1.ɵnov(_v,298)._shouldForward('dirty');
        const currVal_383:any = i1.ɵnov(_v,298)._shouldForward('valid');
        const currVal_384:any = i1.ɵnov(_v,298)._shouldForward('invalid');
        const currVal_385:any = i1.ɵnov(_v,298)._shouldForward('pending');
        _ck(_v,297,1,[currVal_375,currVal_376,currVal_377,currVal_378,currVal_379,
            currVal_380,currVal_381,currVal_382,currVal_383,currVal_384,currVal_385]);
        const currVal_387:any = i1.ɵnov(_v,312).ngClassUntouched;
        const currVal_388:any = i1.ɵnov(_v,312).ngClassTouched;
        const currVal_389:any = i1.ɵnov(_v,312).ngClassPristine;
        const currVal_390:any = i1.ɵnov(_v,312).ngClassDirty;
        const currVal_391:any = i1.ɵnov(_v,312).ngClassValid;
        const currVal_392:any = i1.ɵnov(_v,312).ngClassInvalid;
        const currVal_393:any = i1.ɵnov(_v,312).ngClassPending;
        const currVal_394:any = true;
        const currVal_395:any = i1.ɵnov(_v,313).id;
        const currVal_396:any = i1.ɵnov(_v,313).placeholder;
        const currVal_397:any = i1.ɵnov(_v,313).disabled;
        const currVal_398:any = i1.ɵnov(_v,313).required;
        const currVal_399:any = (i1.ɵnov(_v,313).ariaDescribedby || (null as any));
        _ck(_v,307,1,[currVal_387,currVal_388,currVal_389,currVal_390,currVal_391,
            currVal_392,currVal_393,currVal_394,currVal_395,currVal_396,currVal_397,
            currVal_398,currVal_399]);
        const currVal_403:any = (null as any);
        const currVal_404:any = true;
        const currVal_405:any = i1.ɵnov(_v,318)._isErrorState();
        const currVal_406:any = i1.ɵnov(_v,318)._mdInputChild.focused;
        const currVal_407:any = i1.ɵnov(_v,318)._shouldForward('untouched');
        const currVal_408:any = i1.ɵnov(_v,318)._shouldForward('touched');
        const currVal_409:any = i1.ɵnov(_v,318)._shouldForward('pristine');
        const currVal_410:any = i1.ɵnov(_v,318)._shouldForward('dirty');
        const currVal_411:any = i1.ɵnov(_v,318)._shouldForward('valid');
        const currVal_412:any = i1.ɵnov(_v,318)._shouldForward('invalid');
        const currVal_413:any = i1.ɵnov(_v,318)._shouldForward('pending');
        _ck(_v,317,1,[currVal_403,currVal_404,currVal_405,currVal_406,currVal_407,
            currVal_408,currVal_409,currVal_410,currVal_411,currVal_412,currVal_413]);
        const currVal_415:any = i1.ɵnov(_v,332).ngClassUntouched;
        const currVal_416:any = i1.ɵnov(_v,332).ngClassTouched;
        const currVal_417:any = i1.ɵnov(_v,332).ngClassPristine;
        const currVal_418:any = i1.ɵnov(_v,332).ngClassDirty;
        const currVal_419:any = i1.ɵnov(_v,332).ngClassValid;
        const currVal_420:any = i1.ɵnov(_v,332).ngClassInvalid;
        const currVal_421:any = i1.ɵnov(_v,332).ngClassPending;
        const currVal_422:any = true;
        const currVal_423:any = i1.ɵnov(_v,333).id;
        const currVal_424:any = i1.ɵnov(_v,333).placeholder;
        const currVal_425:any = i1.ɵnov(_v,333).disabled;
        const currVal_426:any = i1.ɵnov(_v,333).required;
        const currVal_427:any = (i1.ɵnov(_v,333).ariaDescribedby || (null as any));
        _ck(_v,327,1,[currVal_415,currVal_416,currVal_417,currVal_418,currVal_419,
            currVal_420,currVal_421,currVal_422,currVal_423,currVal_424,currVal_425,
            currVal_426,currVal_427]);
        const currVal_430:any = (null as any);
        const currVal_431:any = true;
        const currVal_432:any = i1.ɵnov(_v,338)._isErrorState();
        const currVal_433:any = i1.ɵnov(_v,338)._mdInputChild.focused;
        const currVal_434:any = i1.ɵnov(_v,338)._shouldForward('untouched');
        const currVal_435:any = i1.ɵnov(_v,338)._shouldForward('touched');
        const currVal_436:any = i1.ɵnov(_v,338)._shouldForward('pristine');
        const currVal_437:any = i1.ɵnov(_v,338)._shouldForward('dirty');
        const currVal_438:any = i1.ɵnov(_v,338)._shouldForward('valid');
        const currVal_439:any = i1.ɵnov(_v,338)._shouldForward('invalid');
        const currVal_440:any = i1.ɵnov(_v,338)._shouldForward('pending');
        _ck(_v,337,1,[currVal_430,currVal_431,currVal_432,currVal_433,currVal_434,
            currVal_435,currVal_436,currVal_437,currVal_438,currVal_439,currVal_440]);
        const currVal_442:any = i1.ɵnov(_v,352).ngClassUntouched;
        const currVal_443:any = i1.ɵnov(_v,352).ngClassTouched;
        const currVal_444:any = i1.ɵnov(_v,352).ngClassPristine;
        const currVal_445:any = i1.ɵnov(_v,352).ngClassDirty;
        const currVal_446:any = i1.ɵnov(_v,352).ngClassValid;
        const currVal_447:any = i1.ɵnov(_v,352).ngClassInvalid;
        const currVal_448:any = i1.ɵnov(_v,352).ngClassPending;
        const currVal_449:any = true;
        const currVal_450:any = i1.ɵnov(_v,353).id;
        const currVal_451:any = i1.ɵnov(_v,353).placeholder;
        const currVal_452:any = i1.ɵnov(_v,353).disabled;
        const currVal_453:any = i1.ɵnov(_v,353).required;
        const currVal_454:any = (i1.ɵnov(_v,353).ariaDescribedby || (null as any));
        _ck(_v,347,1,[currVal_442,currVal_443,currVal_444,currVal_445,currVal_446,
            currVal_447,currVal_448,currVal_449,currVal_450,currVal_451,currVal_452,
            currVal_453,currVal_454]);
        const currVal_462:any = (null as any);
        const currVal_463:any = true;
        const currVal_464:any = i1.ɵnov(_v,364)._isErrorState();
        const currVal_465:any = i1.ɵnov(_v,364)._mdInputChild.focused;
        const currVal_466:any = i1.ɵnov(_v,364)._shouldForward('untouched');
        const currVal_467:any = i1.ɵnov(_v,364)._shouldForward('touched');
        const currVal_468:any = i1.ɵnov(_v,364)._shouldForward('pristine');
        const currVal_469:any = i1.ɵnov(_v,364)._shouldForward('dirty');
        const currVal_470:any = i1.ɵnov(_v,364)._shouldForward('valid');
        const currVal_471:any = i1.ɵnov(_v,364)._shouldForward('invalid');
        const currVal_472:any = i1.ɵnov(_v,364)._shouldForward('pending');
        _ck(_v,363,1,[currVal_462,currVal_463,currVal_464,currVal_465,currVal_466,
            currVal_467,currVal_468,currVal_469,currVal_470,currVal_471,currVal_472]);
        const currVal_474:any = i1.ɵnov(_v,378).ngClassUntouched;
        const currVal_475:any = i1.ɵnov(_v,378).ngClassTouched;
        const currVal_476:any = i1.ɵnov(_v,378).ngClassPristine;
        const currVal_477:any = i1.ɵnov(_v,378).ngClassDirty;
        const currVal_478:any = i1.ɵnov(_v,378).ngClassValid;
        const currVal_479:any = i1.ɵnov(_v,378).ngClassInvalid;
        const currVal_480:any = i1.ɵnov(_v,378).ngClassPending;
        const currVal_481:any = true;
        const currVal_482:any = i1.ɵnov(_v,379).id;
        const currVal_483:any = i1.ɵnov(_v,379).placeholder;
        const currVal_484:any = i1.ɵnov(_v,379).disabled;
        const currVal_485:any = i1.ɵnov(_v,379).required;
        const currVal_486:any = (i1.ɵnov(_v,379).ariaDescribedby || (null as any));
        _ck(_v,373,1,[currVal_474,currVal_475,currVal_476,currVal_477,currVal_478,
            currVal_479,currVal_480,currVal_481,currVal_482,currVal_483,currVal_484,
            currVal_485,currVal_486]);
        const currVal_489:any = _co.currentPo.notes;
        _ck(_v,381,0,currVal_489);
      });
}
function View_PoNewComponent_12(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'md-option',[['role',
      'option']],[[1,'tabindex',0],[2,'mat-selected',(null as any)],[2,'mat-option-multiple',
      (null as any)],[2,'mat-active',(null as any)],[8,'id',0],[1,'aria-selected',
      0],[1,'aria-disabled',0],[2,'mat-option-disabled',(null as any)],[2,'mat-option',
      (null as any)]],[[(null as any),'click'],[(null as any),'keydown']],(_v,en,$event) => {
    var ad:boolean = true;
    if (('click' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,2)._selectViaInteraction()) !== false);
      ad = (pd_0 && ad);
    }
    if (('keydown' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,2)._handleKeydown($event)) !== false);
      ad = (pd_1 && ad);
    }
    return ad;
  },i6.View_MdOption_0,i6.RenderType_MdOption)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(49152,[[169,4]],0,i7.MdOption,[i1.ElementRef,[2,i7.MATERIAL_COMPATIBILITY_MODE]],
          {value:[0,'value']},(null as any)),(_l()(),i1.ɵted(0,['','']))],(_ck,_v) => {
    const currVal_9:any = _v.context.$implicit;
    _ck(_v,2,0,currVal_9);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,2)._getTabIndex();
    const currVal_1:any = i1.ɵnov(_v,2).selected;
    const currVal_2:any = i1.ɵnov(_v,2).multiple;
    const currVal_3:any = i1.ɵnov(_v,2).active;
    const currVal_4:any = i1.ɵnov(_v,2).id;
    const currVal_5:any = i1.ɵnov(_v,2).selected.toString();
    const currVal_6:any = i1.ɵnov(_v,2).disabled.toString();
    const currVal_7:any = i1.ɵnov(_v,2).disabled;
    const currVal_8:any = true;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8);
    const currVal_10:any = _v.context.$implicit;
    _ck(_v,3,0,currVal_10);
  });
}
function View_PoNewComponent_11(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),131,'md-card-content',
      [['fxLayout','column']],[[2,'mat-card-content',(null as any)]],(null as any),
      (null as any),(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(16384,(null as any),0,i7.MdCardContent,([] as any[]),(null as any),(null as any)),
      i1.ɵdid(737280,(null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2],{layout:[0,'layout']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n                '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),79,
          'div',[['class','padded-container'],['fxLayout','row'],['fxLayout.lt-md',
              'column'],['fxLayoutGap','30px'],['fxLayoutGap.lt-md','14px']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(737280,
          (null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2],
          {layout:[0,'layout'],layoutLtMd:[1,'layoutLtMd']},(null as any)),i1.ɵdid(1720320,
          (null as any),0,i4.LayoutGapDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2,
              [2,i2.LayoutDirective]],{gap:[0,'gap'],gapLtMd:[1,'gapLtMd']},(null as any)),
      i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),['\n                    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',[['fxFlex',
          '22%']],[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
          (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,11)._focusInput()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,151,{_mdInputChild:0}),i1.ɵqud(335544320,152,{_placeholderChild:0}),
      i1.ɵqud(603979776,153,{_errorChildren:1}),i1.ɵqud(603979776,154,{_hintChildren:1}),
      i1.ɵqud(603979776,155,{_prefixChildren:1}),i1.ɵqud(603979776,156,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
              (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
              0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
          'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
          'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,21)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,21).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,21)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,21)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('blur' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,26)._onBlur()) !== false);
          ad = (pd_4 && ad);
        }
        if (('focus' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,26)._onFocus()) !== false);
          ad = (pd_5 && ad);
        }
        if (('input' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,26)._onInput()) !== false);
          ad = (pd_6 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_7:any = ((<any>(_co.currentPo.forward_agent_detail = $event)) !== false);
          ad = (pd_7 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[151,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],
          {placeholder:[0,'placeholder']},(null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,
          ['\n                    '])),(_l()(),i1.ɵted((null as any),['\n\n                    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',[['fxFlex',
          '22%']],[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
          (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,31)._focusInput()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,157,{_mdInputChild:0}),i1.ɵqud(335544320,158,{_placeholderChild:0}),
      i1.ɵqud(603979776,159,{_errorChildren:1}),i1.ɵqud(603979776,160,{_hintChildren:1}),
      i1.ɵqud(603979776,161,{_prefixChildren:1}),i1.ɵqud(603979776,162,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput',''],['type','date']],
          [[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
              (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
              [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
                  (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,
                  'required',0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],
              [(null as any),'input'],[(null as any),'blur'],[(null as any),'compositionstart'],
              [(null as any),'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,41)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,41).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,41)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,41)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,46)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,46)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,46)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.currentPo.closing_date = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[157,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],
          {placeholder:[0,'placeholder'],type:[1,'type']},(null as any)),i1.ɵppd(2),
      (_l()(),i1.ɵted(1,['\n                    '])),(_l()(),i1.ɵted((null as any),
          ['\n\n                    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          18,'md-input-container',[['fxFlex','22%']],[[1,'align',0],[2,'mat-input-container',
              (null as any)],[2,'mat-input-invalid',(null as any)],[2,'mat-focused',
              (null as any)],[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
              [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
                  (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],
          [[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,51)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,163,{_mdInputChild:0}),i1.ɵqud(335544320,164,{_placeholderChild:0}),
      i1.ɵqud(603979776,165,{_errorChildren:1}),i1.ɵqud(603979776,166,{_hintChildren:1}),
      i1.ɵqud(603979776,167,{_prefixChildren:1}),i1.ɵqud(603979776,168,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput',''],['type','date']],
          [[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
              (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
              [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
                  (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,
                  'required',0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],
              [(null as any),'input'],[(null as any),'blur'],[(null as any),'compositionstart'],
              [(null as any),'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,61)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,61).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,61)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,61)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,66)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,66)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,66)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.currentPo.sailing_date = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[163,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],
          {placeholder:[0,'placeholder'],type:[1,'type']},(null as any)),i1.ɵppd(2),
      (_l()(),i1.ɵted(1,['\n                    '])),(_l()(),i1.ɵted((null as any),
          ['\n\n                    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          13,'md-select',[['fxFlex','22%'],['name','Transport Way'],['role','listbox']],
          [[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
              (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
              [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)],[1,'tabindex',
                  0],[1,'aria-label',0],[1,'aria-labelledby',0],[1,'aria-required',
                  0],[1,'aria-disabled',0],[1,'aria-invalid',0],[1,'aria-owns',0],
              [2,'mat-select-disabled',(null as any)],[2,'mat-select',(null as any)]],
          [[(null as any),'ngModelChange'],[(null as any),'keydown'],[(null as any),
              'blur']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('keydown' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,75)._handleClosedKeydown($event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,75)._onBlur()) !== false);
              ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_2:any = ((<any>(_co.currentPo.transport_way = $event)) !== false);
              ad = (pd_2 && ad);
            }
            return ad;
          },i6.View_MdSelect_0,i6.RenderType_MdSelect)),i1.ɵdid(671744,(null as any),
          0,i12.NgModel,[[8,(null as any)],[8,(null as any)],[8,(null as any)],[8,
              (null as any)]],{name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),
      i1.ɵprd(2048,(null as any),i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,
          (null as any),0,i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),
      i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(1294336,(null as any),
          1,i7.MdSelect,[i1.ElementRef,i1.Renderer2,i7.ViewportRuler,i1.ChangeDetectorRef,
              [2,i7.Dir],[2,i12.NgControl],[8,(null as any)]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵqud(603979776,169,{options:1}),i1.ɵppd(2),i1.ɵdid(737280,
          (null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2,
              [3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,'flex']},
          (null as any)),(_l()(),i1.ɵted(0,['\n                        '])),(_l()(),
          i1.ɵand(16777216,(null as any),0,2,(null as any),View_PoNewComponent_12)),
      i1.ɵdid(802816,(null as any),0,i15.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),i1.ɵpid(131072,
          i15.AsyncPipe,[i1.ChangeDetectorRef]),(_l()(),i1.ɵted(0,['\n                    '])),
      (_l()(),i1.ɵted((null as any),['\n                '])),(_l()(),i1.ɵted((null as any),
          ['\n                '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),44,
          'div',[['class','padded-container'],['fxLayout','row'],['fxLayout.lt-md',
              'column'],['fxLayoutGap','30px'],['fxLayoutGap.lt-md','14px']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(737280,
          (null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2],
          {layout:[0,'layout'],layoutLtMd:[1,'layoutLtMd']},(null as any)),i1.ɵdid(1720320,
          (null as any),0,i4.LayoutGapDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2,
              [2,i2.LayoutDirective]],{gap:[0,'gap'],gapLtMd:[1,'gapLtMd']},(null as any)),
      i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),['\n                    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',[['fxFlex',
          '22%']],[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
          (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,92)._focusInput()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,170,{_mdInputChild:0}),i1.ɵqud(335544320,171,{_placeholderChild:0}),
      i1.ɵqud(603979776,172,{_errorChildren:1}),i1.ɵqud(603979776,173,{_hintChildren:1}),
      i1.ɵqud(603979776,174,{_prefixChildren:1}),i1.ɵqud(603979776,175,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
              (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
              0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
          'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
          'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,102)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,102).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,102)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,102)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('blur' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,107)._onBlur()) !== false);
          ad = (pd_4 && ad);
        }
        if (('focus' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,107)._onFocus()) !== false);
          ad = (pd_5 && ad);
        }
        if (('input' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,107)._onInput()) !== false);
          ad = (pd_6 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_7:any = ((<any>(_co.currentPo.place_of_dispatch = $event)) !== false);
          ad = (pd_7 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[170,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],
          {placeholder:[0,'placeholder']},(null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,
          ['\n                    '])),(_l()(),i1.ɵted((null as any),['\n\n                    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',[['fxFlex',
          '22%']],[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
          (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,112)._focusInput()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,176,{_mdInputChild:0}),i1.ɵqud(335544320,177,{_placeholderChild:0}),
      i1.ɵqud(603979776,178,{_errorChildren:1}),i1.ɵqud(603979776,179,{_hintChildren:1}),
      i1.ɵqud(603979776,180,{_prefixChildren:1}),i1.ɵqud(603979776,181,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput',''],['type','date']],
          [[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
              (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
              [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
                  (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,
                  'required',0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],
              [(null as any),'input'],[(null as any),'blur'],[(null as any),'compositionstart'],
              [(null as any),'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,122)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,122).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,122)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,122)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,127)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,127)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,127)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.currentPo.actual_arrival_date = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[176,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],
          {placeholder:[0,'placeholder'],type:[1,'type']},(null as any)),i1.ɵppd(2),
      (_l()(),i1.ɵted(1,['\n                    '])),(_l()(),i1.ɵted((null as any),
          ['\n\n                '])),(_l()(),i1.ɵted((null as any),['\n            ']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_1:any = 'column';
        _ck(_v,3,0,currVal_1);
        const currVal_2:any = 'row';
        const currVal_3:any = 'column';
        _ck(_v,6,0,currVal_2,currVal_3);
        const currVal_4:any = '30px';
        const currVal_5:any = '14px';
        _ck(_v,7,0,currVal_4,currVal_5);
        const currVal_6:any = 'padded-container';
        _ck(_v,8,0,currVal_6);
        const currVal_18:any = '22%';
        _ck(_v,18,0,currVal_18);
        const currVal_32:any = _co.currentPo.forward_agent_detail;
        _ck(_v,23,0,currVal_32);
        const currVal_33:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,26,0,_ck(_v,27,
            0,i1.ɵnov((<any>_v.parent),0),'fwd_agent_detail',_co._authService.getLanguage())),
            '');
        _ck(_v,26,0,currVal_33);
        const currVal_45:any = '22%';
        _ck(_v,38,0,currVal_45);
        const currVal_59:any = _co.currentPo.closing_date;
        _ck(_v,43,0,currVal_59);
        const currVal_60:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,46,0,_ck(_v,47,
            0,i1.ɵnov((<any>_v.parent),0),'closing_date',_co._authService.getLanguage())),
            '');
        const currVal_61:any = 'date';
        _ck(_v,46,0,currVal_60,currVal_61);
        const currVal_73:any = '22%';
        _ck(_v,58,0,currVal_73);
        const currVal_87:any = _co.currentPo.sailing_date;
        _ck(_v,63,0,currVal_87);
        const currVal_88:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,66,0,_ck(_v,67,
            0,i1.ɵnov((<any>_v.parent),0),'sailing_date',_co._authService.getLanguage())),
            '');
        const currVal_89:any = 'date';
        _ck(_v,66,0,currVal_88,currVal_89);
        const currVal_106:any = 'Transport Way';
        const currVal_107:any = _co.currentPo.transport_way;
        _ck(_v,71,0,currVal_106,currVal_107);
        const currVal_108:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,75,0,_ck(_v,
            77,0,i1.ɵnov((<any>_v.parent),0),'transport_way',_co._authService.getLanguage())),
            '');
        _ck(_v,75,0,currVal_108);
        const currVal_109:any = '22%';
        _ck(_v,78,0,currVal_109);
        const currVal_110:any = i1.ɵunv(_v,81,0,i1.ɵnov(_v,82).transform(_co.allTransportWays$));
        _ck(_v,81,0,currVal_110);
        const currVal_111:any = 'row';
        const currVal_112:any = 'column';
        _ck(_v,87,0,currVal_111,currVal_112);
        const currVal_113:any = '30px';
        const currVal_114:any = '14px';
        _ck(_v,88,0,currVal_113,currVal_114);
        const currVal_115:any = 'padded-container';
        _ck(_v,89,0,currVal_115);
        const currVal_127:any = '22%';
        _ck(_v,99,0,currVal_127);
        const currVal_141:any = _co.currentPo.place_of_dispatch;
        _ck(_v,104,0,currVal_141);
        const currVal_142:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,107,0,_ck(_v,
            108,0,i1.ɵnov((<any>_v.parent),0),'place_of_dispatch',_co._authService.getLanguage())),
            '');
        _ck(_v,107,0,currVal_142);
        const currVal_154:any = '22%';
        _ck(_v,119,0,currVal_154);
        const currVal_168:any = _co.currentPo.actual_arrival_date;
        _ck(_v,124,0,currVal_168);
        const currVal_169:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,127,0,_ck(_v,
            128,0,i1.ɵnov((<any>_v.parent),0),'actual_arrival_date',_co._authService.getLanguage())),
            '');
        const currVal_170:any = 'date';
        _ck(_v,127,0,currVal_169,currVal_170);
      },(_ck,_v) => {
        const currVal_0:any = true;
        _ck(_v,0,0,currVal_0);
        const currVal_7:any = (null as any);
        const currVal_8:any = true;
        const currVal_9:any = i1.ɵnov(_v,11)._isErrorState();
        const currVal_10:any = i1.ɵnov(_v,11)._mdInputChild.focused;
        const currVal_11:any = i1.ɵnov(_v,11)._shouldForward('untouched');
        const currVal_12:any = i1.ɵnov(_v,11)._shouldForward('touched');
        const currVal_13:any = i1.ɵnov(_v,11)._shouldForward('pristine');
        const currVal_14:any = i1.ɵnov(_v,11)._shouldForward('dirty');
        const currVal_15:any = i1.ɵnov(_v,11)._shouldForward('valid');
        const currVal_16:any = i1.ɵnov(_v,11)._shouldForward('invalid');
        const currVal_17:any = i1.ɵnov(_v,11)._shouldForward('pending');
        _ck(_v,10,1,[currVal_7,currVal_8,currVal_9,currVal_10,currVal_11,currVal_12,
            currVal_13,currVal_14,currVal_15,currVal_16,currVal_17]);
        const currVal_19:any = i1.ɵnov(_v,25).ngClassUntouched;
        const currVal_20:any = i1.ɵnov(_v,25).ngClassTouched;
        const currVal_21:any = i1.ɵnov(_v,25).ngClassPristine;
        const currVal_22:any = i1.ɵnov(_v,25).ngClassDirty;
        const currVal_23:any = i1.ɵnov(_v,25).ngClassValid;
        const currVal_24:any = i1.ɵnov(_v,25).ngClassInvalid;
        const currVal_25:any = i1.ɵnov(_v,25).ngClassPending;
        const currVal_26:any = true;
        const currVal_27:any = i1.ɵnov(_v,26).id;
        const currVal_28:any = i1.ɵnov(_v,26).placeholder;
        const currVal_29:any = i1.ɵnov(_v,26).disabled;
        const currVal_30:any = i1.ɵnov(_v,26).required;
        const currVal_31:any = (i1.ɵnov(_v,26).ariaDescribedby || (null as any));
        _ck(_v,20,1,[currVal_19,currVal_20,currVal_21,currVal_22,currVal_23,currVal_24,
            currVal_25,currVal_26,currVal_27,currVal_28,currVal_29,currVal_30,currVal_31]);
        const currVal_34:any = (null as any);
        const currVal_35:any = true;
        const currVal_36:any = i1.ɵnov(_v,31)._isErrorState();
        const currVal_37:any = i1.ɵnov(_v,31)._mdInputChild.focused;
        const currVal_38:any = i1.ɵnov(_v,31)._shouldForward('untouched');
        const currVal_39:any = i1.ɵnov(_v,31)._shouldForward('touched');
        const currVal_40:any = i1.ɵnov(_v,31)._shouldForward('pristine');
        const currVal_41:any = i1.ɵnov(_v,31)._shouldForward('dirty');
        const currVal_42:any = i1.ɵnov(_v,31)._shouldForward('valid');
        const currVal_43:any = i1.ɵnov(_v,31)._shouldForward('invalid');
        const currVal_44:any = i1.ɵnov(_v,31)._shouldForward('pending');
        _ck(_v,30,1,[currVal_34,currVal_35,currVal_36,currVal_37,currVal_38,currVal_39,
            currVal_40,currVal_41,currVal_42,currVal_43,currVal_44]);
        const currVal_46:any = i1.ɵnov(_v,45).ngClassUntouched;
        const currVal_47:any = i1.ɵnov(_v,45).ngClassTouched;
        const currVal_48:any = i1.ɵnov(_v,45).ngClassPristine;
        const currVal_49:any = i1.ɵnov(_v,45).ngClassDirty;
        const currVal_50:any = i1.ɵnov(_v,45).ngClassValid;
        const currVal_51:any = i1.ɵnov(_v,45).ngClassInvalid;
        const currVal_52:any = i1.ɵnov(_v,45).ngClassPending;
        const currVal_53:any = true;
        const currVal_54:any = i1.ɵnov(_v,46).id;
        const currVal_55:any = i1.ɵnov(_v,46).placeholder;
        const currVal_56:any = i1.ɵnov(_v,46).disabled;
        const currVal_57:any = i1.ɵnov(_v,46).required;
        const currVal_58:any = (i1.ɵnov(_v,46).ariaDescribedby || (null as any));
        _ck(_v,40,1,[currVal_46,currVal_47,currVal_48,currVal_49,currVal_50,currVal_51,
            currVal_52,currVal_53,currVal_54,currVal_55,currVal_56,currVal_57,currVal_58]);
        const currVal_62:any = (null as any);
        const currVal_63:any = true;
        const currVal_64:any = i1.ɵnov(_v,51)._isErrorState();
        const currVal_65:any = i1.ɵnov(_v,51)._mdInputChild.focused;
        const currVal_66:any = i1.ɵnov(_v,51)._shouldForward('untouched');
        const currVal_67:any = i1.ɵnov(_v,51)._shouldForward('touched');
        const currVal_68:any = i1.ɵnov(_v,51)._shouldForward('pristine');
        const currVal_69:any = i1.ɵnov(_v,51)._shouldForward('dirty');
        const currVal_70:any = i1.ɵnov(_v,51)._shouldForward('valid');
        const currVal_71:any = i1.ɵnov(_v,51)._shouldForward('invalid');
        const currVal_72:any = i1.ɵnov(_v,51)._shouldForward('pending');
        _ck(_v,50,1,[currVal_62,currVal_63,currVal_64,currVal_65,currVal_66,currVal_67,
            currVal_68,currVal_69,currVal_70,currVal_71,currVal_72]);
        const currVal_74:any = i1.ɵnov(_v,65).ngClassUntouched;
        const currVal_75:any = i1.ɵnov(_v,65).ngClassTouched;
        const currVal_76:any = i1.ɵnov(_v,65).ngClassPristine;
        const currVal_77:any = i1.ɵnov(_v,65).ngClassDirty;
        const currVal_78:any = i1.ɵnov(_v,65).ngClassValid;
        const currVal_79:any = i1.ɵnov(_v,65).ngClassInvalid;
        const currVal_80:any = i1.ɵnov(_v,65).ngClassPending;
        const currVal_81:any = true;
        const currVal_82:any = i1.ɵnov(_v,66).id;
        const currVal_83:any = i1.ɵnov(_v,66).placeholder;
        const currVal_84:any = i1.ɵnov(_v,66).disabled;
        const currVal_85:any = i1.ɵnov(_v,66).required;
        const currVal_86:any = (i1.ɵnov(_v,66).ariaDescribedby || (null as any));
        _ck(_v,60,1,[currVal_74,currVal_75,currVal_76,currVal_77,currVal_78,currVal_79,
            currVal_80,currVal_81,currVal_82,currVal_83,currVal_84,currVal_85,currVal_86]);
        const currVal_90:any = i1.ɵnov(_v,73).ngClassUntouched;
        const currVal_91:any = i1.ɵnov(_v,73).ngClassTouched;
        const currVal_92:any = i1.ɵnov(_v,73).ngClassPristine;
        const currVal_93:any = i1.ɵnov(_v,73).ngClassDirty;
        const currVal_94:any = i1.ɵnov(_v,73).ngClassValid;
        const currVal_95:any = i1.ɵnov(_v,73).ngClassInvalid;
        const currVal_96:any = i1.ɵnov(_v,73).ngClassPending;
        const currVal_97:any = i1.ɵnov(_v,75).tabIndex;
        const currVal_98:any = i1.ɵnov(_v,75)._ariaLabel;
        const currVal_99:any = i1.ɵnov(_v,75).ariaLabelledby;
        const currVal_100:any = i1.ɵnov(_v,75).required.toString();
        const currVal_101:any = i1.ɵnov(_v,75).disabled.toString();
        const currVal_102:any = (((i1.ɵnov(_v,75)._control == null)? (null as any): i1.ɵnov(_v,
            75)._control.invalid) || 'false');
        const currVal_103:any = i1.ɵnov(_v,75)._optionIds;
        const currVal_104:any = i1.ɵnov(_v,75).disabled;
        const currVal_105:any = true;
        _ck(_v,70,1,[currVal_90,currVal_91,currVal_92,currVal_93,currVal_94,currVal_95,
            currVal_96,currVal_97,currVal_98,currVal_99,currVal_100,currVal_101,currVal_102,
            currVal_103,currVal_104,currVal_105]);
        const currVal_116:any = (null as any);
        const currVal_117:any = true;
        const currVal_118:any = i1.ɵnov(_v,92)._isErrorState();
        const currVal_119:any = i1.ɵnov(_v,92)._mdInputChild.focused;
        const currVal_120:any = i1.ɵnov(_v,92)._shouldForward('untouched');
        const currVal_121:any = i1.ɵnov(_v,92)._shouldForward('touched');
        const currVal_122:any = i1.ɵnov(_v,92)._shouldForward('pristine');
        const currVal_123:any = i1.ɵnov(_v,92)._shouldForward('dirty');
        const currVal_124:any = i1.ɵnov(_v,92)._shouldForward('valid');
        const currVal_125:any = i1.ɵnov(_v,92)._shouldForward('invalid');
        const currVal_126:any = i1.ɵnov(_v,92)._shouldForward('pending');
        _ck(_v,91,1,[currVal_116,currVal_117,currVal_118,currVal_119,currVal_120,currVal_121,
            currVal_122,currVal_123,currVal_124,currVal_125,currVal_126]);
        const currVal_128:any = i1.ɵnov(_v,106).ngClassUntouched;
        const currVal_129:any = i1.ɵnov(_v,106).ngClassTouched;
        const currVal_130:any = i1.ɵnov(_v,106).ngClassPristine;
        const currVal_131:any = i1.ɵnov(_v,106).ngClassDirty;
        const currVal_132:any = i1.ɵnov(_v,106).ngClassValid;
        const currVal_133:any = i1.ɵnov(_v,106).ngClassInvalid;
        const currVal_134:any = i1.ɵnov(_v,106).ngClassPending;
        const currVal_135:any = true;
        const currVal_136:any = i1.ɵnov(_v,107).id;
        const currVal_137:any = i1.ɵnov(_v,107).placeholder;
        const currVal_138:any = i1.ɵnov(_v,107).disabled;
        const currVal_139:any = i1.ɵnov(_v,107).required;
        const currVal_140:any = (i1.ɵnov(_v,107).ariaDescribedby || (null as any));
        _ck(_v,101,1,[currVal_128,currVal_129,currVal_130,currVal_131,currVal_132,
            currVal_133,currVal_134,currVal_135,currVal_136,currVal_137,currVal_138,
            currVal_139,currVal_140]);
        const currVal_143:any = (null as any);
        const currVal_144:any = true;
        const currVal_145:any = i1.ɵnov(_v,112)._isErrorState();
        const currVal_146:any = i1.ɵnov(_v,112)._mdInputChild.focused;
        const currVal_147:any = i1.ɵnov(_v,112)._shouldForward('untouched');
        const currVal_148:any = i1.ɵnov(_v,112)._shouldForward('touched');
        const currVal_149:any = i1.ɵnov(_v,112)._shouldForward('pristine');
        const currVal_150:any = i1.ɵnov(_v,112)._shouldForward('dirty');
        const currVal_151:any = i1.ɵnov(_v,112)._shouldForward('valid');
        const currVal_152:any = i1.ɵnov(_v,112)._shouldForward('invalid');
        const currVal_153:any = i1.ɵnov(_v,112)._shouldForward('pending');
        _ck(_v,111,1,[currVal_143,currVal_144,currVal_145,currVal_146,currVal_147,
            currVal_148,currVal_149,currVal_150,currVal_151,currVal_152,currVal_153]);
        const currVal_155:any = i1.ɵnov(_v,126).ngClassUntouched;
        const currVal_156:any = i1.ɵnov(_v,126).ngClassTouched;
        const currVal_157:any = i1.ɵnov(_v,126).ngClassPristine;
        const currVal_158:any = i1.ɵnov(_v,126).ngClassDirty;
        const currVal_159:any = i1.ɵnov(_v,126).ngClassValid;
        const currVal_160:any = i1.ɵnov(_v,126).ngClassInvalid;
        const currVal_161:any = i1.ɵnov(_v,126).ngClassPending;
        const currVal_162:any = true;
        const currVal_163:any = i1.ɵnov(_v,127).id;
        const currVal_164:any = i1.ɵnov(_v,127).placeholder;
        const currVal_165:any = i1.ɵnov(_v,127).disabled;
        const currVal_166:any = i1.ɵnov(_v,127).required;
        const currVal_167:any = (i1.ɵnov(_v,127).ariaDescribedby || (null as any));
        _ck(_v,121,1,[currVal_155,currVal_156,currVal_157,currVal_158,currVal_159,
            currVal_160,currVal_161,currVal_162,currVal_163,currVal_164,currVal_165,
            currVal_166,currVal_167]);
      });
}
function View_PoNewComponent_15(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'md-option',[['role',
      'option']],[[1,'tabindex',0],[2,'mat-selected',(null as any)],[2,'mat-option-multiple',
      (null as any)],[2,'mat-active',(null as any)],[8,'id',0],[1,'aria-selected',
      0],[1,'aria-disabled',0],[2,'mat-option-disabled',(null as any)],[2,'mat-option',
      (null as any)]],[[(null as any),'click'],[(null as any),'keydown']],(_v,en,$event) => {
    var ad:boolean = true;
    if (('click' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,2)._selectViaInteraction()) !== false);
      ad = (pd_0 && ad);
    }
    if (('keydown' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,2)._handleKeydown($event)) !== false);
      ad = (pd_1 && ad);
    }
    return ad;
  },i6.View_MdOption_0,i6.RenderType_MdOption)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(49152,[[188,4]],0,i7.MdOption,[i1.ElementRef,[2,i7.MATERIAL_COMPATIBILITY_MODE]],
          {value:[0,'value']},(null as any)),(_l()(),i1.ɵted(0,['','/','']))],(_ck,
      _v) => {
    const currVal_9:any = _v.context.$implicit;
    _ck(_v,2,0,currVal_9);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,2)._getTabIndex();
    const currVal_1:any = i1.ɵnov(_v,2).selected;
    const currVal_2:any = i1.ɵnov(_v,2).multiple;
    const currVal_3:any = i1.ɵnov(_v,2).active;
    const currVal_4:any = i1.ɵnov(_v,2).id;
    const currVal_5:any = i1.ɵnov(_v,2).selected.toString();
    const currVal_6:any = i1.ɵnov(_v,2).disabled.toString();
    const currVal_7:any = i1.ɵnov(_v,2).disabled;
    const currVal_8:any = true;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8);
    const currVal_10:any = _v.context.$implicit.design_name;
    const currVal_11:any = _v.context.$implicit.color_name;
    _ck(_v,3,0,currVal_10,currVal_11);
  });
}
function View_PoNewComponent_14(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),91,'div',[['class',
      'padded-container'],['fxLayout','row'],['fxLayout.lt-md','column'],['fxLayoutGap',
      '30px'],['fxLayoutGap.lt-md','14px']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),i1.ɵdid(737280,(null as any),0,i2.LayoutDirective,
      [i3.MediaMonitor,i1.ElementRef,i1.Renderer2],{layout:[0,'layout'],layoutLtMd:[1,
          'layoutLtMd']},(null as any)),i1.ɵdid(1720320,(null as any),0,i4.LayoutGapDirective,
      [i3.MediaMonitor,i1.ElementRef,i1.Renderer2,[2,i2.LayoutDirective]],{gap:[0,
          'gap'],gapLtMd:[1,'gapLtMd']},(null as any)),i1.ɵdid(933888,(null as any),
      0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,
          i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),
      i1.ɵted((null as any),['\n                    '])),(_l()(),i1.ɵted((null as any),
      ['\n                    '])),(_l()(),i1.ɵted((null as any),['\n                    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',[['fxFlex',
          '22%']],[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
          (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,8)._focusInput()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,182,{_mdInputChild:0}),i1.ɵqud(335544320,183,{_placeholderChild:0}),
      i1.ɵqud(603979776,184,{_errorChildren:1}),i1.ɵqud(603979776,185,{_hintChildren:1}),
      i1.ɵqud(603979776,186,{_prefixChildren:1}),i1.ɵqud(603979776,187,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput',''],['readonly','']],
          [[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
              (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
              [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
                  (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,
                  'required',0],[1,'aria-describedby',0]],[[(null as any),'input'],
              [(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
                  'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,18)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,18).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,18)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,18)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,23)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,23)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,23)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},(null as any)),i1.ɵprd(2048,(null as any),i12.NgControl,
          (null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,i12.NgControlStatus,
          [i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[182,4]],0,i7.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,['\n                    '])),
      (_l()(),i1.ɵted((null as any),['\n\n                    '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),14,'md-select',[['fxFlex','22%'],['name','designColor'],
              ['role','listbox']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',
              (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
              [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
                  (null as any)],[1,'tabindex',0],[1,'aria-label',0],[1,'aria-labelledby',
                  0],[1,'aria-required',0],[1,'aria-disabled',0],[1,'aria-invalid',
                  0],[1,'aria-owns',0],[2,'mat-select-disabled',(null as any)],[2,
                  'mat-select',(null as any)]],[[(null as any),'ngModelChange'],[(null as any),
              'keydown'],[(null as any),'blur']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('keydown' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,32)._handleClosedKeydown($event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,32)._onBlur()) !== false);
              ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_2:any = ((<any>(_co.design = $event)) !== false);
              ad = (pd_2 && ad);
            }
            if (('ngModelChange' === en)) {
              _co.collection = $event.collection_name;
              const pd_3:any = ((<any>(_co.unit_type = $event.unit_type)) !== false);
              ad = (pd_3 && ad);
            }
            return ad;
          },i6.View_MdSelect_0,i6.RenderType_MdSelect)),i1.ɵdid(671744,(null as any),
          0,i12.NgModel,[[8,(null as any)],[8,(null as any)],[8,(null as any)],[8,
              (null as any)]],{name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),
      i1.ɵprd(2048,(null as any),i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,
          (null as any),0,i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),
      i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(1294336,(null as any),
          1,i7.MdSelect,[i1.ElementRef,i1.Renderer2,i7.ViewportRuler,i1.ChangeDetectorRef,
              [2,i7.Dir],[2,i12.NgControl],[8,(null as any)]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵqud(603979776,188,{options:1}),i1.ɵppd(2),i1.ɵppd(2),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(0,['\n                        '])),
      (_l()(),i1.ɵand(16777216,(null as any),0,2,(null as any),View_PoNewComponent_15)),
      i1.ɵdid(802816,(null as any),0,i15.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),i1.ɵpid(131072,
          i15.AsyncPipe,[i1.ChangeDetectorRef]),(_l()(),i1.ɵted(0,['\n                    '])),
      (_l()(),i1.ɵted((null as any),['\n\n                    '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),17,'md-input-container',[['fxFlex','15%']],[[1,
              'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,44)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,189,{_mdInputChild:0}),i1.ɵqud(335544320,190,{_placeholderChild:0}),
      i1.ɵqud(603979776,191,{_errorChildren:1}),i1.ɵqud(603979776,192,{_hintChildren:1}),
      i1.ɵqud(603979776,193,{_prefixChildren:1}),i1.ɵqud(603979776,194,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,6,'input',[['mdInput','']],[[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
              (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
              0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
          'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
          'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,54)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,54).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,54)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,54)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('blur' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,59)._onBlur()) !== false);
          ad = (pd_4 && ad);
        }
        if (('focus' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,59)._onFocus()) !== false);
          ad = (pd_5 && ad);
        }
        if (('input' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,59)._onInput()) !== false);
          ad = (pd_6 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_7:any = ((<any>(_co.length = $event)) !== false);
          ad = (pd_7 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[189,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],
          {placeholder:[0,'placeholder']},(null as any)),(_l()(),i1.ɵted(1,['\n                    '])),
      (_l()(),i1.ɵted((null as any),['\n\n                    '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),18,'md-input-container',[['fxFlex','15%']],[[1,
              'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,63)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdInputContainer_0,i6.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i7.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i12.NgForm],[2,i12.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,195,{_mdInputChild:0}),i1.ɵqud(335544320,196,{_placeholderChild:0}),
      i1.ɵqud(603979776,197,{_errorChildren:1}),i1.ɵqud(603979776,198,{_hintChildren:1}),
      i1.ɵqud(603979776,199,{_prefixChildren:1}),i1.ɵqud(603979776,200,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
              (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
              0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
          'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
          'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,73)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,73).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,73)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,73)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('blur' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,78)._onBlur()) !== false);
          ad = (pd_4 && ad);
        }
        if (('focus' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,78)._onFocus()) !== false);
          ad = (pd_5 && ad);
        }
        if (('input' === en)) {
          const pd_6:any = ((<any>i1.ɵnov(_v,78)._onInput()) !== false);
          ad = (pd_6 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_7:any = ((<any>(_co.unitPrice = $event)) !== false);
          ad = (pd_7 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i12.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i12.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i12.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i12.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i12.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i12.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i12.NgControl,(null as any),[i12.NgModel]),i1.ɵdid(16384,(null as any),0,
          i12.NgControlStatus,[i12.NgControl],(null as any),(null as any)),i1.ɵdid(16384,
          [[195,4]],0,i7.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i12.NgControl]],
          {placeholder:[0,'placeholder']},(null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,
          ['\n                    '])),(_l()(),i1.ɵted((null as any),['\n\n\n                    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),8,'div',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['\n                        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          5,'button',[['class','bg-blue color-white mat-button'],['color','primary'],
              ['md-button','']],[[8,'disabled',0]],[[(null as any),'click']],(_v,en,
              $event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.addItemToList()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdButton_0,i6.RenderType_MdButton)),i1.ɵdid(16384,(null as any),
          0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(180224,(null as any),0,i7.MdButton,
          [i1.ElementRef,i1.Renderer2,i7.Platform,i7.FocusOriginMonitor],{color:[0,
              'color']},(null as any)),i1.ɵdid(16384,(null as any),0,i7.MdButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,(null as any),
          0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(0,['ADD'])),(_l()(),i1.ɵted((null as any),
          ['\n                    '])),(_l()(),i1.ɵted((null as any),['\n                ']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = 'row';
        const currVal_1:any = 'column';
        _ck(_v,1,0,currVal_0,currVal_1);
        const currVal_2:any = '30px';
        const currVal_3:any = '14px';
        _ck(_v,2,0,currVal_2,currVal_3);
        const currVal_4:any = 'padded-container';
        _ck(_v,3,0,currVal_4);
        const currVal_16:any = '22%';
        _ck(_v,15,0,currVal_16);
        const currVal_30:any = _co.collection;
        _ck(_v,20,0,currVal_30);
        const currVal_31:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,23,0,_ck(_v,24,
            0,i1.ɵnov((<any>(<any>_v.parent).parent),0),'collections',_co._authService.getLanguage())),
            ' ');
        _ck(_v,23,0,currVal_31);
        const currVal_48:any = 'designColor';
        const currVal_49:any = _co.design;
        _ck(_v,28,0,currVal_48,currVal_49);
        const currVal_50:any = i1.ɵinlineInterpolate(2,'',i1.ɵunv(_v,32,0,_ck(_v,34,
            0,i1.ɵnov((<any>(<any>_v.parent).parent),0),'design',_co._authService.getLanguage())),
            ' / ',i1.ɵunv(_v,32,0,_ck(_v,35,0,i1.ɵnov((<any>(<any>_v.parent).parent),
                0),'color',_co._authService.getLanguage())),'');
        _ck(_v,32,0,currVal_50);
        const currVal_51:any = '22%';
        _ck(_v,36,0,currVal_51);
        const currVal_52:any = i1.ɵunv(_v,39,0,i1.ɵnov(_v,40).transform(_co.allDesignColors$));
        _ck(_v,39,0,currVal_52);
        const currVal_64:any = '15%';
        _ck(_v,51,0,currVal_64);
        const currVal_78:any = _co.length;
        _ck(_v,56,0,currVal_78);
        const currVal_79:any = i1.ɵinlineInterpolate(1,'',_co.getUnit(_co.unit_type),
            ' ');
        _ck(_v,59,0,currVal_79);
        const currVal_91:any = '15%';
        _ck(_v,70,0,currVal_91);
        const currVal_105:any = _co.unitPrice;
        _ck(_v,75,0,currVal_105);
        const currVal_106:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,78,0,_ck(_v,
            79,0,i1.ɵnov((<any>(<any>_v.parent).parent),0),'unit_price',_co._authService.getLanguage())),
            '');
        _ck(_v,78,0,currVal_106);
        const currVal_108:any = 'primary';
        _ck(_v,86,0,currVal_108);
        const currVal_109:any = 'bg-blue color-white';
        _ck(_v,88,0,currVal_109);
      },(_ck,_v) => {
        const currVal_5:any = (null as any);
        const currVal_6:any = true;
        const currVal_7:any = i1.ɵnov(_v,8)._isErrorState();
        const currVal_8:any = i1.ɵnov(_v,8)._mdInputChild.focused;
        const currVal_9:any = i1.ɵnov(_v,8)._shouldForward('untouched');
        const currVal_10:any = i1.ɵnov(_v,8)._shouldForward('touched');
        const currVal_11:any = i1.ɵnov(_v,8)._shouldForward('pristine');
        const currVal_12:any = i1.ɵnov(_v,8)._shouldForward('dirty');
        const currVal_13:any = i1.ɵnov(_v,8)._shouldForward('valid');
        const currVal_14:any = i1.ɵnov(_v,8)._shouldForward('invalid');
        const currVal_15:any = i1.ɵnov(_v,8)._shouldForward('pending');
        _ck(_v,7,1,[currVal_5,currVal_6,currVal_7,currVal_8,currVal_9,currVal_10,currVal_11,
            currVal_12,currVal_13,currVal_14,currVal_15]);
        const currVal_17:any = i1.ɵnov(_v,22).ngClassUntouched;
        const currVal_18:any = i1.ɵnov(_v,22).ngClassTouched;
        const currVal_19:any = i1.ɵnov(_v,22).ngClassPristine;
        const currVal_20:any = i1.ɵnov(_v,22).ngClassDirty;
        const currVal_21:any = i1.ɵnov(_v,22).ngClassValid;
        const currVal_22:any = i1.ɵnov(_v,22).ngClassInvalid;
        const currVal_23:any = i1.ɵnov(_v,22).ngClassPending;
        const currVal_24:any = true;
        const currVal_25:any = i1.ɵnov(_v,23).id;
        const currVal_26:any = i1.ɵnov(_v,23).placeholder;
        const currVal_27:any = i1.ɵnov(_v,23).disabled;
        const currVal_28:any = i1.ɵnov(_v,23).required;
        const currVal_29:any = (i1.ɵnov(_v,23).ariaDescribedby || (null as any));
        _ck(_v,17,1,[currVal_17,currVal_18,currVal_19,currVal_20,currVal_21,currVal_22,
            currVal_23,currVal_24,currVal_25,currVal_26,currVal_27,currVal_28,currVal_29]);
        const currVal_32:any = i1.ɵnov(_v,30).ngClassUntouched;
        const currVal_33:any = i1.ɵnov(_v,30).ngClassTouched;
        const currVal_34:any = i1.ɵnov(_v,30).ngClassPristine;
        const currVal_35:any = i1.ɵnov(_v,30).ngClassDirty;
        const currVal_36:any = i1.ɵnov(_v,30).ngClassValid;
        const currVal_37:any = i1.ɵnov(_v,30).ngClassInvalid;
        const currVal_38:any = i1.ɵnov(_v,30).ngClassPending;
        const currVal_39:any = i1.ɵnov(_v,32).tabIndex;
        const currVal_40:any = i1.ɵnov(_v,32)._ariaLabel;
        const currVal_41:any = i1.ɵnov(_v,32).ariaLabelledby;
        const currVal_42:any = i1.ɵnov(_v,32).required.toString();
        const currVal_43:any = i1.ɵnov(_v,32).disabled.toString();
        const currVal_44:any = (((i1.ɵnov(_v,32)._control == null)? (null as any): i1.ɵnov(_v,
            32)._control.invalid) || 'false');
        const currVal_45:any = i1.ɵnov(_v,32)._optionIds;
        const currVal_46:any = i1.ɵnov(_v,32).disabled;
        const currVal_47:any = true;
        _ck(_v,27,1,[currVal_32,currVal_33,currVal_34,currVal_35,currVal_36,currVal_37,
            currVal_38,currVal_39,currVal_40,currVal_41,currVal_42,currVal_43,currVal_44,
            currVal_45,currVal_46,currVal_47]);
        const currVal_53:any = (null as any);
        const currVal_54:any = true;
        const currVal_55:any = i1.ɵnov(_v,44)._isErrorState();
        const currVal_56:any = i1.ɵnov(_v,44)._mdInputChild.focused;
        const currVal_57:any = i1.ɵnov(_v,44)._shouldForward('untouched');
        const currVal_58:any = i1.ɵnov(_v,44)._shouldForward('touched');
        const currVal_59:any = i1.ɵnov(_v,44)._shouldForward('pristine');
        const currVal_60:any = i1.ɵnov(_v,44)._shouldForward('dirty');
        const currVal_61:any = i1.ɵnov(_v,44)._shouldForward('valid');
        const currVal_62:any = i1.ɵnov(_v,44)._shouldForward('invalid');
        const currVal_63:any = i1.ɵnov(_v,44)._shouldForward('pending');
        _ck(_v,43,1,[currVal_53,currVal_54,currVal_55,currVal_56,currVal_57,currVal_58,
            currVal_59,currVal_60,currVal_61,currVal_62,currVal_63]);
        const currVal_65:any = i1.ɵnov(_v,58).ngClassUntouched;
        const currVal_66:any = i1.ɵnov(_v,58).ngClassTouched;
        const currVal_67:any = i1.ɵnov(_v,58).ngClassPristine;
        const currVal_68:any = i1.ɵnov(_v,58).ngClassDirty;
        const currVal_69:any = i1.ɵnov(_v,58).ngClassValid;
        const currVal_70:any = i1.ɵnov(_v,58).ngClassInvalid;
        const currVal_71:any = i1.ɵnov(_v,58).ngClassPending;
        const currVal_72:any = true;
        const currVal_73:any = i1.ɵnov(_v,59).id;
        const currVal_74:any = i1.ɵnov(_v,59).placeholder;
        const currVal_75:any = i1.ɵnov(_v,59).disabled;
        const currVal_76:any = i1.ɵnov(_v,59).required;
        const currVal_77:any = (i1.ɵnov(_v,59).ariaDescribedby || (null as any));
        _ck(_v,53,1,[currVal_65,currVal_66,currVal_67,currVal_68,currVal_69,currVal_70,
            currVal_71,currVal_72,currVal_73,currVal_74,currVal_75,currVal_76,currVal_77]);
        const currVal_80:any = (null as any);
        const currVal_81:any = true;
        const currVal_82:any = i1.ɵnov(_v,63)._isErrorState();
        const currVal_83:any = i1.ɵnov(_v,63)._mdInputChild.focused;
        const currVal_84:any = i1.ɵnov(_v,63)._shouldForward('untouched');
        const currVal_85:any = i1.ɵnov(_v,63)._shouldForward('touched');
        const currVal_86:any = i1.ɵnov(_v,63)._shouldForward('pristine');
        const currVal_87:any = i1.ɵnov(_v,63)._shouldForward('dirty');
        const currVal_88:any = i1.ɵnov(_v,63)._shouldForward('valid');
        const currVal_89:any = i1.ɵnov(_v,63)._shouldForward('invalid');
        const currVal_90:any = i1.ɵnov(_v,63)._shouldForward('pending');
        _ck(_v,62,1,[currVal_80,currVal_81,currVal_82,currVal_83,currVal_84,currVal_85,
            currVal_86,currVal_87,currVal_88,currVal_89,currVal_90]);
        const currVal_92:any = i1.ɵnov(_v,77).ngClassUntouched;
        const currVal_93:any = i1.ɵnov(_v,77).ngClassTouched;
        const currVal_94:any = i1.ɵnov(_v,77).ngClassPristine;
        const currVal_95:any = i1.ɵnov(_v,77).ngClassDirty;
        const currVal_96:any = i1.ɵnov(_v,77).ngClassValid;
        const currVal_97:any = i1.ɵnov(_v,77).ngClassInvalid;
        const currVal_98:any = i1.ɵnov(_v,77).ngClassPending;
        const currVal_99:any = true;
        const currVal_100:any = i1.ɵnov(_v,78).id;
        const currVal_101:any = i1.ɵnov(_v,78).placeholder;
        const currVal_102:any = i1.ɵnov(_v,78).disabled;
        const currVal_103:any = i1.ɵnov(_v,78).required;
        const currVal_104:any = (i1.ɵnov(_v,78).ariaDescribedby || (null as any));
        _ck(_v,72,1,[currVal_92,currVal_93,currVal_94,currVal_95,currVal_96,currVal_97,
            currVal_98,currVal_99,currVal_100,currVal_101,currVal_102,currVal_103,
            currVal_104]);
        const currVal_107:any = (i1.ɵnov(_v,86).disabled || (null as any));
        _ck(_v,84,0,currVal_107);
      });
}
function View_PoNewComponent_16(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'th',[['td-data-table-column',
      '']],[[2,'mat-clickable',(null as any)],[2,'mat-sortable',(null as any)],[2,
      'mat-active',(null as any)],[2,'mat-numeric',(null as any)]],(null as any),(null as any),
      i18.View_TdDataTableColumnComponent_0,i18.RenderType_TdDataTableColumnComponent)),
      i1.ɵdid(49152,(null as any),0,i19.TdDataTableColumnComponent,[i1.ElementRef,
          i1.Renderer2],{numeric:[0,'numeric']},(null as any)),(_l()(),i1.ɵted(0,['\n                                    ',
          '\n                                ']))],(_ck,_v) => {
    const currVal_4:any = _v.context.$implicit.numeric;
    _ck(_v,1,0,currVal_4);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,1).bindClickable;
    const currVal_1:any = i1.ɵnov(_v,1).bingSortable;
    const currVal_2:any = i1.ɵnov(_v,1).bindActive;
    const currVal_3:any = i1.ɵnov(_v,1).bindNumeric;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3);
    const currVal_5:any = _v.context.$implicit.label;
    _ck(_v,2,0,currVal_5);
  });
}
function View_PoNewComponent_18(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),7,'a',[['style',
      'cursor:pointer']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.removeItem((<any>_v.parent).context.$implicit)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n                                        '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),4,'md-icon',[['class','rotate45'],
          ['role','img']],[[2,'mat-icon',(null as any)]],(null as any),(null as any),
          i6.View_MdIcon_0,i6.RenderType_MdIcon)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
          [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(9027584,(null as any),0,i7.MdIcon,[i1.ElementRef,i1.Renderer2,i7.MdIconRegistry],
          (null as any),(null as any)),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,
          [i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
              i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted(0,
          ['add_circle'])),(_l()(),i1.ɵted((null as any),['\n                                    ']))],
      (_ck,_v) => {
        _ck(_v,4,0);
        const currVal_1:any = 'rotate45';
        _ck(_v,5,0,currVal_1);
      },(_ck,_v) => {
        const currVal_0:any = true;
        _ck(_v,2,0,currVal_0);
      });
}
function View_PoNewComponent_17(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),45,'tr',[['td-data-table-row',
      '']],(null as any),(null as any),(null as any),i20.View_TdDataTableRowComponent_0,
      i20.RenderType_TdDataTableRowComponent)),i1.ɵdid(49152,(null as any),0,i21.TdDataTableRowComponent,
      [i1.ElementRef,i1.Renderer2],(null as any),(null as any)),(_l()(),i1.ɵted(0,
      ['\n                                '])),(_l()(),i1.ɵted(0,['\n                                '])),
      (_l()(),i1.ɵeld(0,(null as any),0,2,'td',[['td-data-table-cell','']],[[2,'mat-numeric',
          (null as any)]],(null as any),(null as any),i22.View_TdDataTableCellComponent_0,
          i22.RenderType_TdDataTableCellComponent)),i1.ɵdid(49152,(null as any),0,
          i23.TdDataTableCellComponent,[i1.ElementRef,i1.Renderer2],(null as any),
          (null as any)),(_l()(),i1.ɵted(0,['',''])),(_l()(),i1.ɵted(0,['\n                                '])),
      (_l()(),i1.ɵeld(0,(null as any),0,2,'td',[['td-data-table-cell','']],[[2,'mat-numeric',
          (null as any)]],(null as any),(null as any),i22.View_TdDataTableCellComponent_0,
          i22.RenderType_TdDataTableCellComponent)),i1.ɵdid(49152,(null as any),0,
          i23.TdDataTableCellComponent,[i1.ElementRef,i1.Renderer2],(null as any),
          (null as any)),(_l()(),i1.ɵted(0,['','/',''])),(_l()(),i1.ɵted(0,['\n                                '])),
      (_l()(),i1.ɵeld(0,(null as any),0,2,'td',[['td-data-table-cell','']],[[2,'mat-numeric',
          (null as any)]],(null as any),(null as any),i22.View_TdDataTableCellComponent_0,
          i22.RenderType_TdDataTableCellComponent)),i1.ɵdid(49152,(null as any),0,
          i23.TdDataTableCellComponent,[i1.ElementRef,i1.Renderer2],(null as any),
          (null as any)),(_l()(),i1.ɵted(0,['',''])),(_l()(),i1.ɵted(0,['\n                                '])),
      (_l()(),i1.ɵeld(0,(null as any),0,2,'td',[['td-data-table-cell','']],[[2,'mat-numeric',
          (null as any)]],(null as any),(null as any),i22.View_TdDataTableCellComponent_0,
          i22.RenderType_TdDataTableCellComponent)),i1.ɵdid(49152,(null as any),0,
          i23.TdDataTableCellComponent,[i1.ElementRef,i1.Renderer2],(null as any),
          (null as any)),(_l()(),i1.ɵted(0,['','/',''])),(_l()(),i1.ɵted(0,['\n                                '])),
      (_l()(),i1.ɵeld(0,(null as any),0,6,'td',[['style','cursor:pointer'],['td-data-table-cell',
          '']],[[2,'mat-numeric',(null as any)]],[[(null as any),'click']],(_v,en,
          $event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.enterNewValueDialog(_v.context.$implicit,'quantity')) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i22.View_TdDataTableCellComponent_0,i22.RenderType_TdDataTableCellComponent)),
      i1.ɵdid(49152,(null as any),0,i23.TdDataTableCellComponent,[i1.ElementRef,i1.Renderer2],
          (null as any),(null as any)),(_l()(),i1.ɵted(0,['\n                                    '])),
      (_l()(),i1.ɵeld(0,(null as any),0,2,'span',([] as any[]),(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['',' ',''])),i1.ɵppd(2),(_l()(),i1.ɵted(0,['\n                                '])),
      (_l()(),i1.ɵted(0,['\n                                '])),(_l()(),i1.ɵted(0,
          ['\n                                '])),(_l()(),i1.ɵeld(0,(null as any),
          0,3,'td',[['td-data-table-cell','']],[[2,'mat-numeric',(null as any)]],(null as any),
          (null as any),i22.View_TdDataTableCellComponent_0,i22.RenderType_TdDataTableCellComponent)),
      i1.ɵdid(49152,(null as any),0,i23.TdDataTableCellComponent,[i1.ElementRef,i1.Renderer2],
          (null as any),(null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(3),(_l()(),
          i1.ɵted(0,['\n                                '])),(_l()(),i1.ɵeld(0,(null as any),
          0,3,'td',[['td-data-table-cell','']],[[2,'mat-numeric',(null as any)]],(null as any),
          (null as any),i22.View_TdDataTableCellComponent_0,i22.RenderType_TdDataTableCellComponent)),
      i1.ɵdid(49152,(null as any),0,i23.TdDataTableCellComponent,[i1.ElementRef,i1.Renderer2],
          (null as any),(null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(3),(_l()(),
          i1.ɵted(0,['\n                                '])),(_l()(),i1.ɵeld(0,(null as any),
          0,5,'td',[['td-data-table-cell','']],[[2,'mat-numeric',(null as any)]],(null as any),
          (null as any),i22.View_TdDataTableCellComponent_0,i22.RenderType_TdDataTableCellComponent)),
      i1.ɵdid(49152,(null as any),0,i23.TdDataTableCellComponent,[i1.ElementRef,i1.Renderer2],
          (null as any),(null as any)),(_l()(),i1.ɵted(0,['\n                                    '])),
      (_l()(),i1.ɵand(16777216,(null as any),0,1,(null as any),View_PoNewComponent_18)),
      i1.ɵdid(16384,(null as any),0,i15.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(0,['\n                                '])),
      (_l()(),i1.ɵted(0,['\n                            ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_18:boolean = (!_co.isReceived() && !_co._authService.isViewer());
    _ck(_v,43,0,currVal_18);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = i1.ɵnov(_v,5).bindNumeric;
    _ck(_v,4,0,currVal_0);
    const currVal_1:any = _v.context.$implicit['collection_name'];
    _ck(_v,6,0,currVal_1);
    const currVal_2:any = i1.ɵnov(_v,9).bindNumeric;
    _ck(_v,8,0,currVal_2);
    const currVal_3:any = _v.context.$implicit['design_name'];
    const currVal_4:any = _v.context.$implicit['color_name'];
    _ck(_v,10,0,currVal_3,currVal_4);
    const currVal_5:any = i1.ɵnov(_v,13).bindNumeric;
    _ck(_v,12,0,currVal_5);
    const currVal_6:any = _v.context.$implicit['mystic_collection_name'];
    _ck(_v,14,0,currVal_6);
    const currVal_7:any = i1.ɵnov(_v,17).bindNumeric;
    _ck(_v,16,0,currVal_7);
    const currVal_8:any = _v.context.$implicit['mystic_design_name'];
    const currVal_9:any = _v.context.$implicit['mystic_color_name'];
    _ck(_v,18,0,currVal_8,currVal_9);
    const currVal_10:any = i1.ɵnov(_v,21).bindNumeric;
    _ck(_v,20,0,currVal_10);
    const currVal_11:any = i1.ɵunv(_v,24,0,_ck(_v,25,0,i1.ɵnov((<any>(<any>_v.parent).parent),
        1),_v.context.$implicit['quantity'],'1.2-2'));
    const currVal_12:any = _co.getUnitSymbol(_v.context.$implicit.unit_type);
    _ck(_v,24,0,currVal_11,currVal_12);
    const currVal_13:any = i1.ɵnov(_v,30).bindNumeric;
    _ck(_v,29,0,currVal_13);
    const currVal_14:any = i1.ɵunv(_v,31,0,_ck(_v,32,0,i1.ɵnov((<any>(<any>_v.parent).parent),
        2),_v.context.$implicit['unit_price'],_co._this_PO_currency,true));
    _ck(_v,31,0,currVal_14);
    const currVal_15:any = i1.ɵnov(_v,35).bindNumeric;
    _ck(_v,34,0,currVal_15);
    const currVal_16:any = i1.ɵunv(_v,36,0,_ck(_v,37,0,i1.ɵnov((<any>(<any>_v.parent).parent),
        2),(_v.context.$implicit['quantity'] * _v.context.$implicit['unit_price']),
        _co._this_PO_currency,true));
    _ck(_v,36,0,currVal_16);
    const currVal_17:any = i1.ɵnov(_v,40).bindNumeric;
    _ck(_v,39,0,currVal_17);
  });
}
function View_PoNewComponent_19(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted((null as any),['','']))],(null as any),(_ck,_v) => {
    const currVal_0:any = i1.ɵnov((<any>_v.parent),80).range;
    _ck(_v,1,0,currVal_0);
  });
}
function View_PoNewComponent_20(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'span',[['hide-xs',
      '']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['of']))],(null as any),(null as any));
}
function View_PoNewComponent_21(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted((null as any),['All ']))],(null as any),(null as any));
}
function View_PoNewComponent_22(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),6,'button',[['class',
      'bg-blue color-white mat-button'],['color','primary'],['md-button','']],[[8,
      'disabled',0]],[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.createPo()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },i6.View_MdButton_0,i6.RenderType_MdButton)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(180224,(null as any),0,i7.MdButton,[i1.ElementRef,i1.Renderer2,i7.Platform,
          i7.FocusOriginMonitor],{disabled:[0,'disabled'],color:[1,'color']},(null as any)),
      i1.ɵdid(16384,(null as any),0,i7.MdButtonCssMatStyler,([] as any[]),(null as any),
          (null as any)),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i3.MediaMonitor,
          i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],
          {classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2)],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_1:any = _co.saving;
        const currVal_2:any = 'primary';
        _ck(_v,2,0,currVal_1,currVal_2);
        const currVal_3:any = 'bg-blue color-white';
        _ck(_v,4,0,currVal_3);
      },(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = (i1.ɵnov(_v,2).disabled || (null as any));
        _ck(_v,0,0,currVal_0);
        const currVal_4:any = i1.ɵunv(_v,5,0,_ck(_v,6,0,i1.ɵnov((<any>(<any>_v.parent).parent),
            0),'create',_co._authService.getLanguage()));
        _ck(_v,5,0,currVal_4);
      });
}
function View_PoNewComponent_23(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),6,'button',[['class',
      'bg-blue color-white mat-button'],['color','primary'],['md-button','']],[[8,
      'disabled',0]],[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.savePo()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },i6.View_MdButton_0,i6.RenderType_MdButton)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(180224,(null as any),0,i7.MdButton,[i1.ElementRef,i1.Renderer2,i7.Platform,
          i7.FocusOriginMonitor],{disabled:[0,'disabled'],color:[1,'color']},(null as any)),
      i1.ɵdid(16384,(null as any),0,i7.MdButtonCssMatStyler,([] as any[]),(null as any),
          (null as any)),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i3.MediaMonitor,
          i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],
          {classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2)],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_1:any = _co.saving;
        const currVal_2:any = 'primary';
        _ck(_v,2,0,currVal_1,currVal_2);
        const currVal_3:any = 'bg-blue color-white';
        _ck(_v,4,0,currVal_3);
      },(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = (i1.ɵnov(_v,2).disabled || (null as any));
        _ck(_v,0,0,currVal_0);
        const currVal_4:any = i1.ɵunv(_v,5,0,_ck(_v,6,0,i1.ɵnov((<any>(<any>_v.parent).parent),
            0),'save',_co._authService.getLanguage()));
        _ck(_v,5,0,currVal_4);
      });
}
function View_PoNewComponent_13(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),135,'md-card-content',
      [['fxLayout','column']],[[2,'mat-card-content',(null as any)]],(null as any),
      (null as any),(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
      [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(16384,(null as any),0,i7.MdCardContent,([] as any[]),(null as any),(null as any)),
      i1.ɵdid(737280,(null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2],{layout:[0,'layout']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n                '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),
          1,(null as any),View_PoNewComponent_14)),i1.ɵdid(16384,(null as any),0,i15.NgIf,
          [i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),
          i1.ɵted((null as any),['\n\n                '])),(_l()(),i1.ɵted((null as any),
          ['\n                '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),64,
          'div',[['class','mat-table-container tmp-driven-table'],['layout','column']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),['\n                    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),60,'table',[['class','duplicated-thead-fix'],
          ['td-data-table','']],(null as any),(null as any),(null as any),i24.View_TdDataTableTableComponent_0,
          i24.RenderType_TdDataTableTableComponent)),i1.ɵdid(49152,(null as any),0,
          i25.TdDataTableTableComponent,[i1.ElementRef,i1.Renderer2],(null as any),
          (null as any)),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i3.MediaMonitor,
          i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],
          {classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,15,'thead',([] as any[]),(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['\n                            '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          12,'tr',[['td-data-table-column-row','']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n                                '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PoNewComponent_16)),
      i1.ɵdid(802816,(null as any),0,i15.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n                                '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),3,'th',[['td-data-table-column','']],[[2,'mat-clickable',(null as any)],
              [2,'mat-sortable',(null as any)],[2,'mat-active',(null as any)],[2,'mat-numeric',
                  (null as any)]],(null as any),(null as any),i18.View_TdDataTableColumnComponent_0,
          i18.RenderType_TdDataTableColumnComponent)),i1.ɵdid(49152,(null as any),
          0,i19.TdDataTableColumnComponent,[i1.ElementRef,i1.Renderer2],(null as any),
          (null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2),(_l()(),i1.ɵted((null as any),
          ['\n                                '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),1,'th',[['td-data-table-column','']],[[2,'mat-clickable',(null as any)],
              [2,'mat-sortable',(null as any)],[2,'mat-active',(null as any)],[2,'mat-numeric',
                  (null as any)]],(null as any),(null as any),i18.View_TdDataTableColumnComponent_0,
          i18.RenderType_TdDataTableColumnComponent)),i1.ɵdid(49152,(null as any),
          0,i19.TdDataTableColumnComponent,[i1.ElementRef,i1.Renderer2],(null as any),
          (null as any)),(_l()(),i1.ɵted((null as any),['\n                            '])),
      (_l()(),i1.ɵted((null as any),['\n                        '])),(_l()(),i1.ɵted(1,
          ['\n                        '])),(_l()(),i1.ɵeld(0,(null as any),1,38,'tbody',
          ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n                            '])),(_l()(),i1.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_PoNewComponent_17)),i1.ɵdid(802816,
          (null as any),0,i15.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,i1.IterableDiffers],
          {ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n                            '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),32,'tr',[['class','total-row no-border default'],
          ['td-data-table-column-row','']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,
          [i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
              i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n                                '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),3,'td',[['td-data-table-cell','']],[[2,'mat-numeric',(null as any)]],
          (null as any),(null as any),i22.View_TdDataTableCellComponent_0,i22.RenderType_TdDataTableCellComponent)),
      i1.ɵdid(49152,(null as any),0,i23.TdDataTableCellComponent,[i1.ElementRef,i1.Renderer2],
          (null as any),(null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2),(_l()(),
          i1.ɵted((null as any),['\n                                '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),1,'td',[['td-data-table-cell','']],[[2,'mat-numeric',
              (null as any)]],(null as any),(null as any),i22.View_TdDataTableCellComponent_0,
          i22.RenderType_TdDataTableCellComponent)),i1.ɵdid(49152,(null as any),0,
          i23.TdDataTableCellComponent,[i1.ElementRef,i1.Renderer2],(null as any),
          (null as any)),(_l()(),i1.ɵted((null as any),['\n                                '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),1,'td',[['td-data-table-cell',
          '']],[[2,'mat-numeric',(null as any)]],(null as any),(null as any),i22.View_TdDataTableCellComponent_0,
          i22.RenderType_TdDataTableCellComponent)),i1.ɵdid(49152,(null as any),0,
          i23.TdDataTableCellComponent,[i1.ElementRef,i1.Renderer2],(null as any),
          (null as any)),(_l()(),i1.ɵted((null as any),['\n                                '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),1,'td',[['td-data-table-cell',
          '']],[[2,'mat-numeric',(null as any)]],(null as any),(null as any),i22.View_TdDataTableCellComponent_0,
          i22.RenderType_TdDataTableCellComponent)),i1.ɵdid(49152,(null as any),0,
          i23.TdDataTableCellComponent,[i1.ElementRef,i1.Renderer2],(null as any),
          (null as any)),(_l()(),i1.ɵted((null as any),['\n                                '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),3,'td',[['td-data-table-cell',
          '']],[[2,'mat-numeric',(null as any)]],(null as any),(null as any),i22.View_TdDataTableCellComponent_0,
          i22.RenderType_TdDataTableCellComponent)),i1.ɵdid(49152,(null as any),0,
          i23.TdDataTableCellComponent,[i1.ElementRef,i1.Renderer2],(null as any),
          (null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2),(_l()(),i1.ɵted((null as any),
          ['\n                                '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),1,'td',[['td-data-table-cell','']],[[2,'mat-numeric',(null as any)]],
          (null as any),(null as any),i22.View_TdDataTableCellComponent_0,i22.RenderType_TdDataTableCellComponent)),
      i1.ɵdid(49152,(null as any),0,i23.TdDataTableCellComponent,[i1.ElementRef,i1.Renderer2],
          (null as any),(null as any)),(_l()(),i1.ɵted((null as any),['\n                                '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),3,'td',[['td-data-table-cell',
          '']],[[2,'mat-numeric',(null as any)]],(null as any),(null as any),i22.View_TdDataTableCellComponent_0,
          i22.RenderType_TdDataTableCellComponent)),i1.ɵdid(49152,(null as any),0,
          i23.TdDataTableCellComponent,[i1.ElementRef,i1.Renderer2],(null as any),
          (null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(3),(_l()(),i1.ɵted((null as any),
          ['\n                                '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),1,'td',[['td-data-table-cell','']],[[2,'mat-numeric',(null as any)]],
          (null as any),(null as any),i22.View_TdDataTableCellComponent_0,i22.RenderType_TdDataTableCellComponent)),
      i1.ɵdid(49152,(null as any),0,i23.TdDataTableCellComponent,[i1.ElementRef,i1.Renderer2],
          (null as any),(null as any)),(_l()(),i1.ɵted((null as any),['\n                            '])),
      (_l()(),i1.ɵted((null as any),['\n                        '])),(_l()(),i1.ɵted(1,
          ['\n                    '])),(_l()(),i1.ɵted((null as any),['\n                '])),
      (_l()(),i1.ɵted((null as any),['\n                '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),25,'div',[['fxLayout','row'],['fxLayout.lt-md','column']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(737280,(null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2],{layout:[0,'layout'],layoutLtMd:[1,'layoutLtMd']},(null as any)),
      (_l()(),i1.ɵted((null as any),['\n                    '])),(_l()(),i1.ɵted((null as any),
          ['\n\n                    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          20,'td-paging-bar',[['fxFlex',''],['fxFlexAlign','end'],['fxFlexAlign.lt-md',
              'center'],['md-pull-right','']],(null as any),[[(null as any),'change']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('change' === en)) {
              const pd_0:any = ((<any>_co.page($event)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i26.View_TdPagingBarComponent_0,i26.RenderType_TdPagingBarComponent)),
      i1.ɵdid(114688,[['pagingBar',4]],0,i27.TdPagingBarComponent,[[2,i7.Dir]],{pageSizes:[0,
          'pageSizes'],pageSize:[1,'pageSize'],total:[2,'total']},{onChange:'change'}),
      i1.ɵpad(5),i1.ɵdid(737280,(null as any),0,i13.FlexDirective,[i3.MediaMonitor,
          i1.ElementRef,i1.Renderer2,[3,i2.LayoutDirective],[3,i14.LayoutWrapDirective]],
          {flex:[0,'flex']},(null as any)),i1.ɵdid(737280,(null as any),0,i28.FlexAlignDirective,
          [i3.MediaMonitor,i1.ElementRef,i1.Renderer2],{align:[0,'align'],alignLtMd:[1,
              'alignLtMd']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),0,1,'span',[['hide-xs',''],['td-paging-bar-label',
          '']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['Row per page:'])),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵand(16777216,(null as any),1,1,(null as any),View_PoNewComponent_19)),
      i1.ɵdid(16384,(null as any),0,i15.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵand(16777216,(null as any),1,1,(null as any),View_PoNewComponent_20)),
      i1.ɵdid(16384,(null as any),0,i15.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵand(16777216,(null as any),1,1,(null as any),View_PoNewComponent_21)),
      i1.ɵdid(16384,(null as any),0,i15.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(1,['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,1,'span',[['hide-xs','']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['',' items'])),(_l()(),i1.ɵted(1,['\n                    '])),(_l()(),i1.ɵted((null as any),
          ['\n                '])),(_l()(),i1.ɵted((null as any),['\n\n                '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),32,'md-card-actions',([] as any[]),
          [[2,'mat-card-actions',(null as any)]],(null as any),(null as any),(null as any),
          (null as any))),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(16384,(null as any),
          0,i7.MdCardActions,([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n                    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          27,'div',[['class','table-control-buttons'],['fxFlex',''],['fxFlexAlign',
              'start'],['fxFlexAlign.lt-md','center'],['fxLayoutGap','12px']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(1720320,
          (null as any),0,i4.LayoutGapDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2,
              [8,(null as any)]],{gap:[0,'gap']},(null as any)),i1.ɵdid(737280,(null as any),
          0,i13.FlexDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2,[3,i2.LayoutDirective],
              [3,i14.LayoutWrapDirective]],{flex:[0,'flex']},(null as any)),i1.ɵdid(737280,
          (null as any),0,i28.FlexAlignDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2],
          {align:[0,'align'],alignLtMd:[1,'alignLtMd']},(null as any)),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n                        '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PoNewComponent_22)),
      i1.ɵdid(16384,(null as any),0,i15.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n                        '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PoNewComponent_23)),
      i1.ɵdid(16384,(null as any),0,i15.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n                        '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),6,'button',[['class','bg-blue color-white mat-button'],
          ['color','primary'],['md-button','']],[[8,'disabled',0]],[[(null as any),
          'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.printPO()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i6.View_MdButton_0,i6.RenderType_MdButton)),i1.ɵdid(16384,(null as any),0,
          i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),
          (null as any)),i1.ɵdid(180224,(null as any),0,i7.MdButton,[i1.ElementRef,
          i1.Renderer2,i7.Platform,i7.FocusOriginMonitor],{color:[0,'color']},(null as any)),
      i1.ɵdid(16384,(null as any),0,i7.MdButtonCssMatStyler,([] as any[]),(null as any),
          (null as any)),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i3.MediaMonitor,
          i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],
          {classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2),
      (_l()(),i1.ɵted((null as any),['\n                        '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),6,'button',[['class','bg-red color-white mat-button'],
              ['color','warn'],['md-button','']],[[8,'disabled',0]],[[(null as any),
              'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.goBack()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_MdButton_0,i6.RenderType_MdButton)),i1.ɵdid(16384,(null as any),
          0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(180224,(null as any),0,i7.MdButton,
          [i1.ElementRef,i1.Renderer2,i7.Platform,i7.FocusOriginMonitor],{color:[0,
              'color']},(null as any)),i1.ɵdid(16384,(null as any),0,i7.MdButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,(null as any),
          0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2),(_l()(),i1.ɵted((null as any),
          ['\n                    '])),(_l()(),i1.ɵted((null as any),['\n                '])),
      (_l()(),i1.ɵted((null as any),['\n            ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = 'column';
    _ck(_v,3,0,currVal_1);
    const currVal_2:boolean = (!_co.isReceived() && !_co._authService.isViewer());
    _ck(_v,6,0,currVal_2);
    const currVal_3:any = 'mat-table-container tmp-driven-table';
    _ck(_v,10,0,currVal_3);
    const currVal_4:any = 'duplicated-thead-fix';
    _ck(_v,14,0,currVal_4);
    const currVal_5:any = _co.columns;
    _ck(_v,21,0,currVal_5);
    const currVal_15:any = _co.filteredData;
    _ck(_v,36,0,currVal_15);
    const currVal_16:any = 'total-row no-border default';
    _ck(_v,39,0,currVal_16);
    const currVal_28:any = 'row';
    const currVal_29:any = 'column';
    _ck(_v,76,0,currVal_28,currVal_29);
    const currVal_30:any = _ck(_v,81,0,10,50,100,1000,'All');
    const currVal_31:any = _co._settingsService.getPageSize();
    const currVal_32:any = _co.filteredTotal;
    _ck(_v,80,0,currVal_30,currVal_31,currVal_32);
    const currVal_33:any = '';
    _ck(_v,82,0,currVal_33);
    const currVal_34:any = 'end';
    const currVal_35:any = 'center';
    _ck(_v,83,0,currVal_34,currVal_35);
    const currVal_36:any = (i1.ɵnov(_v,80).pageSize != 'All');
    _ck(_v,89,0,currVal_36);
    const currVal_37:any = (i1.ɵnov(_v,80).pageSize != 'All');
    _ck(_v,92,0,currVal_37);
    const currVal_38:any = (i1.ɵnov(_v,80).pageSize == 'All');
    _ck(_v,95,0,currVal_38);
    const currVal_41:any = '12px';
    _ck(_v,107,0,currVal_41);
    const currVal_42:any = '';
    _ck(_v,108,0,currVal_42);
    const currVal_43:any = 'start';
    const currVal_44:any = 'center';
    _ck(_v,109,0,currVal_43,currVal_44);
    const currVal_45:any = 'table-control-buttons';
    _ck(_v,110,0,currVal_45);
    const currVal_46:boolean = (!_co.isEditMode && !_co._authService.isViewer());
    _ck(_v,113,0,currVal_46);
    const currVal_47:any = (_co.isEditMode && !_co._authService.isViewer());
    _ck(_v,116,0,currVal_47);
    const currVal_49:any = 'primary';
    _ck(_v,120,0,currVal_49);
    const currVal_50:any = 'bg-blue color-white';
    _ck(_v,122,0,currVal_50);
    const currVal_53:any = 'warn';
    _ck(_v,128,0,currVal_53);
    const currVal_54:any = 'bg-red color-white';
    _ck(_v,130,0,currVal_54);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = true;
    _ck(_v,0,0,currVal_0);
    const currVal_6:any = i1.ɵnov(_v,24).bindClickable;
    const currVal_7:any = i1.ɵnov(_v,24).bingSortable;
    const currVal_8:any = i1.ɵnov(_v,24).bindActive;
    const currVal_9:any = i1.ɵnov(_v,24).bindNumeric;
    _ck(_v,23,0,currVal_6,currVal_7,currVal_8,currVal_9);
    const currVal_10:any = i1.ɵunv(_v,25,0,_ck(_v,26,0,i1.ɵnov((<any>_v.parent),0),
        'total',_co._authService.getLanguage()));
    _ck(_v,25,0,currVal_10);
    const currVal_11:any = i1.ɵnov(_v,29).bindClickable;
    const currVal_12:any = i1.ɵnov(_v,29).bingSortable;
    const currVal_13:any = i1.ɵnov(_v,29).bindActive;
    const currVal_14:any = i1.ɵnov(_v,29).bindNumeric;
    _ck(_v,28,0,currVal_11,currVal_12,currVal_13,currVal_14);
    const currVal_17:any = i1.ɵnov(_v,42).bindNumeric;
    _ck(_v,41,0,currVal_17);
    const currVal_18:any = i1.ɵunv(_v,43,0,_ck(_v,44,0,i1.ɵnov((<any>_v.parent),0),
        'total',_co._authService.getLanguage()));
    _ck(_v,43,0,currVal_18);
    const currVal_19:any = i1.ɵnov(_v,47).bindNumeric;
    _ck(_v,46,0,currVal_19);
    const currVal_20:any = i1.ɵnov(_v,50).bindNumeric;
    _ck(_v,49,0,currVal_20);
    const currVal_21:any = i1.ɵnov(_v,53).bindNumeric;
    _ck(_v,52,0,currVal_21);
    const currVal_22:any = i1.ɵnov(_v,56).bindNumeric;
    _ck(_v,55,0,currVal_22);
    const currVal_23:any = i1.ɵunv(_v,57,0,_ck(_v,58,0,i1.ɵnov((<any>_v.parent),1),
        _co.getTotalMeters(),'1.2-2'));
    _ck(_v,57,0,currVal_23);
    const currVal_24:any = i1.ɵnov(_v,61).bindNumeric;
    _ck(_v,60,0,currVal_24);
    const currVal_25:any = i1.ɵnov(_v,64).bindNumeric;
    _ck(_v,63,0,currVal_25);
    const currVal_26:any = i1.ɵunv(_v,65,0,_ck(_v,66,0,i1.ɵnov((<any>_v.parent),2),
        _co.getTotalValue(),_co._this_PO_currency,true));
    _ck(_v,65,0,currVal_26);
    const currVal_27:any = i1.ɵnov(_v,69).bindNumeric;
    _ck(_v,68,0,currVal_27);
    const currVal_39:any = i1.ɵnov(_v,80).total;
    _ck(_v,98,0,currVal_39);
    const currVal_40:any = true;
    _ck(_v,102,0,currVal_40);
    const currVal_48:any = (i1.ɵnov(_v,120).disabled || (null as any));
    _ck(_v,118,0,currVal_48);
    const currVal_51:any = i1.ɵunv(_v,123,0,_ck(_v,124,0,i1.ɵnov((<any>_v.parent),
        0),'print_po',_co._authService.getLanguage()));
    _ck(_v,123,0,currVal_51);
    const currVal_52:any = (i1.ɵnov(_v,128).disabled || (null as any));
    _ck(_v,126,0,currVal_52);
    const currVal_55:any = i1.ɵunv(_v,131,0,_ck(_v,132,0,i1.ɵnov((<any>_v.parent),
        0),'back',_co._authService.getLanguage()));
    _ck(_v,131,0,currVal_55);
  });
}
export function View_PoNewComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵpid(0,i29.TranslatePipe,([] as any[])),i1.ɵpid(0,i15.DecimalPipe,
      [i1.LOCALE_ID]),i1.ɵpid(0,i15.CurrencyPipe,[i1.LOCALE_ID]),(_l()(),i1.ɵeld(0,
      (null as any),(null as any),75,'div',[['fxLayout','column']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),i1.ɵdid(737280,(null as any),0,i2.LayoutDirective,
      [i3.MediaMonitor,i1.ElementRef,i1.Renderer2],{layout:[0,'layout']},(null as any)),
      (_l()(),i1.ɵted((null as any),['\n    \n\n    '])),(_l()(),i1.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_PoNewComponent_1)),i1.ɵdid(16384,
          (null as any),0,i15.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n\n    '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),68,'div',[['class','boxed-content-wrapper cards-no-gaps']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,
          i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,
          'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),['\n        '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PoNewComponent_2)),
      i1.ɵdid(212992,(null as any),0,i30.TdLoadingDirective,[i1.ViewContainerRef,i1.TemplateRef,
          i31.TdLoadingService],{name:[0,'name'],type:[1,'type'],mode:[2,'mode'],strategy:[3,
          'strategy'],color:[4,'color']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),19,'md-card',
          ([] as any[]),[[2,'mat-card',(null as any)]],(null as any),(null as any),
          i6.View_MdCard_0,i6.RenderType_MdCard)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
          [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(49152,(null as any),0,i7.MdCard,([] as any[]),(null as any),(null as any)),
      (_l()(),i1.ɵted(0,['\n            '])),(_l()(),i1.ɵeld(0,(null as any),0,11,
          'md-card-header',[['fxLayout','column']],[[2,'mat-card-header',(null as any)]],
          (null as any),(null as any),i6.View_MdCardHeader_0,i6.RenderType_MdCardHeader)),
      i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(49152,(null as any),
          0,i7.MdCardHeader,([] as any[]),(null as any),(null as any)),i1.ɵdid(737280,
          (null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,i1.Renderer2],
          {layout:[0,'layout']},(null as any)),(_l()(),i1.ɵted(2,['\n                '])),
      (_l()(),i1.ɵeld(0,(null as any),1,5,'md-card-subtitle',[['class','bg-grey color-white text-only']],
          [[2,'mat-card-subtitle',(null as any)]],(null as any),(null as any),(null as any),
          (null as any))),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(16384,(null as any),
          0,i7.MdCardSubtitle,([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['','\n                '])),
      i1.ɵppd(2),(_l()(),i1.ɵted(2,['\n            '])),(_l()(),i1.ɵted(0,['\n            '])),
      (_l()(),i1.ɵand(16777216,(null as any),0,1,(null as any),View_PoNewComponent_9)),
      i1.ɵdid(16384,(null as any),0,i15.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(0,['\n        '])),(_l()(),
          i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          19,'md-card',([] as any[]),[[2,'mat-card',(null as any)]],(null as any),
          (null as any),i6.View_MdCard_0,i6.RenderType_MdCard)),i1.ɵdid(16384,(null as any),
          0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(49152,(null as any),0,i7.MdCard,([] as any[]),
          (null as any),(null as any)),(_l()(),i1.ɵted(0,['\n            '])),(_l()(),
          i1.ɵeld(0,(null as any),0,11,'md-card-header',[['fxLayout','column']],[[2,
              'mat-card-header',(null as any)]],(null as any),(null as any),i6.View_MdCardHeader_0,
              i6.RenderType_MdCardHeader)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
          [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(49152,(null as any),0,i7.MdCardHeader,([] as any[]),(null as any),(null as any)),
      i1.ɵdid(737280,(null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2],{layout:[0,'layout']},(null as any)),(_l()(),i1.ɵted(2,['\n                '])),
      (_l()(),i1.ɵeld(0,(null as any),1,5,'md-card-subtitle',[['class','bg-grey color-white text-only']],
          [[2,'mat-card-subtitle',(null as any)]],(null as any),(null as any),(null as any),
          (null as any))),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(16384,(null as any),
          0,i7.MdCardSubtitle,([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['',''])),i1.ɵppd(2),(_l()(),
          i1.ɵted(2,['\n            '])),(_l()(),i1.ɵted(0,['\n            '])),(_l()(),
          i1.ɵand(16777216,(null as any),0,1,(null as any),View_PoNewComponent_11)),
      i1.ɵdid(16384,(null as any),0,i15.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(0,['\n        '])),(_l()(),
          i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          19,'md-card',([] as any[]),[[2,'mat-card',(null as any)]],(null as any),
          (null as any),i6.View_MdCard_0,i6.RenderType_MdCard)),i1.ɵdid(16384,(null as any),
          0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(49152,(null as any),0,i7.MdCard,([] as any[]),
          (null as any),(null as any)),(_l()(),i1.ɵted(0,['\n            '])),(_l()(),
          i1.ɵeld(0,(null as any),0,11,'md-card-header',[['fxLayout','column']],[[2,
              'mat-card-header',(null as any)]],(null as any),(null as any),i6.View_MdCardHeader_0,
              i6.RenderType_MdCardHeader)),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,
          [[2,i7.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(49152,(null as any),0,i7.MdCardHeader,([] as any[]),(null as any),(null as any)),
      i1.ɵdid(737280,(null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2],{layout:[0,'layout']},(null as any)),(_l()(),i1.ɵted(2,['\n                '])),
      (_l()(),i1.ɵeld(0,(null as any),1,5,'md-card-subtitle',[['class','bg-grey color-white text-only']],
          [[2,'mat-card-subtitle',(null as any)]],(null as any),(null as any),(null as any),
          (null as any))),i1.ɵdid(16384,(null as any),0,i7.MdPrefixRejector,[[2,i7.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(16384,(null as any),
          0,i7.MdCardSubtitle,([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['',''])),i1.ɵppd(2),(_l()(),
          i1.ɵted(2,['\n            '])),(_l()(),i1.ɵted(0,['\n            '])),(_l()(),
          i1.ɵand(16777216,(null as any),0,1,(null as any),View_PoNewComponent_13)),
      i1.ɵdid(16384,(null as any),0,i15.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(0,['\n        '])),(_l()(),
          i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵted((null as any),['\n']))],
      (_ck,_v) => {
        var _co:i32.PoNewComponent = _v.component;
        const currVal_0:any = 'column';
        _ck(_v,4,0,currVal_0);
        const currVal_1:any = _co.changed();
        _ck(_v,7,0,currVal_1);
        const currVal_2:any = 'boxed-content-wrapper cards-no-gaps';
        _ck(_v,10,0,currVal_2);
        const currVal_3:any = 'loading';
        const currVal_4:any = 'circle';
        const currVal_5:any = 'indeterminate';
        const currVal_6:any = 'overlay';
        const currVal_7:any = 'accent';
        _ck(_v,13,0,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
        const currVal_10:any = 'column';
        _ck(_v,22,0,currVal_10);
        const currVal_12:any = 'bg-grey color-white text-only';
        _ck(_v,27,0,currVal_12);
        const currVal_14:any = _co.currentPo;
        _ck(_v,33,0,currVal_14);
        const currVal_17:any = 'column';
        _ck(_v,43,0,currVal_17);
        const currVal_19:any = 'bg-grey color-white text-only';
        _ck(_v,48,0,currVal_19);
        const currVal_21:any = _co.currentPo;
        _ck(_v,54,0,currVal_21);
        const currVal_24:any = 'column';
        _ck(_v,64,0,currVal_24);
        const currVal_26:any = 'bg-grey color-white text-only';
        _ck(_v,69,0,currVal_26);
        const currVal_28:any = _co.currentPo;
        _ck(_v,75,0,currVal_28);
      },(_ck,_v) => {
        var _co:i32.PoNewComponent = _v.component;
        const currVal_8:any = true;
        _ck(_v,15,0,currVal_8);
        const currVal_9:any = true;
        _ck(_v,19,0,currVal_9);
        const currVal_11:any = true;
        _ck(_v,24,0,currVal_11);
        const currVal_13:any = i1.ɵunv(_v,28,0,_ck(_v,29,0,i1.ɵnov(_v,0),'invoice_and_payment_details',
            _co._authService.getLanguage()));
        _ck(_v,28,0,currVal_13);
        const currVal_15:any = true;
        _ck(_v,36,0,currVal_15);
        const currVal_16:any = true;
        _ck(_v,40,0,currVal_16);
        const currVal_18:any = true;
        _ck(_v,45,0,currVal_18);
        const currVal_20:any = i1.ɵunv(_v,49,0,_ck(_v,50,0,i1.ɵnov(_v,0),'shipping_details',
            _co._authService.getLanguage()));
        _ck(_v,49,0,currVal_20);
        const currVal_22:any = true;
        _ck(_v,57,0,currVal_22);
        const currVal_23:any = true;
        _ck(_v,61,0,currVal_23);
        const currVal_25:any = true;
        _ck(_v,66,0,currVal_25);
        const currVal_27:any = i1.ɵunv(_v,70,0,_ck(_v,71,0,i1.ɵnov(_v,0),'po_items',
            _co._authService.getLanguage()));
        _ck(_v,70,0,currVal_27);
      });
}
export function View_PoNewComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(16777216,(null as any),(null as any),4,'app-po-new',
      ([] as any[]),(null as any),(null as any),(null as any),View_PoNewComponent_0,
      RenderType_PoNewComponent)),i1.ɵprd(512,(null as any),i33.CollectionService,
      i33.CollectionService,[i34.Http,i35.Configuration,i36.AuthenticationService]),
      i1.ɵprd(512,(null as any),i37.CurrencyService,i37.CurrencyService,([] as any[])),
      i1.ɵprd(512,(null as any),i38.ReportService,i38.ReportService,[i34.Http,i35.Configuration,
          i36.AuthenticationService]),i1.ɵdid(114688,(null as any),0,i32.PoNewComponent,
          [i39.PoService,i40.TdDialogService,i1.ViewContainerRef,i16.ActivatedRoute,
              i31.TdLoadingService,i41.ReceivingService,i42.BranchService,i33.CollectionService,
              i43.SettingsService,i44.SupplierService,i16.Router,i37.CurrencyService,
              i15.Location,i38.ReportService,i45.TdDataTableService,i36.AuthenticationService],
          (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,4,0);
  },(null as any));
}
export const PoNewComponentNgFactory:i1.ComponentFactory<i32.PoNewComponent> = i1.ɵccf('app-po-new',
    i32.PoNewComponent,View_PoNewComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/$$_gendir/app/agatextscreens/purchasing/pos/po-new/po-new.component.ngfactory.ts